import React, { useEffect, useMemo, useCallback, useState, useRef } from 'react';
import { Drawer, Form, Input, InputNumber, Select, Card, Button, Space, Tag, message, Alert, Table, Modal, Radio, Checkbox, Tabs, Divider, Switch, AutoComplete } from 'antd';
import {
  MinusCircleOutlined, PlusOutlined, SettingOutlined, FormOutlined, EditOutlined, DeleteOutlined,
  MessageOutlined, FileTextOutlined, BellOutlined, FullscreenOutlined, FullscreenExitOutlined,
  ClockCircleOutlined, CloseOutlined,
  UserOutlined, RobotOutlined, SafetyOutlined, BranchesOutlined, AuditOutlined,
  ShoppingCartOutlined, ThunderboltOutlined, DatabaseOutlined, MailOutlined,
  EnvironmentOutlined, InfoCircleOutlined, ApiOutlined, FilterOutlined,
  PlayCircleOutlined, ScheduleOutlined, FileSearchOutlined, ReadOutlined,
  CalendarOutlined, FieldTimeOutlined, PictureOutlined,
} from '@ant-design/icons';
import ProcessVariableSelect from './ProcessVariableSelect';
import RecipientModal from '../modals/RecipientModal';
import RecipientSelector from './RecipientSelector';
import WebhookAccessControlModal from '../modals/WebhookAccessControlModal';
import WebhookAccessControlField from './WebhookAccessControlField';
import DataSetFieldMappingModal from '../modals/DataSetFieldMappingModal';
import MessageModeTabsComponent from './MessageModeTabsComponent';
import QRCodeMessageTabsComponent from './QRCodeMessageTabsComponent';
import WaitReplyMessageTabsComponent from './WaitReplyMessageTabsComponent';
import TimeValidatorConfigSection from './TimeValidatorConfigSection';
import DirectMessageTab from './DirectMessageTab';
import ProcessVariablesDisplay from './ProcessVariablesDisplay';
import TemplateVariableConfig from './TemplateVariableConfig';
import DataSetQueryConditionGroupsEditor from './DataSetQueryConditionGroupsEditor';
import DataSetQueryOrderByEditor from './DataSetQueryOrderByEditor';
import TemplateModal from '../modals/TemplateModal';
import { getAvailableOutputPaths } from '../utils';
import { apiService } from '../services/apiService';
import { useEmailProviders } from '../hooks/useEmailProviders';
import AiStaffSelectField from './AiStaffSelectField';
import SelectWithClearButton from './SelectWithClearButton';
import WorkflowKnowledgeBaseSettingsControl from './WorkflowKnowledgeBaseSettingsControl';
import PropertySectionTabs from './PropertySectionTabs';
import OdooFieldAutoComplete from './OdooFieldAutoComplete';
import OdooOperationSchemaPanel from './OdooOperationSchemaPanel';
import OdooPromptFieldPicker from './OdooPromptFieldPicker';
import OdooSourceValueSelect from './OdooSourceValueSelect';
import ProcessDataCellEditor from './ProcessDataCellEditor';
import { hasRole } from '../../../utils/permissionUtils';
import './NodePropertyDrawer.css';

const parseEmailFilterTagValue = (value) => {
  if (Array.isArray(value)) return value.filter(Boolean);
  return (value || '').toString().split(/\s*[\n\r,]+\s*/).filter(Boolean);
};

/** ???? emailFilterSubject + emailFilterBodyKeywords?? UI ???????????? */
const mergeEmailFilterAnyKeywords = (data) => {
  const merged = [
    ...parseEmailFilterTagValue(data?.emailFilterSubject),
    ...parseEmailFilterTagValue(data?.emailFilterBodyKeywords),
  ];
  const seen = new Set();
  return merged.filter((tag) => {
    const key = tag.trim().toLowerCase();
    if (!key || seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

// ??????????
const NodePropertyDrawer = ({
  selectedNode,
  drawerOpen,
  setDrawerOpen,
  form,
  handleNodeDataChange,
  processVariables,
  nodes,
  edges,
  workflowId,
  workflowName,
  t,
  templates,
  metaTemplates,
  eforms,
  // ?????
  isTemplateModalVisible,
  setIsTemplateModalVisible,
  isUserModalVisible,
  setIsUserModalVisible,
  isEFormModalVisible,
  setIsEFormModalVisible,
  isRecipientModalVisible,
  setIsRecipientModalVisible,
  // ??????
  conditionModalVisible,
  setConditionModalVisible,
  conditionGroupModalVisible,
  setConditionGroupModalVisible,
  defaultPathModalVisible,
  setDefaultPathModalVisible,
  editingCondition,
  setEditingCondition,
  editingConditionGroup,
  setEditingConditionGroup,
  conditionForm,
  conditionGroupForm,
  // ????
  handleSelectTemplate,
  handleSelectUser,
  handleSelectEForm,
  onSaveConditionGroup,
  onEditCondition,
  onAddCondition,
  onDeleteCondition,
  onSelectPath,
  // ???Time Validator ??????
  templateModalSource,
  setTemplateModalSource,
  handleTimeValidatorTemplateSelect,
}) => {
  // Email ??????????????
  const { emailProviders, loadingEmailProviders } = useEmailProviders(
    !!selectedNode && (
      (selectedNode.data?.type === 'start' && selectedNode.data?.activationType === 'email') ||
      selectedNode.data?.type === 'waitForEmailReply'
    )
  );

  // ?? DataSet Query ??
  const dataSetQueryNodes = nodes.filter(node => 
    node.data?.type === 'dataSetQuery' && 
    node.data?.operationType === 'SELECT'
  );
  
  // DataSet ????
  const [dataSets, setDataSets] = useState([]);
  const [dataSetColumns, setDataSetColumns] = useState([]);
  const [operationDataFields, setOperationDataFields] = useState([]);
  const [availableProcessVariables, setAvailableProcessVariables] = useState([]);
  const [loadingDataSets, setLoadingDataSets] = useState(false);
  const [testingOperation, setTestingOperation] = useState(false);

  const [aiProviders, setAiProviders] = useState([]);
  const [loadingAiProviders, setLoadingAiProviders] = useState(false);
  const [aiProvidersError, setAiProvidersError] = useState(null);

  const [voiceProviders, setVoiceProviders] = useState([]);
  const [loadingVoiceProviders, setLoadingVoiceProviders] = useState(false);

  const [aiStaffs, setAiStaffs] = useState([]);
  const [loadingAiStaffs, setLoadingAiStaffs] = useState(false);
  
  // DataSet ????????
  const [dataSetFieldMappingModalVisible, setDataSetFieldMappingModalVisible] = useState(false);
  const [dataSetFieldMappingForm] = Form.useForm();
  
  // ??????????
  const [operationDataModalVisible, setOperationDataModalVisible] = useState(false);
  /** 'dataSetQuery' | 'scheduledStart' ? ?????? Modal?????????? */
  const [operationDataModalMode, setOperationDataModalMode] = useState('dataSetQuery');
  const [editingOperationData, setEditingOperationData] = useState([]);
  /** Start ?? Dataset ?????????????? operationDataFields ????? */
  const [scheduledPostSuccessOperationFields, setScheduledPostSuccessOperationFields] = useState([]);
  const [eformFieldsMap, setEformFieldsMap] = useState({}); // { formId: [{ name, label }] }
  const [loadingEformFields, setLoadingEformFields] = useState(false);

  // Odoo ???AI ?? Prompt textarea ref?? OdooPromptFieldPicker ????????
  const odooPromptRef = useRef(null);
  
  // PV ????????
  const [pvSimulationData, setPvSimulationData] = useState({});
  const [showPvSimulation, setShowPvSimulation] = useState(false);
  
  // ????????
  const [queryPreviewData, setQueryPreviewData] = useState([]);
  const [showQueryPreview, setShowQueryPreview] = useState(false);
  const [queryPreviewModalVisible, setQueryPreviewModalVisible] = useState(false);

  // Commerce Collections?WhatsApp Shopping Cart ???
  const [commerceCollections, setCommerceCollections] = useState([]);
  const [loadingCommerceCollections, setLoadingCommerceCollections] = useState(false);

  // Studio ????? KnowledgeBasePage ?? API???? Dataset?AI ?????
  const [knowledgeStudioDocs, setKnowledgeStudioDocs] = useState([]);
  const [loadingKnowledgeStudioDocs, setLoadingKnowledgeStudioDocs] = useState(false);

  // ??????Broadcast Groups?? WorkflowKnowledgeBaseSettingsControl ? groupTag ?????
  const [broadcastGroups, setBroadcastGroups] = useState([]);
  const [loadingBroadcastGroups, setLoadingBroadcastGroups] = useState(false);

  // Institution Ordering Cart??? Flow Template ???
  const [companiesForFlowTemplate, setCompaniesForFlowTemplate] = useState([]);
  const [createFlowTemplateLoading, setCreateFlowTemplateLoading] = useState(false);
  const [flowTemplatePreview, setFlowTemplatePreview] = useState(null);
  const [flowTemplatePreviewModalVisible, setFlowTemplatePreviewModalVisible] = useState(false);

  // Time Validator ?????Wait for Reply ???
  const [retryMessageExpanded, setRetryMessageExpanded] = useState(false);
  const [escalationConfigExpanded, setEscalationConfigExpanded] = useState(false);
  const [timeValidatorRecipientModalVisible, setTimeValidatorRecipientModalVisible] = useState(false); // Time Validator ??? Recipient Modal
  
  // Overdue Settings ?????Start ???
  const [overdueEscalationExpanded, setOverdueEscalationExpanded] = useState(false);

  // Webhook ???????????Start ?? ? webhook activation?
  const [webhookAccessModalVisible, setWebhookAccessModalVisible] = useState(false);
  
  // Drawer ????
  const [isFullscreen, setIsFullscreen] = useState(false);
  
  // MetaFlows ??????????? PV ???
  const [activeFlowField, setActiveFlowField] = useState('flowCta'); // ???? flowCta

  const watchedValidatorType = Form.useWatch(['validation', 'validatorType'], form);
  const watchedAiIsActive = Form.useWatch(['validation', 'aiIsActive'], form);
  const watchedTimeIsActive = Form.useWatch(['validation', 'timeIsActive'], form);

  const aiIsActive = typeof watchedAiIsActive === 'boolean'
    ? watchedAiIsActive
    : (selectedNode?.data?.validation?.aiIsActive ?? false);

  const timeIsActive = typeof watchedTimeIsActive === 'boolean'
    ? watchedTimeIsActive
    : (selectedNode?.data?.validation?.timeIsActive ?? false);

  const normalizedValidatorType = ((watchedValidatorType ?? selectedNode?.data?.validation?.validatorType) || '').toLowerCase();

  const allowedValidatorTypes = ['ai', 'time', 'timeout-complete'];
  const [activeValidatorTab, setActiveValidatorTab] = useState(
    allowedValidatorTypes.includes(normalizedValidatorType) ? normalizedValidatorType : 'ai'
  );

  const syncValidationState = useCallback((updates) => {
    if (!selectedNode) {
      return;
    }

    const currentFormValidation = form?.getFieldValue?.('validation') || {};
    const mergedValidation = {
      ...(selectedNode.data.validation || {}),
      ...currentFormValidation,
      ...updates
    };

    const aiActive = mergedValidation.aiIsActive ?? false;
    const timeActive = mergedValidation.timeIsActive ?? false;
    const timeoutCompleteActive = mergedValidation.timeoutCompleteIsActive ?? false;

    // ? ???validatorType ??????? tab ?????????
    // ??????????? IsActive ?????????????
    if (!updates.validatorType && !mergedValidation.validatorType) {
      mergedValidation.validatorType = aiActive ? 'ai' : timeActive ? 'time' : 'ai';
    }

    mergedValidation.enabled = aiActive || timeActive || timeoutCompleteActive;

    form?.setFieldsValue?.({
      validation: mergedValidation
    });

    handleNodeDataChange({
      validation: mergedValidation
    });
  }, [allowedValidatorTypes, form, handleNodeDataChange, selectedNode]);

  const handleValidatorToggle = useCallback((key, isActive) => {
    const updates = key === 'ai'
      ? { aiIsActive: isActive }
      : key === 'time'
      ? { timeIsActive: isActive }
      : { timeoutCompleteIsActive: isActive }; // timeout-complete

    // ? ????????? validatorType???????????? tab
    syncValidationState(updates);

    if (isActive) {
      setActiveValidatorTab(key);
    }
  }, [syncValidationState]);

  useEffect(() => {
    if (aiIsActive && !timeIsActive) {
      setActiveValidatorTab('ai');
    } else if (!aiIsActive && timeIsActive) {
      setActiveValidatorTab('time');
    } else if (!aiIsActive && !timeIsActive) {
      const next = allowedValidatorTypes.includes(normalizedValidatorType) ? normalizedValidatorType : 'ai';
      setActiveValidatorTab(next);
    }
    // timeout-complete tab is toggled directly via handleValidatorToggle, no auto-switch needed
  }, [aiIsActive, timeIsActive, normalizedValidatorType]);

  // ?? Time Validator ??????
  useEffect(() => {
    const handleTimeValidatorTemplateSelected = (event) => {
      const { template, isMetaTemplate, source } = event.detail;
      console.log('?? NodePropertyDrawer ?? Time Validator ??????:', { template: template.name, isMetaTemplate, source });
      
      // ??????????????????????
      if (source === 'retryMessage') {
        const currentConfig = selectedNode?.data?.validation?.retryMessageConfig || {};
        const newValidation = {
          ...(selectedNode.data.validation || {}),
          retryMessageConfig: {
            ...currentConfig,
            useTemplate: true,
            messageMode: 'template',
            templateId: template.id,
            templateName: template.name,
            isMetaTemplate: isMetaTemplate,
            templateLanguage: template.language || null
          }
        };
        handleNodeDataChange({ validation: newValidation });
      } else if (source === 'escalation') {
        const currentConfig = selectedNode?.data?.validation?.escalationConfig || {};
        const newValidation = {
          ...(selectedNode.data.validation || {}),
          escalationConfig: {
            ...currentConfig,
            useTemplate: true,
            messageMode: 'template',
            templateId: template.id,
            templateName: template.name,
            isMetaTemplate: isMetaTemplate,
            templateLanguage: template.language || null
          }
        };
        handleNodeDataChange({ validation: newValidation });
      } else if (source === 'overdue') {
        const currentConfig = selectedNode?.data?.overdueConfig?.escalationConfig || {};
        const newOverdueConfig = {
          ...(selectedNode.data.overdueConfig || {}),
          escalationConfig: {
            ...currentConfig,
            useTemplate: true,
            messageMode: 'template',
            templateId: template.id,
            templateName: template.name,
            isMetaTemplate: isMetaTemplate,
            templateLanguage: template.language || null
          }
        };
        handleNodeDataChange({ overdueConfig: newOverdueConfig });
      }
    };

    window.addEventListener('timeValidatorTemplateSelected', handleTimeValidatorTemplateSelected);
    
    return () => {
      window.removeEventListener('timeValidatorTemplateSelected', handleTimeValidatorTemplateSelected);
    };
  }, []); // ?? selectedNode ?????????????


  // ?? WHERE ?????
  const generateWhereClause = (conditionGroups) => {
    if (!conditionGroups || conditionGroups.length === 0) {
      return '';
    }

    return conditionGroups.map(group => {
      if (!group.conditions || group.conditions.length === 0) {
        return '';
      }

      const groupConditions = group.conditions.map(condition => {
        const { fieldName, operator, value } = condition;
        
        // ???????? - ???????
        const safeFieldName = `[${fieldName}]`;
        
        // ????? - ?????
        const safeValue = value ? value.toString().replace(/'/g, "''") : '';
        
        // ?????????
        switch (operator) {
          case 'equals':
            return `${safeFieldName} = '${safeValue}'`;
          case 'notEquals':
            return `${safeFieldName} != '${safeValue}'`;
          case 'greaterThan':
            return `${safeFieldName} > '${safeValue}'`;
          case 'lessThan':
            return `${safeFieldName} < '${safeValue}'`;
          case 'greaterThanOrEqual':
            return `${safeFieldName} >= '${safeValue}'`;
          case 'lessThanOrEqual':
            return `${safeFieldName} <= '${safeValue}'`;
          case 'contains':
            return `${safeFieldName} LIKE '%${safeValue}%'`;
          case 'startsWith':
            return `${safeFieldName} LIKE '${safeValue}%'`;
          case 'endsWith':
            return `${safeFieldName} LIKE '%${safeValue}'`;
          case 'isEmpty':
            return `${safeFieldName} IS NULL OR ${safeFieldName} = ''`;
          case 'isNotEmpty':
            return `${safeFieldName} IS NOT NULL AND ${safeFieldName} != ''`;
          case 'in':
            // ?? IN ??????????
            const inValues = safeValue.split(',').map(v => `'${v.trim()}'`).join(', ');
            return `${safeFieldName} IN (${inValues})`;
          case 'notIn':
            // ?? NOT IN ??????????
            const notInValues = safeValue.split(',').map(v => `'${v.trim()}'`).join(', ');
            return `${safeFieldName} NOT IN (${notInValues})`;
          default:
            return `${safeFieldName} = '${safeValue}'`;
        }
      }).join(` ${group.relation.toUpperCase()} `);

      return `(${groupConditions})`;
    }).join(' AND ');
  };

  // ??????????????
  const extractProcessVariablesFromConditions = (conditionGroups) => {
    const variables = new Set();
    
    if (!conditionGroups || conditionGroups.length === 0) {
      return [];
    }
    
    conditionGroups.forEach(group => {
      if (group.conditions) {
        group.conditions.forEach(condition => {
          if (condition.value && condition.value.includes('${')) {
            // ?? ${variableName} ?????
            const matches = condition.value.match(/\$\{([^}]+)\}/g);
            if (matches) {
              matches.forEach(match => {
                const variableName = match.replace('${', '').replace('}', '');
                variables.add(variableName);
              });
            }
          }
        });
      }
    });
    
    return Array.from(variables);
  };

  const yesNoOptions = useMemo(() => ([
    { value: true, label: t('workflowDesigner.yes') },
    { value: false, label: t('workflowDesigner.no') }
  ]), [t]);

  const aiProviderOptions = useMemo(() => {
    return aiProviders.map(provider => ({
      value: provider.providerKey,
      label: `${provider.displayName}${provider.active ? '' : ` (${t('workflowDesigner.aiProviderInactive')})`}`,
      disabled: provider.active === false
    }));
  }, [aiProviders, t]);

  const voiceProviderOptions = useMemo(() => {
    return voiceProviders.map(provider => ({
      value: provider.providerKey,
      label: `${provider.displayName}${provider.active ? '' : ` (${t('workflowDesigner.aiProviderInactive')})`}`,
      disabled: provider.active === false
    }));
  }, [voiceProviders, t]);

  const aiStaffOptions = useMemo(() => {
    return aiStaffs.map(staff => ({
      value: staff.id,
      label: `${staff.displayName || ''}${staff.jobTitle ? ` - ${staff.jobTitle}` : ''}`,
      staff,
    }));
  }, [aiStaffs]);

  const handleAiStaffChange = useCallback((staffId, fieldPath = ['validation', 'aiStaffId']) => {
    const staff = aiStaffs.find(s => s.id === staffId);
    const isValidation = fieldPath[0] === 'validation';
    if (isValidation) {
      handleNodeDataChange({
        validation: {
          ...selectedNode?.data?.validation,
          aiStaffId: staffId || null,
        },
        aiStaffAvatarUrl: staff?.avatarUrl || null,
        aiStaffName: staff?.displayName || null,
        aiStaffJobTitle: staff?.jobTitle || null,
      });
    } else {
      handleNodeDataChange({
        aiStaffId: staffId || null,
        aiStaffAvatarUrl: staff?.avatarUrl || null,
        aiStaffName: staff?.displayName || null,
        aiStaffJobTitle: staff?.jobTitle || null,
      });
    }
  }, [aiStaffs, selectedNode?.data?.validation, handleNodeDataChange]);

  // ??? sendEForm ????????????????????
  const sendEFormFixedVariables = useMemo(() => [
    {
      id: 'formName',
      name: 'formName',
      displayName: '{formName}',
      description: t('workflowDesigner.sendEForm.formNameVariable') || 'Form Name'
    },
    {
      id: 'formUrl',
      name: 'formUrl',
      displayName: '{formUrl}',
      description: t('workflowDesigner.sendEForm.formUrlVariable') || 'Form Link'
    }
  ], [t]);

  const artifactReportDocFixedVariables = useMemo(() => [
    { id: 'reportName', name: 'reportName', displayName: '{reportName}', description: t('workflowDesigner.artifact.reportNameVariable') },
    { id: 'reportUrl', name: 'reportUrl', displayName: '{reportUrl}', description: t('workflowDesigner.artifact.reportUrlVariable') },
    { id: 'docName', name: 'docName', displayName: '{docName}', description: t('workflowDesigner.artifact.docNameVariable') },
    { id: 'docUrl', name: 'docUrl', displayName: '{docUrl}', description: t('workflowDesigner.artifact.docUrlVariable') }
  ], [t]);

  /** AI Suggestion / Fail Reason ?????? text?string??? json ?? */
  const textOrStringProcessVariables = useMemo(() => {
    return (processVariables || []).filter((pv) => {
      const dt = (pv.dataType || '').toLowerCase();
      return dt === 'text' || dt === 'string';
    });
  }, [processVariables]);

  // ? AI prompt / ??????????????????????? templateHeaderUrl ????
  const renderPromptVariablesDisplay = useCallback((fieldName) => {
    if (!processVariables || processVariables.length === 0) return null;
    return (
      <ProcessVariablesDisplay
        processVariables={processVariables}
        form={form}
        t={t}
        targetFieldName={fieldName}
        onInsert={(v) => {
          const cur = selectedNode?.data?.[fieldName] || '';
          const next = cur + `\${${v}}`;
          handleNodeDataChange({ [fieldName]: next });
          if (form) {
            form.setFieldValue(fieldName, next);
          }
        }}
        showLabel={true}
      />
    );
  }, [processVariables, form, t, selectedNode, handleNodeDataChange]);

  const loadAiProviders = useCallback(async () => {
    try {
      setLoadingAiProviders(true);
      setAiProvidersError(null);

      const token = localStorage.getItem('token');
      if (!token) {
        setAiProviders([]);
        return;
      }

      const response = await fetch('/api/apiproviders/company?category=AI', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const data = await response.json();
      if (Array.isArray(data)) {
        setAiProviders(data);
      } else {
        setAiProviders([]);
      }
    } catch (error) {
      console.error('Failed to load AI providers', error);
      setAiProviders([]);
      setAiProvidersError(error.message || 'Failed to load AI providers');
    } finally {
      setLoadingAiProviders(false);
    }
  }, []);

  const loadVoiceProviders = useCallback(async () => {
    try {
      setLoadingVoiceProviders(true);
      const token = localStorage.getItem('token');
      if (!token) { setVoiceProviders([]); return; }
      const response = await fetch('/api/apiproviders/company?category=Voice', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) { setVoiceProviders([]); return; }
      const data = await response.json();
      setVoiceProviders(Array.isArray(data) ? data : []);
    } catch {
      setVoiceProviders([]);
    } finally {
      setLoadingVoiceProviders(false);
    }
  }, []);

  const loadAiStaffs = useCallback(async () => {
    try {
      setLoadingAiStaffs(true);
      const token = localStorage.getItem('token');
      if (!token) { setAiStaffs([]); return; }
      const response = await fetch('/api/aivirtualemployees?pageSize=200', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) { setAiStaffs([]); return; }
      const result = await response.json();
      setAiStaffs(Array.isArray(result?.data) ? result.data : Array.isArray(result) ? result : []);
    } catch {
      setAiStaffs([]);
    } finally {
      setLoadingAiStaffs(false);
    }
  }, []);

  // DataSet ????????
  const handleSaveDataSetFieldMapping = async (mappedFields) => {
    try {
      const isScheduledStart =
        selectedNode?.data?.type === 'start' && selectedNode?.data?.activationType === 'scheduled';
      handleNodeDataChange(isScheduledStart ? { scheduledMappedFields: mappedFields } : { mappedFields });
      setDataSetFieldMappingModalVisible(false);
      dataSetFieldMappingForm.resetFields();
      message.success(t('workflowDesigner.dataSet.fieldMappingSaved'));
    } catch (error) {
      console.error(t('workflowDesigner.dataSet.fieldMappingSaveFailed') + ':', error);
      message.error(t('workflowDesigner.dataSet.fieldMappingSaveFailed'));
    }
  };

  // ????????
  const handleOpenOperationDataModal = () => {
    setOperationDataModalMode('dataSetQuery');
    setEditingOperationData([...operationDataFields]);
    setOperationDataModalVisible(true);
  };

  const handleOpenScheduledPostSuccessOperationModal = () => {
    setOperationDataModalMode('scheduledStart');
    setEditingOperationData([...scheduledPostSuccessOperationFields]);
    setOperationDataModalVisible(true);
  };

  // ????? modal ????????? sendEForm ???????
  useEffect(() => {
    if (!operationDataModalVisible || !nodes?.length) return;
    const sendEFormNodes = nodes.filter(n => n.data?.type === 'sendEForm' && n.data?.formId);
    if (sendEFormNodes.length === 0) {
      setEformFieldsMap({});
      return;
    }
    const fetchEformFields = async () => {
      setLoadingEformFields(true);
      const map = {};
      try {
        const token = localStorage.getItem('token');
        await Promise.all(sendEFormNodes.map(async (node) => {
          const formId = node.data.formId;
          if (!formId || map[formId]) return;
          try {
            const res = await fetch(`/api/eforms/${formId}/fields`, {
              headers: token ? { Authorization: `Bearer ${token}` } : {}
            });
            if (res.ok) {
              const data = await res.json();
              if (data?.fields?.length) {
                map[formId] = data.fields;
              }
            }
          } catch (err) {
            console.warn(`???? ${formId} ????:`, err);
          }
        }));
        setEformFieldsMap(map);
      } finally {
        setLoadingEformFields(false);
      }
    };
    fetchEformFields();
  }, [operationDataModalVisible, nodes]);

  // ??? processDataCell ????????? sendEForm ????????? eFormToPv ???????
  useEffect(() => {
    if (selectedNode?.data?.type !== 'processDataCell') return;
    if (!nodes?.length) return;
    const sendEFormNodes = nodes.filter(n => n.data?.type === 'sendEForm' && n.data?.formId);
    if (sendEFormNodes.length === 0) return;
    const missing = sendEFormNodes.filter(n => !eformFieldsMap[n.data.formId]);
    if (missing.length === 0) return;
    const token = localStorage.getItem('token');
    let cancelled = false;
    (async () => {
      const next = { ...eformFieldsMap };
      await Promise.all(missing.map(async (node) => {
        const formId = node.data.formId;
        try {
          const res = await fetch(`/api/eforms/${formId}/fields`, {
            headers: token ? { Authorization: `Bearer ${token}` } : {}
          });
          if (res.ok) {
            const data = await res.json();
            if (data?.fields?.length) next[formId] = data.fields;
          }
        } catch (err) {
          console.warn(`processDataCell ?? eForm ${formId} ????:`, err);
        }
      }));
      if (!cancelled) setEformFieldsMap(next);
    })();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedNode?.id, selectedNode?.data?.type, nodes]);

  // ??? Odoo ???formBased / integrateDataSetQuery???????? sendEForm ???????
  useEffect(() => {
    if (selectedNode?.data?.type !== 'odoo') return;
    if (!nodes?.length) return;
    const sendEFormNodes = nodes.filter(n => n.data?.type === 'sendEForm' && n.data?.formId);
    if (sendEFormNodes.length === 0) return;
    const missing = sendEFormNodes.filter(n => !eformFieldsMap[n.data.formId]);
    if (missing.length === 0) return;
    const token = localStorage.getItem('token');
    let cancelled = false;
    (async () => {
      const next = { ...eformFieldsMap };
      await Promise.all(missing.map(async (node) => {
        const formId = node.data.formId;
        try {
          const res = await fetch(`/api/eforms/${formId}/fields`, {
            headers: token ? { Authorization: `Bearer ${token}` } : {}
          });
          if (res.ok) {
            const data = await res.json();
            if (data?.fields?.length) next[formId] = data.fields;
          }
        } catch (err) {
          console.warn(`Odoo ???? eForm ${formId} ????:`, err);
        }
      }));
      if (!cancelled) setEformFieldsMap(next);
    })();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedNode?.id, selectedNode?.data?.type, nodes]);

  const handleSaveOperationData = () => {
    if (operationDataModalMode === 'scheduledStart') {
      setScheduledPostSuccessOperationFields([...editingOperationData]);
      const operationData = {};
      const operationDataFieldsOut = [];
      editingOperationData.forEach(field => {
        const isDynamic = field.targetColumnMode === 'dynamic';
        const hasTarget = isDynamic ? !!field.targetColumnRef : !!field.name;
        if (hasTarget && field.value) {
          if (!isDynamic) {
            operationData[field.name] = field.value;
          }
          operationDataFieldsOut.push({
            name: field.name || '',
            value: field.value,
            jsonKey: field.jsonKey || null,
            targetColumnMode: field.targetColumnMode || 'fixed',
            targetColumnRef: isDynamic ? (field.targetColumnRef || null) : null,
            targetColumnJsonKey: isDynamic ? (field.targetColumnJsonKey || null) : null
          });
        }
      });
      handleNodeDataChange({
        scheduledPostSuccessOperationData: operationData,
        scheduledPostSuccessOperationDataFields: operationDataFieldsOut
      });
      setOperationDataModalVisible(false);
      message.success(t('workflowDesigner.scheduledPostSuccessOperationSaved'));
      return;
    }

    setOperationDataFields([...editingOperationData]);
    
    // ?? operationData ????? jsonKey ??
    const operationData = {};
    const operationDataFields = [];
    
    editingOperationData.forEach(field => {
      const isDynamic = field.targetColumnMode === 'dynamic';
      const hasTarget = isDynamic ? !!field.targetColumnRef : !!field.name;
      if (hasTarget && field.value) {
        if (!isDynamic) {
          operationData[field.name] = field.value;
        }
        
        operationDataFields.push({
          name: field.name || '',
          value: field.value,
          jsonKey: field.jsonKey || null,
          targetColumnMode: field.targetColumnMode || 'fixed',
          targetColumnRef: isDynamic ? (field.targetColumnRef || null) : null,
          targetColumnJsonKey: isDynamic ? (field.targetColumnJsonKey || null) : null
        });
      }
    });
    
    // ????????
    handleNodeDataChange({ 
      operationData,
      operationDataFields // ???????????? jsonKey
    });
    
    setOperationDataModalVisible(false);
    message.success(t('workflowDesigner.dataSet.operationDataSaved'));
  };

  const handleCancelOperationData = () => {
    setOperationDataModalVisible(false);
  };

  const handleAddOperationDataField = () => {
    setEditingOperationData([...editingOperationData, { name: '', value: '', jsonKey: '', targetColumnMode: 'fixed', targetColumnRef: '', targetColumnJsonKey: '' }]);
  };

  const handleRemoveOperationDataField = (index) => {
    const newFields = editingOperationData.filter((_, i) => i !== index);
    setEditingOperationData(newFields);
  };

  const handleUpdateOperationDataField = (index, field, value) => {
    const newFields = [...editingOperationData];
    newFields[index][field] = value;
    
    // ???????????
    if (field === 'targetColumnMode') {
      if (value === 'fixed') {
        newFields[index].targetColumnRef = '';
        newFields[index].targetColumnJsonKey = '';
      } else {
        newFields[index].name = '';
      }
    }
    
    // ????????
    if (field === 'value') {
      if (value && String(value).startsWith('eform:')) {
        newFields[index].jsonKey = '';
      } else {
        const selectedPv = processVariables?.find(pv => 
          `\${${pv.variableName || pv.name}}` === value
        );
        if (selectedPv && selectedPv.dataType?.toLowerCase() !== 'json') {
          newFields[index].jsonKey = '';
        }
      }
    }

    // ???????????? JSON key
    if (field === 'targetColumnRef') {
      if (value && String(value).startsWith('eform:')) {
        newFields[index].targetColumnJsonKey = '';
      } else {
        const selectedPv = processVariables?.find(pv =>
          `\${${pv.variableName || pv.name}}` === value
        );
        if (selectedPv && selectedPv.dataType?.toLowerCase() !== 'json') {
          newFields[index].targetColumnJsonKey = '';
        }
      }
    }
    
    setEditingOperationData(newFields);
  };
  
  // ?????????pv ? json ????? jsonKey?eform ??
  const getSelectedPvType = (fieldValue) => {
    if (!fieldValue) return null;
    if (String(fieldValue).startsWith('eform:')) return null; // eForm ????? jsonKey
    if (!processVariables) return null;
    const variableName = fieldValue.replace(/^\$\{/, '').replace(/\}$/, '');
    const selectedPv = processVariables.find(pv => 
      (pv.variableName || pv.name) === variableName
    );
    return selectedPv?.dataType?.toLowerCase() || null;
  };

  // ?? workflowId ??
  useEffect(() => {
  }, [workflowId]);

  // ????????? headerType ????????? components ???
  useEffect(() => {
    if ((selectedNode?.data?.type === 'sendWhatsAppTemplate' || 
         (selectedNode?.data?.type === 'sendWhatsApp' && selectedNode?.data?.messageMode === 'template')) && 
        selectedNode?.data?.templateId && 
        !selectedNode?.data?.templateHeaderType &&
        selectedNode?.data?.isMetaTemplate) {
      console.log('?? NodePropertyDrawer - ??????? headerType?????');
      console.log('?? templateId:', selectedNode.data.templateId);
      console.log('?? metaTemplates count:', metaTemplates?.length);
      
      // ?????????????
      const template = metaTemplates?.find(t => t.id === selectedNode.data.templateId);
      console.log('?? ????:', template ? { id: template.id, name: template.name, hasComponents: !!template.components } : '???');
      
      if (template) {
        // ??????? headerType?????
        if (template.headerType || template.HeaderType) {
          console.log('? ??????? headerType:', template.headerType || template.HeaderType);
          handleNodeDataChange({ 
            templateHeaderType: template.headerType || template.HeaderType,
            templateHeaderUrl: template.headerUrl || template.HeaderUrl || null,
            templateHeaderFilename: template.headerFilename || template.HeaderFilename || null
          });
          return;
        }
        
        // ??? components ???
        if (template.components) {
          try {
            console.log('?? ??? components ??, components:', template.components);
            const headerComponent = template.components.find(c => 
              c.type === 'HEADER' || c.Type === 'HEADER'
            );
            console.log('?? ?? headerComponent:', headerComponent);
            if (headerComponent) {
              const format = headerComponent.format || headerComponent.Format;
              console.log('?? headerComponent format:', format);
              if (format) {
                const headerType = format.toLowerCase();
                console.log('? ? components ??? headerType:', headerType);
                handleNodeDataChange({ templateHeaderType: headerType });
                return;
              }
            }
          } catch (error) {
            console.warn('? ???? components ??:', error);
          }
        }
      }
    }
  }, [selectedNode?.data?.templateId, selectedNode?.data?.isMetaTemplate, selectedNode?.data?.templateHeaderType, metaTemplates, handleNodeDataChange]);

  // ? selectedNode ?????? Form ????
  useEffect(() => {
    if (selectedNode && form && form.resetFields) {
      // ????????????
      form.resetFields();
      const validation = selectedNode.data.validation || {};
      const normalizedInitialValidatorType = (validation.validatorType || '').toLowerCase();
      const derivedAiIsActive = typeof validation.aiIsActive === 'boolean'
        ? validation.aiIsActive
        : (validation.enabled === true && normalizedInitialValidatorType === 'ai');
      const derivedTimeIsActive = typeof validation.timeIsActive === 'boolean'
        ? validation.timeIsActive
        : (validation.enabled === true && normalizedInitialValidatorType === 'time');
      // ?? emailConfig??????????
      const emailConfig = selectedNode.data.emailConfig || {};
      const emailConfigFields = {
        'emailConfig.providerKey': emailConfig.providerKey || '',
        'emailConfig.subject': emailConfig.subject || '',
        'emailConfig.body': emailConfig.body || '',
        'emailConfig.replyTo': emailConfig.replyTo || '',
      };

      form.setFieldsValue({
        taskName: selectedNode.data.taskName || selectedNode.data.label,
        to: selectedNode.data.to || '',
        message: selectedNode.data.message || '',
        templateName: selectedNode.data.templateName || '',
        timeout: selectedNode.data.timeout || '',
        sql: selectedNode.data.sql || '',
        url: selectedNode.data.url || '',
        formName: selectedNode.data.formName || '',
        result: selectedNode.data.result || '',
        replyType: selectedNode.data.replyType || '',
        specifiedUsers: selectedNode.data.specifiedUsers || '',
        qrCodeVariable: selectedNode.data.qrCodeVariable || '',
        // QR Code ??????? messageMode ? message?
        messageMode: selectedNode.data.messageMode || 'direct',
        message: selectedNode.data.message || '',
        // QR Code ????
        qrCodeSuccessMessage: selectedNode.data.qrCodeSuccessMessage || t('workflowDesigner.dataSet.qrCodeSuccessMessage'),
        qrCodeSuccessMessageMode: selectedNode.data.qrCodeSuccessMessageMode || 'direct',
        qrCodeSuccessTemplateId: selectedNode.data.qrCodeSuccessTemplateId || '',
        qrCodeSuccessTemplateName: selectedNode.data.qrCodeSuccessTemplateName || '',
        qrCodeSuccessIsMetaTemplate: selectedNode.data.qrCodeSuccessIsMetaTemplate || false,
        qrCodeSuccessTemplateLanguage: selectedNode.data.qrCodeSuccessTemplateLanguage || null,
        qrCodeSuccessTemplateVariables: selectedNode.data.qrCodeSuccessTemplateVariables || [],
        // QR Code ????
        qrCodeErrorMessage: selectedNode.data.qrCodeErrorMessage || t('workflowDesigner.dataSet.qrCodeErrorMessage'),
        qrCodeErrorMessageMode: selectedNode.data.qrCodeErrorMessageMode || 'direct',
        qrCodeErrorTemplateId: selectedNode.data.qrCodeErrorTemplateId || '',
        qrCodeErrorTemplateName: selectedNode.data.qrCodeErrorTemplateName || '',
        qrCodeErrorIsMetaTemplate: selectedNode.data.qrCodeErrorIsMetaTemplate || false,
        qrCodeErrorTemplateLanguage: selectedNode.data.qrCodeErrorTemplateLanguage || null,
        qrCodeErrorTemplateVariables: selectedNode.data.qrCodeErrorTemplateVariables || [],
        locationRequestBody: selectedNode.data.locationRequestBody || '',
        locationVariable: selectedNode.data.locationVariable || '',
        approvalResultVariable: selectedNode.data.approvalResultVariable || '',
        approveButtonLabel: selectedNode.data.approveButtonLabel || '',
        rejectButtonLabel: selectedNode.data.rejectButtonLabel || '',
        requireApproval: selectedNode.data.requireApproval !== undefined ? selectedNode.data.requireApproval : true,
        activationType: selectedNode.data.activationType || 'manual',
        whatsAppMenuName: selectedNode.data.whatsAppMenuName ?? '',
        webhookAccessMode: selectedNode.data.webhookAccessMode || 'public',
        webhookAllowedContacts: Array.isArray(selectedNode.data.webhookAllowedContacts) ? selectedNode.data.webhookAllowedContacts : [],
        webhookAllowedGroups: Array.isArray(selectedNode.data.webhookAllowedGroups) ? selectedNode.data.webhookAllowedGroups : [],
        webhookAllowedHashtags: Array.isArray(selectedNode.data.webhookAllowedHashtags) ? selectedNode.data.webhookAllowedHashtags : [],
        scheduledTable: selectedNode.data.scheduledTable || '',
        scheduledQuery: selectedNode.data.scheduledQuery || '',
        scheduledDataSetId: selectedNode.data.scheduledDataSetId || '',
        scheduledInterval: selectedNode.data.scheduledInterval || 300,
        emailProviderKey: selectedNode.data.emailProviderKey || '',
        emailMonitorMailbox: selectedNode.data.emailMonitorMailbox || '',
        emailFilterSender: (() => {
          const v = selectedNode.data.emailFilterSender;
          if (Array.isArray(v)) return v;
          return (v || '').toString().split(/\s*[\n\r,]+\s*/).filter(Boolean);
        })(),
        emailFilterSubject: mergeEmailFilterAnyKeywords(selectedNode.data),
        emailFilterKeywordsRequired: (() => {
          const v = selectedNode.data.emailFilterKeywordsRequired;
          if (Array.isArray(v)) return v;
          return (v || '').toString().split(/\s*[\n\r,]+\s*/).filter(Boolean);
        })(),
        emailFilterSenderNot: (() => {
          const v = selectedNode.data.emailFilterSenderNot;
          if (Array.isArray(v)) return v;
          return (v || '').toString().split(/\s*[\n\r,]+\s*/).filter(Boolean);
        })(),
        emailFilterSubjectNot: (() => {
          const v = selectedNode.data.emailFilterSubjectNot;
          if (Array.isArray(v)) return v;
          return (v || '').toString().split(/\s*[\n\r,]+\s*/).filter(Boolean);
        })(),
        emailFilterBodyKeywordsNot: (() => {
          const v = selectedNode.data.emailFilterBodyKeywordsNot;
          if (Array.isArray(v)) return v;
          return (v || '').toString().split(/\s*[\n\r,]+\s*/).filter(Boolean);
        })(),
        emailFilterHasAttachment: selectedNode.data.emailFilterHasAttachment ?? false,
        validation: {
          ...validation,
          enabled: (validation.enabled ?? false) || derivedAiIsActive || derivedTimeIsActive,
          aiIsActive: derivedAiIsActive,
          timeIsActive: derivedTimeIsActive
        },
        // DataSet ????????
        dataSetId: selectedNode.data.dataSetId || '',
        operationType: selectedNode.data.operationType || 'SELECT',
        queryConditions: selectedNode.data.queryConditions || '',
        operationData: selectedNode.data.operationData || {},
        mappedFields: selectedNode.data.mappedFields || [],
        // Email ????
        ...emailConfigFields,
        // ? spread ???????? tag ????????????????????????? tag?
        ...((() => {
          const { emailFilterSender: _s, emailFilterSubject: _b, emailFilterBodyKeywords: _k, emailFilterKeywordsRequired: _kr, emailFilterSenderNot: _sn, emailFilterSubjectNot: _bn, emailFilterBodyKeywordsNot: _kn, emailFilterAttachmentExtensions: _e, emailFilterAttachmentFileName: _f, emailFilterAttachmentFileNameNot: _fn, ...rest } = selectedNode.data;
          return rest;
        })()),
        emailFilterSender: (() => {
          const v = selectedNode.data.emailFilterSender;
          if (Array.isArray(v)) return v;
          return (v || '').toString().split(/\s*[\n\r,]+\s*/).filter(Boolean);
        })(),
        emailFilterSubject: mergeEmailFilterAnyKeywords(selectedNode.data),
        emailFilterKeywordsRequired: (() => {
          const v = selectedNode.data.emailFilterKeywordsRequired;
          if (Array.isArray(v)) return v;
          return (v || '').toString().split(/\s*[\n\r,]+\s*/).filter(Boolean);
        })(),
        emailFilterAttachmentExtensions: (() => {
          const v = selectedNode.data.emailFilterAttachmentExtensions;
          if (Array.isArray(v)) return v;
          return (v || '').toString().split(/\s*[\n\r,]+\s*/).filter(Boolean);
        })(),
        emailFilterAttachmentFileName: (() => {
          const v = selectedNode.data.emailFilterAttachmentFileName;
          if (Array.isArray(v)) return v;
          return (v || '').toString().split(/\s*[\n\r,]+\s*/).filter(Boolean);
        })(),
        emailFilterAttachmentFileNameNot: (() => {
          const v = selectedNode.data.emailFilterAttachmentFileNameNot;
          if (Array.isArray(v)) return v;
          return (v || '').toString().split(/\s*[\n\r,]+\s*/).filter(Boolean);
        })(),
        emailFilterSenderNot: (() => {
          const v = selectedNode.data.emailFilterSenderNot;
          if (Array.isArray(v)) return v;
          return (v || '').toString().split(/\s*[\n\r,]+\s*/).filter(Boolean);
        })(),
        emailFilterSubjectNot: (() => {
          const v = selectedNode.data.emailFilterSubjectNot;
          if (Array.isArray(v)) return v;
          return (v || '').toString().split(/\s*[\n\r,]+\s*/).filter(Boolean);
        })(),
        emailFilterBodyKeywordsNot: (() => {
          const v = selectedNode.data.emailFilterBodyKeywordsNot;
          if (Array.isArray(v)) return v;
          return (v || '').toString().split(/\s*[\n\r,]+\s*/).filter(Boolean);
        })(),
        // HTML ????????????? messageTemplate???????????? message
        ...((() => {
          const d = selectedNode.data;
          if (d.type !== 'generateHtmlReport' && d.type !== 'generateDocument') return {};
          const mm = d.messageMode || 'direct';
          if (mm === 'direct' && !(d.message || '').trim() && (d.messageTemplate || '').trim()) {
            return { message: d.messageTemplate };
          }
          return {};
        })())
      });
    }
  }, [selectedNode?.id, form]); // ??? selectedNode.id?????? selectedNode ??

  useEffect(() => {
    if (drawerOpen) {
      loadAiProviders();
      loadAiStaffs();
      loadVoiceProviders();
    }
  }, [drawerOpen, loadAiProviders, loadAiStaffs, loadVoiceProviders]);

  useEffect(() => {
    if (!selectedNode?.data?.validation) {
      return;
    }
    const rawType = selectedNode.data.validation.validatorType;
    if (!rawType) {
      return;
    }
    const normalizedType = rawType.toLowerCase();
    if (normalizedType === 'openai' || normalizedType === 'xai') {
      const fallbackProviderKey = selectedNode.data.validation.aiProviderKey || normalizedType;
      const newValidation = {
        ...selectedNode.data.validation,
        validatorType: 'ai',
        aiProviderKey: fallbackProviderKey
      };
      handleNodeDataChange({
        validation: newValidation,
        aiProviderKey: selectedNode.data.aiProviderKey ?? fallbackProviderKey
      });
    }
  }, [
    selectedNode?.id,
    selectedNode?.data?.validation?.validatorType,
    selectedNode?.data?.validation?.aiProviderKey,
    selectedNode?.data?.aiProviderKey,
    handleNodeDataChange
  ]);

  useEffect(() => {
    if (!drawerOpen || !selectedNode) {
      return;
    }
    if (!aiProviders.length) {
      return;
    }

    const activeProvider = aiProviders.find(p => p.active);
    const fallbackProvider = activeProvider || aiProviders[0];

    if (selectedNode.data?.type === 'sendEForm' &&
        (selectedNode.data.sendEFormMode === 'integrateWaitReply' || selectedNode.data.sendEFormMode === 'integrateEForm')) {
      const currentKey = selectedNode.data.aiProviderKey;
      const exists = currentKey && aiProviders.some(p => p.providerKey === currentKey);
      if (!exists && fallbackProvider) {
        handleNodeDataChange({ aiProviderKey: fallbackProvider.providerKey });
      }
    }

    const validationType = selectedNode.data?.validation?.validatorType?.toLowerCase();
    if (validationType === 'ai') {
      const currentKey = selectedNode.data.validation?.aiProviderKey || selectedNode.data.aiProviderKey;
      const exists = currentKey && aiProviders.some(p => p.providerKey === currentKey);
      if (!exists && fallbackProvider) {
        const newValidation = {
          ...(selectedNode.data.validation || {}),
          aiProviderKey: fallbackProvider.providerKey
        };
        handleNodeDataChange({
          validation: newValidation,
          aiProviderKey: selectedNode.data.aiProviderKey ?? fallbackProvider.providerKey
        });
      }
    }
  }, [
    drawerOpen,
    selectedNode?.id,
    selectedNode?.data?.type,
    selectedNode?.data?.sendEFormMode,
    selectedNode?.data?.validation?.validatorType,
    selectedNode?.data?.validation?.aiProviderKey,
    selectedNode?.data?.aiProviderKey,
    aiProviders,
    handleNodeDataChange
  ]);

  // ??? MetaFlows ????????? manualFill ???????? AI ??
  useEffect(() => {
    if (selectedNode?.data?.type === 'sendEForm' && 
        selectedNode?.data?.formType === 'MetaFlows') {
      const needsUpdate =
        selectedNode?.data?.sendEFormMode !== 'manualFill' ||
        (Array.isArray(selectedNode?.data?.sendEFormModes) &&
          (selectedNode.data.sendEFormModes.length !== 1 || selectedNode.data.sendEFormModes[0] !== 'manualFill'));
      if (needsUpdate) {
        handleNodeDataChange({ 
          sendEFormMode: 'manualFill',
          sendEFormModes: ['manualFill'],
          integratedDataSetQueryNodeId: '',
          integratedEFormNodeId: '',
          integratedWaitReplyNodeId: '',
          integratedChatBotNodeId: '',
        });
      }
    }
  }, [selectedNode?.data?.formType, selectedNode?.data?.type, selectedNode?.data?.sendEFormMode, selectedNode?.data?.sendEFormModes, handleNodeDataChange]);

  // ???????DataSetQueryConditionGroupsEditor ? useEffect ???????????? render ?????????
  const loadDataSetColumns = useCallback(async (dataSetId) => {
    if (!dataSetId) return;
    try {
      setQueryPreviewData([]);
      setQueryPreviewModalVisible(false);

      const response = await fetch(`/api/datasets/${dataSetId}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (!response.ok) {
        throw new Error('?? DataSet ????');
      }

      const data = await response.json();
      setDataSetColumns(data.data?.columns || []);
    } catch (error) {
      message.error('?? DataSet ????: ' + error.message);
    }
  }, []);

  // sendEForm AI ????? Dataset ??????????
  // ???????? AI ?????? integrateChatBot????????????
  useEffect(() => {
    if (selectedNode?.data?.type === 'sendEForm') {
      const mode = selectedNode.data.sendEFormMode || '';
      const modes = Array.isArray(selectedNode.data.sendEFormModes) ? selectedNode.data.sendEFormModes : [];
      const AI_MODES = ['integrateWaitReply', 'integrateEmailStart', 'integrateManualStart', 'integrateEForm', 'integrateChatBot', 'integrateDataSetQuery'];
      const hasAiMode = AI_MODES.includes(mode) || modes.some(m => AI_MODES.includes(m));
      const hasKb = selectedNode.data.knowledgeBaseEnabled || selectedNode.data.knowledgeBaseDatasetEnabled;
      if (hasAiMode || hasKb) {
        loadDataSets();
      }
    }
  }, [selectedNode?.data?.type, selectedNode?.data?.sendEFormMode, selectedNode?.data?.sendEFormModes, selectedNode?.data?.knowledgeBaseEnabled, selectedNode?.data?.knowledgeBaseDatasetEnabled]);

  // sendEForm ??? Dataset ???????
  useEffect(() => {
    if (selectedNode?.data?.type === 'sendEForm' && selectedNode.data.knowledgeBaseDataSetId) {
      loadDataSetColumns(selectedNode.data.knowledgeBaseDataSetId);
    }
  }, [selectedNode?.data?.knowledgeBaseDataSetId, selectedNode?.data?.type, loadDataSetColumns]);

  useEffect(() => {
    if (selectedNode?.data?.type === 'generateHtmlReport' || selectedNode?.data?.type === 'generateDocument') {
      const gm = selectedNode.data.generationMode || 'integrateWaitReply';
      if (gm === 'integrateWaitReply' || gm === 'integrateEmailStart' || gm === 'integrateManualStart') {
        loadAiProviders();
        loadDataSets();
      }
      if (gm === 'integrateDataSetQuery') {
        loadDataSets();
      }
    }
  }, [selectedNode?.data?.type, selectedNode?.data?.generationMode]);

  useEffect(() => {
    if ((selectedNode?.data?.type === 'generateHtmlReport' || selectedNode?.data?.type === 'generateDocument') &&
        selectedNode.data.knowledgeBaseDataSetId) {
      loadDataSetColumns(selectedNode.data.knowledgeBaseDataSetId);
    }
  }, [selectedNode?.data?.type, selectedNode?.data?.knowledgeBaseDataSetId, loadDataSetColumns]);

  // waitReply / waitForLocation + AI Validator??? Dataset ???????
  useEffect(() => {
    if (
      ((selectedNode?.data?.type === 'waitReply' || selectedNode?.data?.type === 'waitForLocation') &&
       selectedNode.data.validation?.aiIsActive === true) ||
      selectedNode?.data?.type === 'chatOrderingCart' ||
      selectedNode?.data?.type === 'chatBot'
    ) {
      loadDataSets();
    }
  }, [selectedNode?.data?.type, selectedNode?.data?.validation?.aiIsActive]);

  useEffect(() => {
    if (
      (selectedNode?.data?.type === 'waitReply' || selectedNode?.data?.type === 'waitForLocation' || selectedNode?.data?.type === 'chatOrderingCart' || selectedNode?.data?.type === 'chatBot') &&
      selectedNode.data.knowledgeBaseDataSetId
    ) {
      loadDataSetColumns(selectedNode.data.knowledgeBaseDataSetId);
    }
  }, [selectedNode?.data?.knowledgeBaseDataSetId, selectedNode?.data?.type, loadDataSetColumns]);

  // ?? DataSet ???????
  useEffect(() => {
    if (selectedNode?.data?.type === 'dataSetQuery') {
      loadDataSets();
      loadAvailableProcessVariables();
      
      // ????????? operationDataFields??? jsonKey?
      if (selectedNode.data.operationDataFields && Array.isArray(selectedNode.data.operationDataFields)) {
        setOperationDataFields(selectedNode.data.operationDataFields);
      } else if (selectedNode.data.operationData && typeof selectedNode.data.operationData === 'object') {
        // ??????? operationData ????? operationDataFields ??
        const fields = Object.entries(selectedNode.data.operationData).map(([name, value]) => ({
          name,
          value,
          jsonKey: null // ????? jsonKey
        }));
        setOperationDataFields(fields);
      } else {
        setOperationDataFields([]);
      }
    }
  }, [selectedNode?.data?.type, selectedNode?.data?.operationData, selectedNode?.data?.operationDataFields, processVariables]);

  // ?? Commerce Collections?Shopping Cart ???
  const loadCommerceCollections = useCallback(async (companyId = null) => {
    setLoadingCommerceCollections(true);
    try {
      const list = await apiService.fetchCommerceCollections(companyId);
      setCommerceCollections(Array.isArray(list) ? list : []);
    } catch (err) {
      console.error('loadCommerceCollections error', err);
      setCommerceCollections([]);
    } finally {
      setLoadingCommerceCollections(false);
    }
  }, []);
  useEffect(() => {
    if (selectedNode?.data?.type === 'sendWhatsAppShoppingCart') {
      loadCommerceCollections();
    }
  }, [selectedNode?.data?.type, loadCommerceCollections]);

  // ???????Institution Ordering Cart ??????? Template?
  const loadCompaniesForFlowTemplate = useCallback(async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch('/api/commerce/companies-for-select', {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (!res.ok) return;
      const data = await res.json();
      setCompaniesForFlowTemplate(Array.isArray(data) ? data : []);
    } catch (e) {
      console.error('loadCompaniesForFlowTemplate', e);
      setCompaniesForFlowTemplate([]);
    }
  }, []);
  useEffect(() => {
    if (selectedNode?.data?.type === 'sendInstitutionOrderingCart' || selectedNode?.data?.type === 'chatOrderingCart') {
      loadCompaniesForFlowTemplate();
    }
  }, [selectedNode?.data?.type, loadCompaniesForFlowTemplate]);

  const chatCartIsTenantAdmin = useMemo(() => {
    try {
      const userInfoStr = localStorage.getItem('userInfo');
      if (!userInfoStr) return false;
      const userInfo = JSON.parse(userInfoStr);
      return hasRole(userInfo, 'Tenant_Admin');
    } catch (e) {
      return false;
    }
  }, []);

  // ? DataSet ???????????dataSetQuery ??? Start ?? Dataset?
  useEffect(() => {
    if (selectedNode?.data?.type === 'start' && selectedNode?.data?.activationType === 'scheduled') {
      if (selectedNode.data.scheduledDataSetId) {
        loadDataSetColumns(selectedNode.data.scheduledDataSetId);
      }
      return;
    }
    if (selectedNode?.data?.dataSetId) {
      loadDataSetColumns(selectedNode.data.dataSetId);
    }
  }, [selectedNode?.data?.dataSetId, selectedNode?.data?.scheduledDataSetId, selectedNode?.data?.type, selectedNode?.data?.activationType, loadDataSetColumns]);

  // ?? DataSet ??
  const loadDataSets = async () => {
    try {
      setLoadingDataSets(true);
      const response = await fetch('/api/datasets', {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (!response.ok) {
        throw new Error('?? DataSet ????');
      }

      const data = await response.json();
      setDataSets(data.data || []);
    } catch (error) {
      message.error('?? DataSet ????: ' + error.message);
    } finally {
      setLoadingDataSets(false);
    }
  };

  // Start ???Dataset ?? ? ?? DataSet ?????????
  useEffect(() => {
    if (selectedNode?.data?.type === 'start' && selectedNode?.data?.activationType === 'scheduled') {
      void loadDataSets();
      loadAvailableProcessVariables();
      const d = selectedNode.data.scheduledPostSuccessOperationDataFields;
      if (d && Array.isArray(d)) {
        setScheduledPostSuccessOperationFields(d);
      } else if (selectedNode.data.scheduledPostSuccessOperationData && typeof selectedNode.data.scheduledPostSuccessOperationData === 'object') {
        setScheduledPostSuccessOperationFields(
          Object.entries(selectedNode.data.scheduledPostSuccessOperationData).map(([name, value]) => ({
            name,
            value,
            jsonKey: null
          }))
        );
      } else {
        setScheduledPostSuccessOperationFields([]);
      }
    }
  }, [
    selectedNode?.data?.type,
    selectedNode?.data?.activationType,
    selectedNode?.data?.scheduledPostSuccessOperationData,
    selectedNode?.data?.scheduledPostSuccessOperationDataFields,
    processVariables
  ]);

  const loadKnowledgeStudioDocs = useCallback(async () => {
    try {
      setLoadingKnowledgeStudioDocs(true);
      const token = localStorage.getItem('token');
      const response = await fetch('/api/knowledge-documents?page=1&pageSize=100', {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        credentials: 'include',
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.error || data.message || 'load knowledge list failed');
      }
      const rows = (data.data || []).map((row) => ({
        id: row.id ?? row.Id,
        title: row.title ?? row.Title ?? '',
        publishedVersionId: row.publishedVersionId ?? row.PublishedVersionId ?? null,
      }));
      setKnowledgeStudioDocs(rows);
    } catch (error) {
      console.error('loadKnowledgeStudioDocs', error);
      setKnowledgeStudioDocs([]);
    } finally {
      setLoadingKnowledgeStudioDocs(false);
    }
  }, []);

  const loadBroadcastGroups = useCallback(async () => {
    try {
      setLoadingBroadcastGroups(true);
      const token = localStorage.getItem('token');
      const response = await fetch('/api/ContactList/groups?page=1&pageSize=500', {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        credentials: 'include',
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.error || data.message || 'load broadcast groups failed');
      }
      const rows = (data.groups || data.data || data || []).map((g) => ({
        id: g.id ?? g.Id,
        name: g.name ?? g.Name ?? '',
        color: g.color ?? g.Color ?? null,
      }));
      setBroadcastGroups(rows);
    } catch (error) {
      console.error('loadBroadcastGroups', error);
      setBroadcastGroups([]);
    } finally {
      setLoadingBroadcastGroups(false);
    }
  }, []);

  useEffect(() => {
    const nodeType = selectedNode?.data?.type;
    const sendMode = selectedNode?.data?.sendEFormMode;
    const aiActive = selectedNode?.data?.validation?.aiIsActive;
    const needKbPicker =
      (nodeType === 'sendEForm' && (sendMode === 'integrateWaitReply' || sendMode === 'integrateEmailStart' || sendMode === 'integrateManualStart' || sendMode === 'integrateEForm')) ||
      ((nodeType === 'waitReply' || nodeType === 'waitForLocation') && aiActive === true) ||
      nodeType === 'chatOrderingCart' ||
      nodeType === 'chatBot' ||
      nodeType === 'generateHtmlReport' ||
      nodeType === 'generateDocument';
    if (needKbPicker) {
      void loadKnowledgeStudioDocs();
      if (broadcastGroups.length === 0) {
        void loadBroadcastGroups();
      }
    }
  }, [selectedNode?.data?.type, selectedNode?.data?.sendEFormMode, selectedNode?.data?.validation?.aiIsActive, loadKnowledgeStudioDocs, loadBroadcastGroups, broadcastGroups.length]);

  // ????????? - ? processVariables prop ???
  const loadAvailableProcessVariables = async () => {
    try {
      // ???? processVariables prop ???????????
      if (processVariables && processVariables.length > 0) {
        const variableNames = processVariables.map(pv => pv.variableName || pv.name);
        setAvailableProcessVariables(variableNames);
      } else {
        setAvailableProcessVariables([]);
      }
    } catch (error) {
      console.error('????????:', error);
      setAvailableProcessVariables([]);
    }
  };

  // ????????
  const addOperationDataField = () => {
    const newFields = [...operationDataFields, { name: '', value: '' }];
    setOperationDataFields(newFields);
  };

  // ????????
  const removeOperationDataField = (index) => {
    const newFields = operationDataFields.filter((_, i) => i !== index);
    setOperationDataFields(newFields);
    
    // ?????
    const operationData = {};
    newFields.forEach(field => {
      if (field.name && field.value) {
        operationData[field.name] = field.value;
      }
    });
    
    handleNodeDataChange({ operationData });
  };

  // ????????
  const updateOperationDataField = (index, field, value) => {
    const newFields = [...operationDataFields];
    newFields[index][field] = value;
    setOperationDataFields(newFields);
    
    // ?????
    const operationData = {};
    newFields.forEach(field => {
      if (field.name && field.value) {
        operationData[field.name] = field.value;
      }
    });
    
    handleNodeDataChange({ operationData });
  };

  // ?? DataSet ??
  const testDataSetOperation = async () => {
    try {
      setTestingOperation(true);
      const currentNode = nodes.find(node => node.id === selectedNode?.id);
      
      if (!currentNode?.data?.dataSetId) {
        message.error(t('workflowDesigner.dataSet.pleaseSelectDataSet'));
        return;
      }
      
      if (!currentNode?.data?.operationType) {
        message.error(t('workflowDesigner.dataSet.pleaseSelectOperationType'));
        return;
      }
      
      // ????????
      const requestData = {
        dataSetId: currentNode.data.dataSetId,
        operationType: currentNode.data.operationType,
        queryConditionGroups: currentNode.data.queryConditionGroups || [],
        operationData: currentNode.data.operationData || {},
        mappedFields: currentNode.data.mappedFields || []
      };
      
      console.log('=== ?? DataSet ?? ===');
      console.log('????:', requestData);
      
      // ?????????????????
      let processedConditionGroups = requestData.queryConditionGroups;
      if (requestData.operationType === 'SELECT' && Object.keys(pvSimulationData).length > 0) {
        processedConditionGroups = requestData.queryConditionGroups.map(group => ({
          ...group,
          conditions: group.conditions.map(condition => ({
            ...condition,
            value: condition.value.replace(/\$\{([^}]+)\}/g, (match, variableName) => {
              return pvSimulationData[variableName] || match;
            })
          }))
        }));
      }
      
      // ?? SQL ??
      const whereClause = generateWhereClause(processedConditionGroups);
      console.log(t('workflowDesigner.dataSet.generatedWhereClause') + ':', whereClause);
      
      // ??????
      const previewInfo = {
        DataSet: dataSets.find(ds => ds.id === requestData.dataSetId)?.name || '??',
        [t('workflowDesigner.dataSet.operationType')]: requestData.operationType,
        [t('workflowDesigner.dataSet.queryConditions')]: whereClause || t('workflowDesigner.dataSet.noQueryConditions'),
        [t('workflowDesigner.dataSet.operationData')]: Object.keys(requestData.operationData).length > 0 ? JSON.stringify(requestData.operationData) : t('workflowDesigner.dataSet.noOperationData'),
        [t('workflowDesigner.dataSet.fieldMapping')]: requestData.mappedFields.length > 0 ? 
          requestData.mappedFields.map(m => `${m.fieldName} ? $${m.variableName}`).join(', ') : t('workflowDesigner.dataSet.noFieldMapping')
      };
      
      console.log('????:', previewInfo);
      
      // ????????
      setQueryPreviewData([]); // ?????
      setQueryPreviewModalVisible(true);
      
      // ??? SELECT ?????????????????
      if (requestData.operationType === 'SELECT' && Object.keys(pvSimulationData).length > 0) {
        try {
          // ????? API ??????
          const response = await fetch('/api/datasets/preview', {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('token')}`,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              dataSetId: currentNode?.data?.dataSetId || selectedNode?.data?.dataSetId,
              whereClause,
              limit: 10,
              processVariableValues: pvSimulationData
            })
          });

          if (!response.ok) {
            const errorText = await response.text();
            console.error('API ????:', errorText);
            throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
          }

          const result = await response.json();
          console.log('API ????:', result);

          if (result.success && result.data) {
            setQueryPreviewData(result.data);
            const total = result.totalCount ?? result.data.length;
            message.success(`??????? ${total} ????`);
          } else {
            throw new Error(result.message || '????????');
          }
        } catch (previewError) {
          console.error('????????:', previewError);
          message.error(t('workflowDesigner.dataSet.previewFailed', { message: previewError.message }));
        } finally {
          setTestingOperation(false);
        }
      } else {
        // ? SELECT ?????????????????
        message.success('?????????????????????????');
      }
      
    } catch (error) {
      console.error('??????:', error);
      message.error('??????: ' + error.message);
    } finally {
      setTestingOperation(false);
    }
  };

  // ?? onValuesChange ????
  const handleFormValuesChange = useCallback((changedValues, allValues) => {
    // ???? taskName ???taskName ?? onBlur ????
    const { taskName, ...otherValues } = changedValues;
    if (Object.keys(otherValues).length > 0) {
      // ???? validation ????????????????
      if (otherValues.validation) {
        otherValues.validation = {
          ...(selectedNode?.data?.validation || {}),
          ...otherValues.validation
        };

        const validatorType = otherValues.validation.validatorType?.toLowerCase();
        if (validatorType === 'ai') {
          if (!otherValues.validation.aiProviderKey && aiProviders.length > 0) {
            const fallback = aiProviders.find(p => p.active) || aiProviders[0];
            if (fallback) {
              otherValues.validation.aiProviderKey = fallback.providerKey;
            }
          }
        }

        if (!otherValues.aiProviderKey && otherValues.validation.aiProviderKey) {
          otherValues.aiProviderKey = otherValues.validation.aiProviderKey;
        }
      }
      
      // ???? emailConfig ??????????????
      // ????? emailConfig ???????
      const hasEmailConfigChange = otherValues.emailConfig || 
        changedValues['emailConfig.providerKey'] !== undefined || 
        changedValues['emailConfig.subject'] !== undefined || 
        changedValues['emailConfig.body'] !== undefined;
      
      if (hasEmailConfigChange) {
        const currentEmailConfig = selectedNode?.data?.emailConfig || {};
        const newEmailConfig = {
          ...currentEmailConfig,
          // ???? changedValues ??????? otherValues.emailConfig???????
          providerKey: changedValues['emailConfig.providerKey'] !== undefined 
            ? changedValues['emailConfig.providerKey'] 
            : (otherValues.emailConfig?.providerKey !== undefined ? otherValues.emailConfig.providerKey : currentEmailConfig.providerKey || ''),
          subject: changedValues['emailConfig.subject'] !== undefined 
            ? changedValues['emailConfig.subject'] 
            : (otherValues.emailConfig?.subject !== undefined ? otherValues.emailConfig.subject : currentEmailConfig.subject || ''),
          body: changedValues['emailConfig.body'] !== undefined 
            ? changedValues['emailConfig.body'] 
            : (otherValues.emailConfig?.body !== undefined ? otherValues.emailConfig.body : currentEmailConfig.body || ''),
          replyTo: otherValues.emailConfig?.replyTo !== undefined 
            ? otherValues.emailConfig.replyTo 
            : (currentEmailConfig.replyTo || ''),
        };
        otherValues.emailConfig = newEmailConfig;
        // ????????????????? emailConfig ???
        delete otherValues['emailConfig.providerKey'];
        delete otherValues['emailConfig.subject'];
        delete otherValues['emailConfig.body'];
        console.log('?? NodePropertyDrawer.handleFormValuesChange - emailConfig:', newEmailConfig);
      }

      // Email ???tag ???? array???? string????????? split
      const tagKeys = ['emailFilterSender', 'emailFilterSubject', 'emailFilterKeywordsRequired', 'emailFilterSenderNot', 'emailFilterSubjectNot', 'emailFilterBodyKeywordsNot', 'emailFilterAttachmentExtensions', 'emailFilterAttachmentFileName', 'emailFilterAttachmentFileNameNot'];
      tagKeys.forEach(key => {
        if (otherValues[key] !== undefined && Array.isArray(otherValues[key])) {
          otherValues[key] = otherValues[key].filter(Boolean).join(',');
        }
      });
      if (otherValues.emailFilterSubject !== undefined) {
        otherValues.emailFilterBodyKeywords = '';
      }
      
      // ?? setTimeout ???????????????
      setTimeout(() => {
        handleNodeDataChange(otherValues);
      }, 0);
    }
  }, [handleNodeDataChange, selectedNode, aiProviders]);

  if (!selectedNode) return null;

  const aiStaffSelectProps = {
    selectedNode,
    aiStaffs,
    aiStaffOptions,
    loadingAiStaffs,
    handleAiStaffChange,
    handleNodeDataChange,
    t,
  };

  // Timeout Complete ??? TabPane???????????????
  const renderTimeoutCompleteTabPane = () => {
    if (!selectedNode) return null;
    const tcIsActive = selectedNode.data.validation?.timeoutCompleteIsActive ?? false;
    const updateTimeoutComplete = (patch) => {
      handleNodeDataChange({
        validation: { ...(selectedNode.data.validation || {}), ...patch }
      });
    };
    return (
      <Tabs.TabPane tab={t('workflowDesigner.timeoutCompleteValidatorLabel')} key="timeout-complete">
        <Form.Item
          label={t('workflowDesigner.validatorActiveLabel')}
          name={['validation', 'timeoutCompleteIsActive']}
          valuePropName="checked"
        >
          <Switch
            className="validator-switch"
            checkedChildren={t('workflowDesigner.active')}
            unCheckedChildren={t('workflowDesigner.inactive')}
            onChange={(checked) => handleValidatorToggle('timeout-complete', checked)}
          />
        </Form.Item>
        {tcIsActive && activeValidatorTab === 'timeout-complete' && (
          <>
            <Alert
              type="info"
              showIcon
              message={t('workflowDesigner.timeoutComplete.description')}
              style={{ marginBottom: 12 }}
            />
            <Form.Item label={t('workflowDesigner.timeoutComplete.timeoutInterval')}>
              <div style={{
                display: 'grid',
                gridTemplateColumns: isFullscreen ? '1fr 1fr 1fr' : '1fr',
                gap: isFullscreen ? '12px' : '8px'
              }}>
                <Input
                  type="number"
                  min="0"
                  placeholder="0"
                  value={selectedNode.data.validation?.timeoutCompleteDays ?? 0}
                  onChange={(e) => updateTimeoutComplete({ timeoutCompleteDays: parseInt(e.target.value) || 0 })}
                  addonAfter={t('workflowDesigner.days')}
                />
                <Input
                  type="number"
                  min="0"
                  max="23"
                  placeholder="0"
                  value={selectedNode.data.validation?.timeoutCompleteHours ?? 0}
                  onChange={(e) => updateTimeoutComplete({ timeoutCompleteHours: parseInt(e.target.value) || 0 })}
                  addonAfter={t('workflowDesigner.hours')}
                />
                <Input
                  type="number"
                  min="0"
                  max="59"
                  placeholder="0"
                  value={selectedNode.data.validation?.timeoutCompleteMinutes ?? 0}
                  onChange={(e) => updateTimeoutComplete({ timeoutCompleteMinutes: parseInt(e.target.value) || 0 })}
                  addonAfter={t('workflowDesigner.minutes')}
                />
              </div>
            </Form.Item>
            <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>
              {t('workflowDesigner.timeoutComplete.hint')}
            </div>
          </>
        )}
      </Tabs.TabPane>
    );
  };

  return (
    <>
      <Drawer
        title={
          selectedNode ? (
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginRight: 40 }}>
              <span>{t(`workflowDesigner.${selectedNode.data.type}Node`)}</span>
              <Button
                type="text"
                icon={isFullscreen ? <FullscreenExitOutlined /> : <FullscreenOutlined />}
                onClick={(e) => {
                  e.stopPropagation();
                  setIsFullscreen(!isFullscreen);
                }}
                style={{ 
                  marginLeft: 8,
                  fontSize: 16,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
                title={isFullscreen ? t('workflowDesigner.exitFullscreen') : t('workflowDesigner.enterFullscreen')}
              />
            </div>
          ) : ''
        }
        placement="right"
        open={drawerOpen}
        onClose={() => {
          setDrawerOpen(false);
          setIsFullscreen(false); // ?????????
        }}
        width={isFullscreen ? '100%' : 340}
        style={{
          transition: 'width 0.3s ease'
        }}
      >
        <div
          className={`wfd-property-drawer-body${isFullscreen ? ' wfd-drawer-fullscreen' : ''}`}
          style={{
            maxWidth: isFullscreen ? '1200px' : '100%',
            margin: isFullscreen ? '0 auto' : '0',
            padding: isFullscreen ? '20px 40px' : '0'
          }}
        >
        {selectedNode && selectedNode.data.type !== 'start' && (
          <Form
            form={form}
            key={selectedNode.id}
            layout="vertical"
            onValuesChange={handleFormValuesChange}
          >
            <Form.Item label={t('workflowDesigner.taskNameLabel')} name="taskName">
              <Input 
                placeholder={t('workflowDesigner.taskNamePlaceholder')}
                onBlur={(e) => {
                  const value = e.target.value;
                  if (value !== selectedNode.data.taskName) {
                    handleNodeDataChange({ taskName: value });
                  }
                }}
              />
            </Form.Item>
            
            {/* ?? WhatsApp ???? - ??????????? */}
            {selectedNode.data.type === 'sendWhatsApp' && (
              <PropertySectionTabs
                resetKey={selectedNode.id}
                sections={[
                  {
                    key: 'recipientAndMessage',
                    icon: <MessageOutlined />,
                    tooltip: t('workflowDesigner.sectionRecipientAndMessage'),
                    children: (
                      <>
                      <Form.Item label={t('workflow.to')}>
                        <div style={{ position: 'relative' }}>
                          <RecipientSelector
                            value={selectedNode.data.to || ''}
                            recipientDetails={selectedNode.data.recipientDetails}
                            placeholder={t('workflowDesigner.selectRecipients')}
                            compact={true}
                            workflowDefinitionId={workflowId}
                            t={t}
                            onChange={(value, detailedValue) => {
                              if (value === '' && detailedValue === null) {
                                setIsRecipientModalVisible(true);
                              } else {
                                handleNodeDataChange({
                                  to: value,
                                  recipientDetails: detailedValue
                                });
                              }
                            }}
                          />
                          <div style={{
                            position: 'absolute',
                            right: '8px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            display: 'flex',
                            gap: '4px'
                          }}>
                            {selectedNode.data.to && (
                              <Button
                                type="text"
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleNodeDataChange({ to: '', recipientDetails: { users: [], contacts: [], groups: [], hashtags: [], useInitiator: false, phoneNumbers: [] } });
                                }}
                                style={{ padding: '0 4px', fontSize: '12px' }}
                              >
                                {t('workflowDesigner.clear')}
                              </Button>
                            )}
                          </div>
                        </div>
                      </Form.Item>
                        <MessageModeTabsComponent
                          selectedNode={selectedNode}
                          handleNodeDataChange={handleNodeDataChange}
                          setIsTemplateModalVisible={setIsTemplateModalVisible}
                          processVariables={processVariables}
                          form={form}
                          t={t}
                          messageLabel={t('workflow.message')}
                          messagePlaceholder={t('workflowDesigner.messageWithVariablesPlaceholder')}
                          messageRows={3}
                          showProcessVariables={true}
                          enableEmailMode={true}
                          metaTemplates={metaTemplates}
                        />

                        {selectedNode.data.templateId &&
                         (selectedNode.data.messageMode === 'template' || selectedNode.data.messageMode === 'metaTemplate') &&
                         (selectedNode.data.templateHeaderType === 'image' || selectedNode.data.templateHeaderType === 'document') && (
                          <>
                            <Divider />
                            {selectedNode.data.templateHeaderType === 'image' && (
                              <Form.Item label={t('workflowDesigner.templateImageSource')}>
                                <Radio.Group
                                  value={selectedNode.data.templateHeaderImageSource || 'url'}
                                  onChange={(e) => {
                                    handleNodeDataChange({
                                      templateHeaderImageSource: e.target.value,
                                      templateHeaderUrl: e.target.value === 'instance' ? '' : selectedNode.data.templateHeaderUrl
                                    });
                                  }}
                                >
                                  <Radio value="url">{t('workflowDesigner.templateImageSourceUrl')}</Radio>
                                  <Radio value="instance">{t('workflowDesigner.templateImageSourceInstance')}</Radio>
                                </Radio.Group>
                                <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                                  {t('workflowDesigner.templateImageSourceHelp')}
                                </div>
                              </Form.Item>
                            )}
                            {(selectedNode.data.templateHeaderType === 'document' ||
                              (selectedNode.data.templateHeaderType === 'image' && (selectedNode.data.templateHeaderImageSource === 'url' || !selectedNode.data.templateHeaderImageSource))) && (
                              <Form.Item
                                label={
                                  selectedNode.data.templateHeaderType === 'image'
                                    ? t('workflowDesigner.templateImageUrl')
                                    : t('workflowDesigner.templateDocumentUrl')
                                }
                              >
                                <div style={{ marginBottom: 8 }}>
                                  <Input
                                    placeholder={
                                      selectedNode.data.templateHeaderType === 'image'
                                        ? t('workflowDesigner.templateImageUrlPlaceholder')
                                        : t('workflowDesigner.templateDocumentUrlPlaceholder')
                                    }
                                    value={selectedNode.data.templateHeaderUrl || ''}
                                    onChange={(e) => {
                                      handleNodeDataChange({ templateHeaderUrl: e.target.value });
                                    }}
                                    onFocus={() => setActiveFlowField('templateHeaderUrl')}
                                  />
                                  <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                                    {t('workflowDesigner.templateHeaderUrlHelp')}
                                  </div>
                                </div>
                                <ProcessVariablesDisplay
                                  processVariables={processVariables}
                                  form={form}
                                  t={t}
                                  targetFieldName="templateHeaderUrl"
                                  onInsert={(variableName) => {
                                    const currentValue = selectedNode.data.templateHeaderUrl || '';
                                    const newValue = currentValue + `\${${variableName}}`;
                                    handleNodeDataChange({ templateHeaderUrl: newValue });
                                  }}
                                  showLabel={true}
                                />
                              </Form.Item>
                            )}

                            {selectedNode.data.templateHeaderType === 'document' && (
                              <Form.Item label={t('workflowDesigner.templateDocumentFilename')}>
                                <div style={{ marginBottom: 8 }}>
                                  <Input
                                    placeholder={t('workflowDesigner.templateDocumentFilenamePlaceholder')}
                                    value={selectedNode.data.templateHeaderFilename || ''}
                                    onChange={(e) => {
                                      handleNodeDataChange({ templateHeaderFilename: e.target.value });
                                    }}
                                    onFocus={() => setActiveFlowField('templateHeaderFilename')}
                                  />
                                  <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                                    {t('workflowDesigner.templateDocumentFilenameHelp')}
                                  </div>
                                </div>
                                <ProcessVariablesDisplay
                                  processVariables={processVariables}
                                  form={form}
                                  t={t}
                                  targetFieldName="templateHeaderFilename"
                                  onInsert={(variableName) => {
                                    const currentValue = selectedNode.data.templateHeaderFilename || '';
                                    const newValue = currentValue + `\${${variableName}}`;
                                    handleNodeDataChange({ templateHeaderFilename: newValue });
                                  }}
                                  showLabel={true}
                                />
                              </Form.Item>
                            )}
                          </>
                        )}
                      </>
                    ),
                  },
                ]}
              />
            )}

            {/* WhatsApp Shopping Cart ???product_list ? ?? collection ??? */}
            {selectedNode.data.type === 'sendWhatsAppShoppingCart' && (
              <PropertySectionTabs
                resetKey={selectedNode.id}
                sections={[
                  {
                    key: 'recipient',
                    icon: <UserOutlined />,
                    tooltip: t('workflowDesigner.sectionRecipient'),
                    children: (
                      <Form.Item label={t('workflow.to')}>
                        <div style={{ position: 'relative' }}>
                          <RecipientSelector
                            value={selectedNode.data.to || ''}
                            recipientDetails={selectedNode.data.recipientDetails}
                            placeholder={t('workflowDesigner.selectRecipients')}
                            compact={true}
                            workflowDefinitionId={workflowId}
                            t={t}
                            onChange={(value, detailedValue) => {
                              if (value === '' && detailedValue === null) {
                                setIsRecipientModalVisible(true);
                              } else {
                                handleNodeDataChange({ to: value, recipientDetails: detailedValue });
                              }
                            }}
                          />
                          {selectedNode.data.to && (
                            <Button
                              type="text"
                              size="small"
                              style={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)' }}
                              onClick={() => handleNodeDataChange({ to: '', recipientDetails: { users: [], contacts: [], groups: [], hashtags: [], useInitiator: false, phoneNumbers: [] } })}
                            >
                              {t('workflowDesigner.clear')}
                            </Button>
                          )}
                        </div>
                      </Form.Item>
                    ),
                  },
                  {
                    key: 'commerce',
                    icon: <ShoppingCartOutlined />,
                    tooltip: t('workflowDesigner.sectionCommerce'),
                    children: (
                      <>
                        <Form.Item label={t('workflowDesigner.shoppingCartMode')}>
                          <Select
                            value={selectedNode.data.shoppingCartMode || 'select_collection'}
                            onChange={(v) => handleNodeDataChange({ shoppingCartMode: v || 'select_collection' })}
                            options={[
                              { value: 'select_collection', label: t('workflowDesigner.shoppingCartModeSelectCollection') },
                              { value: 'send_collection_options', label: t('workflowDesigner.shoppingCartModeSendCollectionOptions') }
                            ]}
                          />
                        </Form.Item>
                        {(selectedNode.data.shoppingCartMode || 'select_collection') === 'select_collection' && (
                          <Form.Item label={t('workflowDesigner.shoppingCartSelectCollection')} required>
                            <Select
                              allowClear
                              showSearch
                              placeholder={t('workflowDesigner.shoppingCartSelectCollectionPlaceholder')}
                              loading={loadingCommerceCollections}
                              value={selectedNode.data.collectionId || undefined}
                              onChange={(id) => handleNodeDataChange({ collectionId: id || null })}
                              optionFilterProp="label"
                              filterOption={(input, opt) => (opt?.label ?? '').toLowerCase().includes((input || '').toLowerCase())}
                              options={commerceCollections.map(c => ({
                                value: c.id ?? c.Id,
                                label: (c.name ?? c.Name) || (c.id ?? c.Id)
                              }))}
                              notFoundContent={loadingCommerceCollections ? t('workflowDesigner.loading') : t('workflowDesigner.noCollections')}
                            />
                          </Form.Item>
                        )}
                        <Form.Item label={t('workflowDesigner.shoppingCartBody')} required>
                          <Input.TextArea
                            rows={3}
                            value={selectedNode.data.body ?? ''}
                            onChange={(e) => handleNodeDataChange({ body: e.target.value })}
                            placeholder={t('workflowDesigner.shoppingCartBodyPlaceholder')}
                          />
                        </Form.Item>
                        <Form.Item label={t('workflowDesigner.shoppingCartHeader')}>
                          <Input
                            value={selectedNode.data.header ?? ''}
                            onChange={(e) => handleNodeDataChange({ header: e.target.value })}
                            placeholder={t('workflowDesigner.shoppingCartHeaderPlaceholder')}
                          />
                        </Form.Item>
                        <Form.Item label={t('workflowDesigner.shoppingCartFooter')}>
                          <Input
                            value={selectedNode.data.footer ?? ''}
                            onChange={(e) => handleNodeDataChange({ footer: e.target.value })}
                            placeholder={t('workflowDesigner.shoppingCartFooterPlaceholder')}
                          />
                        </Form.Item>
                        <Alert type="info" showIcon message={t('workflowDesigner.shoppingCart24hHint')} style={{ marginBottom: 12 }} />
                      </>
                    ),
                  },
                ]}
              />
            )}

            {/* Institution Ordering Cart ???Flows ?????? */}
            {selectedNode.data.type === 'sendInstitutionOrderingCart' && (
              <PropertySectionTabs
                resetKey={selectedNode.id}
                sections={[
                  {
                    key: 'commerce',
                    icon: <ShoppingCartOutlined />,
                    tooltip: t('workflowDesigner.sectionCommerce'),
                    children: (
              <>
                <Divider orientation="left" plain>{t('workflowDesigner.institutionOrderingCartFlowMessageTitle')}</Divider>
                <Form.Item label={t('workflowDesigner.institutionOrderingCartFlowMessageHeader')}>
                  <Input
                    value={selectedNode.data.flowMessageHeader ?? ''}
                    onChange={(e) => handleNodeDataChange({ flowMessageHeader: e.target.value || undefined })}
                    placeholder={t('workflowDesigner.institutionOrderingCartFlowMessageHeaderPlaceholder')}
                  />
                </Form.Item>
                <Form.Item label={t('workflowDesigner.institutionOrderingCartFlowMessageBody')}>
                  <Input
                    value={selectedNode.data.flowMessageBody ?? ''}
                    onChange={(e) => handleNodeDataChange({ flowMessageBody: e.target.value || undefined })}
                    placeholder={t('workflowDesigner.institutionOrderingCartFlowMessageBodyDefault')}
                  />
                </Form.Item>
                <Form.Item label={t('workflowDesigner.institutionOrderingCartFlowMessageButton')}>
                  <Input
                    value={selectedNode.data.flowMessageButton ?? ''}
                    onChange={(e) => handleNodeDataChange({ flowMessageButton: e.target.value || undefined })}
                    placeholder={t('workflowDesigner.institutionOrderingCartFlowMessageButtonDefault')}
                  />
                </Form.Item>
                <Form.Item label={t('workflowDesigner.institutionOrderingCartFlowTemplate')}>
                  <Input
                    value={selectedNode.data.flowTemplateName ?? 'institution_ordering_cart'}
                    onChange={(e) => handleNodeDataChange({ flowTemplateName: e.target.value || 'institution_ordering_cart' })}
                    placeholder="institution_ordering_cart"
                  />
                </Form.Item>
                <Form.Item label={t('workflowDesigner.institutionOrderingCartFlowLanguage')}>
                  <Select
                    value={selectedNode.data.flowLanguage ?? 'zh_TW'}
                    onChange={(v) => handleNodeDataChange({ flowLanguage: v || 'zh_TW' })}
                    style={{ width: '100%' }}
                    options={[
                      { label: t('workflowDesigner.institutionOrderingCartLangZhTW'), value: 'zh_TW' },
                      { label: t('workflowDesigner.institutionOrderingCartLangZhCN'), value: 'zh_CN' },
                      { label: t('workflowDesigner.institutionOrderingCartLangEn'), value: 'en' }
                    ]}
                  />
                </Form.Item>
                <Form.Item label={t('workflowDesigner.institutionOrderingCartCompanyForTemplate')}>
                  <Select
                    placeholder={t('workflowDesigner.institutionOrderingCartSelectCompany')}
                    value={selectedNode.data.flowTemplateCompanyId || undefined}
                    onChange={(v) => handleNodeDataChange({ flowTemplateCompanyId: v || null })}
                    allowClear
                    style={{ width: '100%' }}
                    options={companiesForFlowTemplate.map((c) => ({
                      label: (c.name ?? c.Name) || (c.id ?? c.Id),
                      value: c.id ?? c.Id
                    }))}
                  />
                </Form.Item>
                <Form.Item>
                  <Button
                    type="primary"
                    loading={createFlowTemplateLoading}
                    onClick={async () => {
                      const companyId = selectedNode.data.flowTemplateCompanyId || companiesForFlowTemplate[0]?.id || companiesForFlowTemplate[0]?.Id;
                      if (!companyId) {
                        message.warning(t('workflowDesigner.institutionOrderingCartSelectCompanyFirst'));
                        return;
                      }
                      const lang = selectedNode.data.flowLanguage ?? 'zh_TW';
                      setCreateFlowTemplateLoading(true);
                      const log = '[InstitutionOrderingCart] create-flow-template';
                      const payload = {
                        companyId,
                        templateName: selectedNode.data.flowTemplateName ?? 'institution_ordering_cart',
                        language: lang,
                        workflowName: workflowName || undefined,
                        flowMessageHeader: selectedNode.data.flowMessageHeader?.trim() || undefined,
                        flowMessageBody: selectedNode.data.flowMessageBody?.trim() || undefined,
                        flowMessageButton: selectedNode.data.flowMessageButton?.trim() || undefined
                      };
                      console.log(`${log} ??`, { ...payload, _note: '?? token' });
                      try {
                        const token = localStorage.getItem('token');
                        const res = await fetch('/api/institution-ordering-cart/create-flow-template', {
                          method: 'POST',
                          headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json'
                          },
                          body: JSON.stringify(payload)
                        });
                        const raw = await res.text();
                        let result = {};
                        try {
                          result = raw ? JSON.parse(raw) : {};
                        } catch (parseErr) {
                          console.error(`${log} ??? JSON`, {
                            status: res.status,
                            statusText: res.statusText,
                            rawLength: raw?.length,
                            rawPreview: (raw && raw.length > 0) ? raw.slice(0, 2000) : ''
                          });
                          message.error(
                            t('workflowDesigner.institutionOrderingCartCreateFailed') +
                            ` (HTTP ${res.status}, ? JSON ??)`
                          );
                          return;
                        }
                        if (!res.ok) {
                          const part = [result.error, result.detail && `??: ${result.detail}`]
                            .filter(Boolean)
                            .join(' ');
                          const modelMsg = result.message && typeof result.message === 'string' ? result.message : '';
                          const flatFromServer = Array.isArray(result.errorMessages) && result.errorMessages.length
                            ? result.errorMessages[0] : '';
                          const firstModelErr = flatFromServer || (() => {
                            const e = result.errors;
                            if (!e || typeof e !== 'object') return '';
                            for (const key of Object.keys(e)) {
                              const v = e[key];
                              if (v && Array.isArray(v) && v.length) {
                                return `${key}: ${v[0]}`;
                              }
                              if (v && typeof v === 'object' && Array.isArray(v?.errors) && v.errors[0]) {
                                const m = v.errors[0].errorMessage || v.errors[0].ErrorMessage;
                                if (m) return `${key}: ${m}`;
                              }
                            }
                            return '';
                          })();
                          const combined = [part, modelMsg && (part ? `?${modelMsg}?` : modelMsg), firstModelErr]
                            .filter(Boolean)
                            .join(' ? ');
                          console.error(`${log} ??`, {
                            status: res.status,
                            statusText: res.statusText,
                            traceId: result.traceId,
                            result,
                            raw: raw?.length > 0 ? raw.slice(0, 3000) : undefined
                          });
                          message.error(
                            combined ||
                            res.statusText ||
                            t('workflowDesigner.institutionOrderingCartCreateFailed') +
                            (result.traceId ? ` [trace: ${result.traceId}]` : '')
                          );
                          return;
                        }
                        console.log(`${log} ??`, { traceId: result.traceId, result });
                        if (result.flowTemplateName) {
                          handleNodeDataChange({ flowTemplateName: result.flowTemplateName });
                        }
                        setFlowTemplatePreview(result);
                        setFlowTemplatePreviewModalVisible(true);
                        message.success(t('workflowDesigner.institutionOrderingCartCreateSuccess'));
                      } catch (e) {
                        console.error(`${log} ??`, e);
                        message.error(e?.message || t('workflowDesigner.institutionOrderingCartCreateFailed'));
                      } finally {
                        setCreateFlowTemplateLoading(false);
                      }
                    }}
                  >
                    {t('workflowDesigner.institutionOrderingCartCreateTemplateButton')}
                  </Button>
                </Form.Item>
                <Alert type="info" showIcon message={t('workflowDesigner.institutionOrderingCartHint')} style={{ marginBottom: 8 }} />
                <Alert type="info" showIcon message={t('workflowDesigner.institutionOrderingCart24hTemplateNote')} style={{ marginBottom: 8 }} />
                <div style={{ marginBottom: 12, color: 'rgba(0,0,0,0.45)', fontSize: 12 }}>{t('workflowDesigner.institutionOrderingCartSettingsSummary')}</div>
              </>
                    ),
                  },
                  {
                    key: 'recipient',
                    icon: <UserOutlined />,
                    tooltip: t('workflowDesigner.sectionRecipient'),
                    children: (
                      <Form.Item label={t('workflow.to')}>
                        <div style={{ position: 'relative' }}>
                          <RecipientSelector
                            value={selectedNode.data.to || ''}
                            recipientDetails={selectedNode.data.recipientDetails}
                            placeholder={t('workflowDesigner.selectRecipients')}
                            compact={true}
                            workflowDefinitionId={workflowId}
                            t={t}
                            onChange={(value, detailedValue) => {
                              if (value === '' && detailedValue === null) {
                                setIsRecipientModalVisible(true);
                              } else {
                                handleNodeDataChange({ to: value, recipientDetails: detailedValue });
                              }
                            }}
                          />
                          {selectedNode.data.to && (
                            <Button
                              type="text"
                              size="small"
                              style={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)' }}
                              onClick={() => handleNodeDataChange({ to: '', recipientDetails: { users: [], contacts: [], groups: [], hashtags: [], useInitiator: false, phoneNumbers: [] } })}
                            >
                              {t('workflowDesigner.clear')}
                            </Button>
                          )}
                        </div>
                      </Form.Item>
                    ),
                  },
                ]}
              />
            )}

            {/* ??????? */}
            {selectedNode.data.type === 'chatOrderingCart' && (
              <PropertySectionTabs
                resetKey={selectedNode.id}
                sections={[
                  {
                    key: 'recipientAndMessage',
                    icon: <MessageOutlined />,
                    tooltip: t('workflowDesigner.sectionRecipientAndMessage'),
                    children: (
                      <>
                        <Form.Item label={t('workflowDesigner.replyType')}>
                          <Select
                            value={selectedNode.data.replyType || 'initiator'}
                            onChange={(v) => handleNodeDataChange({ replyType: v })}
                            options={[
                              { value: 'initiator', label: t('workflowDesigner.initiator') },
                              { value: 'specified', label: t('workflowDesigner.specifiedPerson') }
                            ]}
                          />
                        </Form.Item>
                        {selectedNode.data.replyType === 'specified' && (
                          <Form.Item label={t('workflowDesigner.specifiedPerson')}>
                            <RecipientSelector
                              value={selectedNode.data.specifiedUsers || ''}
                              recipientDetails={selectedNode.data.recipientDetails}
                              placeholder={t('workflowDesigner.selectRecipients')}
                              compact={true}
                              workflowDefinitionId={workflowId}
                              onChange={(value, detailedValue) => {
                                if (value === '' && detailedValue === null) {
                                  setIsRecipientModalVisible(true);
                                } else {
                                  handleNodeDataChange({ specifiedUsers: value, recipientDetails: detailedValue });
                                }
                              }}
                            />
                          </Form.Item>
                        )}

                        <Divider orientation="left" plain>{t('workflowDesigner.chatOrderingCartInitialGreeting')}</Divider>
                        <Form.Item label={t('workflowDesigner.chatOrderingCartInitialGreeting')}>
                          <Input.TextArea
                            rows={2}
                            value={selectedNode.data.initialGreetingMessage || ''}
                            onChange={(e) => handleNodeDataChange({ initialGreetingMessage: e.target.value })}
                            placeholder={t('workflowDesigner.chatOrderingCartInitialGreetingPlaceholder')}
                          />
                        </Form.Item>
                        {renderPromptVariablesDisplay('initialGreetingMessage')}
                        <Form.Item label={t('workflowDesigner.chatOrderingCartReconfirmQuestion')}>
                          <Input
                            value={selectedNode.data.reconfirmQuestion || ''}
                            onChange={(e) => handleNodeDataChange({ reconfirmQuestion: e.target.value })}
                            placeholder={t('workflowDesigner.chatOrderingCartReconfirmQuestionPlaceholder')}
                          />
                        </Form.Item>
                        {renderPromptVariablesDisplay('reconfirmQuestion')}
                        <Form.Item label={t('workflowDesigner.chatOrderingCartMissingInfoExtra')}>
                          <Input.TextArea
                            rows={2}
                            value={selectedNode.data.missingInfoPromptExtra || ''}
                            onChange={(e) => handleNodeDataChange({ missingInfoPromptExtra: e.target.value })}
                          />
                        </Form.Item>
                        {renderPromptVariablesDisplay('missingInfoPromptExtra')}
                        <Form.Item
                          label={t('workflowDesigner.chatOrderingCartAdditionalPrompt')}
                          tooltip={t('workflowDesigner.chatOrderingCartAdditionalPromptHelp')}
                        >
                          <Input.TextArea
                            rows={3}
                            value={selectedNode.data.additionalPrompt || ''}
                            onChange={(e) => handleNodeDataChange({ additionalPrompt: e.target.value })}
                            placeholder={t('workflowDesigner.chatOrderingCartAdditionalPromptPlaceholder')}
                          />
                        </Form.Item>
                        {renderPromptVariablesDisplay('additionalPrompt')}
                        <Form.Item label={t('workflowDesigner.chatOrderingCartEndKeywords')}>
                          <Select
                            mode="tags"
                            style={{ width: '100%' }}
                            placeholder={t('workflowDesigner.chatOrderingCartEndKeywordsPlaceholder')}
                            value={selectedNode.data.endKeywords || []}
                            onChange={(v) => handleNodeDataChange({ endKeywords: Array.isArray(v) ? v : [] })}
                            tokenSeparators={[',']}
                          />
                        </Form.Item>

                        <Divider orientation="left" plain>Buttons</Divider>
                        <Form.Item label={t('workflowDesigner.chatOrderingCartBtnConfirmLabel')}>
                          <Input
                            value={selectedNode.data.btnConfirmLabel || ''}
                            onChange={(e) => handleNodeDataChange({ btnConfirmLabel: e.target.value })}
                            placeholder="????"
                          />
                        </Form.Item>
                        <Form.Item label={t('workflowDesigner.chatOrderingCartBtnModifyLabel')}>
                          <Input
                            value={selectedNode.data.btnModifyLabel || ''}
                            onChange={(e) => handleNodeDataChange({ btnModifyLabel: e.target.value })}
                            placeholder="??"
                          />
                        </Form.Item>
                        <Form.Item label={t('workflowDesigner.chatOrderingCartBtnCancelLabel')}>
                          <Input
                            value={selectedNode.data.btnCancelLabel || ''}
                            onChange={(e) => handleNodeDataChange({ btnCancelLabel: e.target.value })}
                            placeholder="??"
                          />
                        </Form.Item>
                        <Form.Item label={t('workflowDesigner.chatOrderingCartSystemPromptOverride')}>
                          <Input.TextArea
                            rows={4}
                            value={selectedNode.data.systemPromptOverride || ''}
                            onChange={(e) => handleNodeDataChange({ systemPromptOverride: e.target.value })}
                            placeholder={t('workflowDesigner.chatOrderingCartSystemPromptOverridePlaceholder')}
                          />
                        </Form.Item>
                        {renderPromptVariablesDisplay('systemPromptOverride')}
                      </>
                    ),
                  },
                  {
                    key: 'commerce',
                    icon: <ShoppingCartOutlined />,
                    tooltip: t('workflowDesigner.sectionCommerce'),
                    children: (
                      <>
                        <Divider orientation="left" plain>{t('workflowDesigner.chatOrderingCartTargetCompany')}</Divider>
                        {chatCartIsTenantAdmin ? (
                          <Form.Item label={t('workflowDesigner.chatOrderingCartTargetCompany')}>
                            <Select
                              placeholder={t('workflowDesigner.institutionOrderingCartSelectCompany')}
                              value={selectedNode.data.targetCompanyId || undefined}
                              onChange={(v) => handleNodeDataChange({ targetCompanyId: v || '' })}
                              allowClear
                              style={{ width: '100%' }}
                              options={companiesForFlowTemplate.map((c) => ({
                                label: (c.name ?? c.Name) || (c.id ?? c.Id),
                                value: c.id ?? c.Id
                              }))}
                            />
                          </Form.Item>
                        ) : (
                          <Alert type="info" showIcon message={t('workflowDesigner.chatOrderingCartTargetCompany') + ': ' + (t('workflowDesigner.institutionOrderingCartSettingsSummary') || '')} style={{ marginBottom: 12 }} />
                        )}

                        <Form.Item label={t('workflowDesigner.chatOrderingCartProductLanguage')}>
                          <Select
                            value={selectedNode.data.productLanguage || 'zh_TC'}
                            onChange={(v) => handleNodeDataChange({ productLanguage: v || 'zh_TC' })}
                            style={{ width: '100%' }}
                            options={[
                              { label: '???? (zh_TC)', value: 'zh_TC' },
                              { label: '???? (zh_SC)', value: 'zh_SC' },
                              { label: 'English (en)', value: 'en' }
                            ]}
                          />
                        </Form.Item>

                        <Form.Item
                          label={t('workflowDesigner.chatOrderingCartProductNlFilterFields')}
                          tooltip={t('workflowDesigner.chatOrderingCartProductNlFilterFieldsHelp')}
                        >
                          <Select
                            mode="multiple"
                            allowClear
                            style={{ width: '100%' }}
                            placeholder={t('workflowDesigner.chatOrderingCartProductNlFilterFields')}
                            value={selectedNode.data.productNlFilterFields || []}
                            onChange={(v) => handleNodeDataChange({ productNlFilterFields: Array.isArray(v) ? v : [] })}
                            options={[
                              { label: t('workflowDesigner.chatOrderingCartProductNlFilterName'), value: 'Name' },
                              { label: t('workflowDesigner.chatOrderingCartProductNlFilterProductType'), value: 'ProductType' },
                              { label: t('workflowDesigner.chatOrderingCartProductNlFilterBrand'), value: 'Brand' },
                              { label: t('workflowDesigner.chatOrderingCartProductNlFilterGoogleCategory'), value: 'GoogleProductCategory' },
                              { label: t('workflowDesigner.chatOrderingCartProductNlFilterFbCategory'), value: 'FbProductCategory' },
                              { label: t('workflowDesigner.chatOrderingCartProductNlFilterCustomLabel0'), value: 'CustomLabel0' },
                            ]}
                          />
                        </Form.Item>

                        <Divider orientation="left" plain>{t('workflowDesigner.chatOrderingCartContactAndAnonymous')}</Divider>
                        <Form.Item
                          label={t('workflowDesigner.chatOrderingCartAllowAnonymousOrder')}
                          extra={t('workflowDesigner.chatOrderingCartAllowAnonymousOrderHelp')}
                        >
                          <Switch
                            checked={selectedNode.data.allowAnonymousOrder !== false}
                            onChange={(v) => handleNodeDataChange({ allowAnonymousOrder: v })}
                          />
                        </Form.Item>
                      </>
                    ),
                  },
                  {
                    key: 'ai',
                    icon: <RobotOutlined />,
                    tooltip: t('workflowDesigner.sectionAi'),
                    children: (
                      <>
                        <Form.Item label={t('workflowDesigner.validationAiProvider')} required>
                          <SelectWithClearButton
                            clearText={t('workflowDesigner.clear')}
                            loading={loadingAiProviders}
                            placeholder={t('workflowDesigner.validationAiProviderPlaceholder')}
                            value={selectedNode.data.aiProviderKey || undefined}
                            onChange={(v) => handleNodeDataChange({ aiProviderKey: v || '' })}
                            options={aiProviderOptions}
                          />
                        </Form.Item>
                        <Form.Item label={t('workflowDesigner.voiceProviderKey') || 'Speech-to-Text Provider'}>
                          <SelectWithClearButton
                            clearText={t('workflowDesigner.clear')}
                            loading={loadingVoiceProviders}
                            placeholder={t('workflowDesigner.voiceProviderKeyPlaceholder') || 'Leave blank for company default'}
                            value={selectedNode.data.voiceProviderKey || undefined}
                            onChange={(v) => handleNodeDataChange({ voiceProviderKey: v || '' })}
                            options={voiceProviderOptions}
                          />
                        </Form.Item>
                        <AiStaffSelectField {...aiStaffSelectProps} fieldPath={['aiStaffId']} />

                        <WorkflowKnowledgeBaseSettingsControl
                          showDivider
                          nodeData={selectedNode.data}
                          onApply={(patch) => handleNodeDataChange(patch)}
                          dataSets={dataSets}
                          loadingDataSets={loadingDataSets}
                          knowledgeStudioDocs={knowledgeStudioDocs}
                          loadingKnowledgeStudioDocs={loadingKnowledgeStudioDocs}
                          broadcastGroups={broadcastGroups}
                          loadingBroadcastGroups={loadingBroadcastGroups}
                          processVariables={processVariables}
                          generateWhereClause={generateWhereClause}
                          t={t}
                        />
                      </>
                    ),
                  },
                  {
                    key: 'validation',
                    icon: <SafetyOutlined />,
                    tooltip: t('workflowDesigner.sectionValidation'),
                    children: (
                      <Card
                        size="small"
                        title={t('workflowDesigner.timeoutCompleteValidatorLabel')}
                        style={{ marginBottom: 16 }}
                      >
                        <Alert
                          type="info"
                          showIcon
                          message={t('workflowDesigner.timeoutComplete.description')}
                          style={{ marginBottom: 16 }}
                        />
                        <Form.Item
                          label={t('workflowDesigner.validatorActiveLabel')}
                          name={['validation', 'timeoutCompleteIsActive']}
                          valuePropName="checked"
                        >
                          <Switch
                            className="validator-switch"
                            checkedChildren={t('workflowDesigner.active')}
                            unCheckedChildren={t('workflowDesigner.inactive')}
                            onChange={(checked) => {
                              handleNodeDataChange({
                                validation: {
                                  ...(selectedNode.data.validation || {}),
                                  timeoutCompleteIsActive: checked
                                }
                              });
                            }}
                          />
                        </Form.Item>
                        {(selectedNode.data.validation?.timeoutCompleteIsActive ?? false) && (
                          <>
                            <Form.Item label={t('workflowDesigner.timeoutComplete.timeoutInterval')}>
                              <div style={{
                                display: 'grid',
                                gridTemplateColumns: isFullscreen ? '1fr 1fr 1fr' : '1fr',
                                gap: isFullscreen ? '12px' : '8px'
                              }}>
                                <Input
                                  type="number"
                                  min="0"
                                  placeholder="0"
                                  value={selectedNode.data.validation?.timeoutCompleteDays ?? 0}
                                  onChange={(e) => handleNodeDataChange({
                                    validation: { ...(selectedNode.data.validation || {}), timeoutCompleteDays: parseInt(e.target.value) || 0 }
                                  })}
                                  addonAfter={t('workflowDesigner.days')}
                                />
                                <Input
                                  type="number"
                                  min="0"
                                  max="23"
                                  placeholder="0"
                                  value={selectedNode.data.validation?.timeoutCompleteHours ?? 0}
                                  onChange={(e) => handleNodeDataChange({
                                    validation: { ...(selectedNode.data.validation || {}), timeoutCompleteHours: parseInt(e.target.value) || 0 }
                                  })}
                                  addonAfter={t('workflowDesigner.hours')}
                                />
                                <Input
                                  type="number"
                                  min="0"
                                  max="59"
                                  placeholder="0"
                                  value={selectedNode.data.validation?.timeoutCompleteMinutes ?? 0}
                                  onChange={(e) => handleNodeDataChange({
                                    validation: { ...(selectedNode.data.validation || {}), timeoutCompleteMinutes: parseInt(e.target.value) || 0 }
                                  })}
                                  addonAfter={t('workflowDesigner.minutes')}
                                />
                              </div>
                            </Form.Item>
                            <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>
                              {t('workflowDesigner.timeoutComplete.hint')}
                            </div>
                          </>
                        )}
                      </Card>
                    ),
                  },
                ]}
              />
            )}

            {/* Chat Bot ?? */}
            {selectedNode.data.type === 'chatBot' && (
              <PropertySectionTabs
                resetKey={selectedNode.id}
                sections={[
                  {
                    key: 'recipientAndMessage',
                    icon: <MessageOutlined />,
                    tooltip: t('workflowDesigner.sectionRecipientAndMessage'),
                    children: (
                      <>
                        <Form.Item label={t('workflowDesigner.replyType')}>
                          <Select
                            value={selectedNode.data.replyType || 'initiator'}
                            onChange={(v) => handleNodeDataChange({ replyType: v })}
                            options={[
                              { value: 'initiator', label: t('workflowDesigner.initiator') },
                              { value: 'specified', label: t('workflowDesigner.specifiedPerson') }
                            ]}
                          />
                        </Form.Item>
                        {selectedNode.data.replyType === 'specified' && (
                          <Form.Item label={t('workflowDesigner.specifiedPerson')}>
                            <RecipientSelector
                              value={selectedNode.data.specifiedUsers || ''}
                              recipientDetails={selectedNode.data.recipientDetails}
                              placeholder={t('workflowDesigner.selectRecipients')}
                              compact={true}
                              workflowDefinitionId={workflowId}
                              onChange={(value, detailedValue) => {
                                if (value === '' && detailedValue === null) {
                                  setIsRecipientModalVisible(true);
                                } else {
                                  handleNodeDataChange({ specifiedUsers: value, recipientDetails: detailedValue });
                                }
                              }}
                            />
                          </Form.Item>
                        )}

                        <Divider orientation="left" plain>{t('workflowDesigner.chatBotInitialGreeting')}</Divider>
                        <Form.Item
                          label={t('workflowDesigner.chatBotGreetingEnabled')}
                          tooltip={t('workflowDesigner.chatBotGreetingEnabledHelp')}
                        >
                          <Switch
                            checked={selectedNode.data.greetingEnabled !== false}
                            checkedChildren={t('workflowDesigner.active')}
                            unCheckedChildren={t('workflowDesigner.inactive')}
                            onChange={(checked) => handleNodeDataChange({ greetingEnabled: checked })}
                          />
                        </Form.Item>
                        {selectedNode.data.greetingEnabled !== false && (
                          <>
                            <Form.Item label={t('workflowDesigner.chatBotInitialGreeting')}>
                              <Input.TextArea
                                rows={2}
                                value={selectedNode.data.initialGreetingMessage || ''}
                                onChange={(e) => handleNodeDataChange({ initialGreetingMessage: e.target.value })}
                                placeholder={t('workflowDesigner.chatBotInitialGreetingPlaceholder')}
                              />
                            </Form.Item>
                            {renderPromptVariablesDisplay('initialGreetingMessage')}
                          </>
                        )}
                        <Form.Item label={t('workflowDesigner.chatBotEndKeywords')}>
                          <Select
                            mode="tags"
                            style={{ width: '100%' }}
                            placeholder={t('workflowDesigner.chatBotEndKeywordsPlaceholder')}
                            value={selectedNode.data.endKeywords || []}
                            onChange={(v) => handleNodeDataChange({ endKeywords: Array.isArray(v) ? v : [] })}
                            tokenSeparators={[',']}
                          />
                        </Form.Item>
                        <Form.Item
                          label={t('workflowDesigner.chatBotEndMessage')}
                          tooltip={t('workflowDesigner.chatBotEndMessageHelp')}
                        >
                          <Input.TextArea
                            rows={2}
                            value={selectedNode.data.endMessage || ''}
                            onChange={(e) => handleNodeDataChange({ endMessage: e.target.value })}
                            placeholder={t('workflowDesigner.chatBotEndMessagePlaceholder')}
                          />
                        </Form.Item>
                        <Form.Item
                          label={t('workflowDesigner.chatBotAdditionalPrompt')}
                          tooltip={t('workflowDesigner.chatBotAdditionalPromptHelp')}
                        >
                          <Input.TextArea
                            rows={3}
                            value={selectedNode.data.additionalPrompt || ''}
                            onChange={(e) => handleNodeDataChange({ additionalPrompt: e.target.value })}
                            placeholder={t('workflowDesigner.chatBotAdditionalPromptPlaceholder')}
                          />
                        </Form.Item>
                        {renderPromptVariablesDisplay('additionalPrompt')}
                        <Form.Item label={t('workflowDesigner.chatBotSystemPromptOverride')}>
                          <Input.TextArea
                            rows={4}
                            value={selectedNode.data.systemPromptOverride || ''}
                            onChange={(e) => handleNodeDataChange({ systemPromptOverride: e.target.value })}
                            placeholder={t('workflowDesigner.chatBotSystemPromptOverridePlaceholder')}
                          />
                        </Form.Item>
                        {renderPromptVariablesDisplay('systemPromptOverride')}
                        <Divider orientation="left" plain>{t('workflowDesigner.chatBot.jsonExtraction.sectionTitle')}</Divider>
                        <Form.Item
                          label={t('workflowDesigner.chatBot.jsonExtraction.additionalPrompt')}
                          tooltip={t('workflowDesigner.chatBot.jsonExtraction.additionalPromptHelp')}
                        >
                          <Input.TextArea
                            rows={4}
                            value={selectedNode.data.chatBotJsonAdditionalPrompt || ''}
                            onChange={(e) => handleNodeDataChange({ chatBotJsonAdditionalPrompt: e.target.value })}
                            placeholder={t('workflowDesigner.chatBot.jsonExtraction.additionalPromptPlaceholder')}
                          />
                        </Form.Item>
                        {renderPromptVariablesDisplay('chatBotJsonAdditionalPrompt')}
                        <Form.Item
                          label={t('workflowDesigner.chatBot.jsonExtraction.jsonResultVariable')}
                          tooltip={t('workflowDesigner.chatBot.jsonExtraction.jsonResultVariableHelp')}
                        >
                          <SelectWithClearButton
                            clearText={t('workflowDesigner.clear')}
                            placeholder={t('workflowDesigner.chatBot.jsonExtraction.jsonResultVariablePlaceholder')}
                            value={selectedNode.data.chatBotJsonResultVariable || undefined}
                            onChange={(value) => handleNodeDataChange({ chatBotJsonResultVariable: value || '' })}
                          >
                            {processVariables
                              .filter(pv => pv.dataType === 'json')
                              .map(pv => (
                                <Select.Option key={pv.id} value={pv.variableName}>
                                  {pv.variableName} ({pv.dataType})
                                </Select.Option>
                              ))}
                          </SelectWithClearButton>
                        </Form.Item>
                      </>
                    ),
                  },
                  {
                    key: 'ai',
                    icon: <RobotOutlined />,
                    tooltip: t('workflowDesigner.sectionAi'),
                    children: (
                      <>
                        <Form.Item label={t('workflowDesigner.validationAiProvider')} required>
                          <SelectWithClearButton
                            clearText={t('workflowDesigner.clear')}
                            loading={loadingAiProviders}
                            placeholder={t('workflowDesigner.validationAiProviderPlaceholder')}
                            value={selectedNode.data.aiProviderKey || undefined}
                            onChange={(v) => handleNodeDataChange({ aiProviderKey: v || '' })}
                            options={aiProviderOptions}
                          />
                        </Form.Item>
                        <Form.Item label={t('workflowDesigner.voiceProviderKey') || 'Speech-to-Text Provider'}>
                          <SelectWithClearButton
                            clearText={t('workflowDesigner.clear')}
                            loading={loadingVoiceProviders}
                            placeholder={t('workflowDesigner.voiceProviderKeyPlaceholder') || 'Leave blank for company default'}
                            value={selectedNode.data.voiceProviderKey || undefined}
                            onChange={(v) => handleNodeDataChange({ voiceProviderKey: v || '' })}
                            options={voiceProviderOptions}
                          />
                        </Form.Item>
                        <AiStaffSelectField {...aiStaffSelectProps} fieldPath={['aiStaffId']} />

                        <WorkflowKnowledgeBaseSettingsControl
                          showDivider
                          nodeData={selectedNode.data}
                          onApply={(patch) => handleNodeDataChange(patch)}
                          dataSets={dataSets}
                          loadingDataSets={loadingDataSets}
                          knowledgeStudioDocs={knowledgeStudioDocs}
                          loadingKnowledgeStudioDocs={loadingKnowledgeStudioDocs}
                          broadcastGroups={broadcastGroups}
                          loadingBroadcastGroups={loadingBroadcastGroups}
                          processVariables={processVariables}
                          generateWhereClause={generateWhereClause}
                          t={t}
                        />
                      </>
                    ),
                  },
                  {
                    key: 'validation',
                    icon: <SafetyOutlined />,
                    tooltip: t('workflowDesigner.sectionValidation'),
                    children: (
                      <Card
                        size="small"
                        title={t('workflowDesigner.timeoutCompleteValidatorLabel')}
                        style={{ marginBottom: 16 }}
                      >
                        <Alert
                          type="info"
                          showIcon
                          message={t('workflowDesigner.timeoutComplete.description')}
                          style={{ marginBottom: 16 }}
                        />
                        <Form.Item
                          label={t('workflowDesigner.validatorActiveLabel')}
                          name={['validation', 'timeoutCompleteIsActive']}
                          valuePropName="checked"
                        >
                          <Switch
                            className="validator-switch"
                            checkedChildren={t('workflowDesigner.active')}
                            unCheckedChildren={t('workflowDesigner.inactive')}
                            onChange={(checked) => {
                              handleNodeDataChange({
                                validation: {
                                  ...(selectedNode.data.validation || {}),
                                  timeoutCompleteIsActive: checked
                                }
                              });
                            }}
                          />
                        </Form.Item>
                        {(selectedNode.data.validation?.timeoutCompleteIsActive ?? false) && (
                          <>
                            <Form.Item label={t('workflowDesigner.timeoutComplete.timeoutInterval')}>
                              <div style={{
                                display: 'grid',
                                gridTemplateColumns: isFullscreen ? '1fr 1fr 1fr' : '1fr',
                                gap: isFullscreen ? '12px' : '8px'
                              }}>
                                <Input
                                  type="number"
                                  min="0"
                                  placeholder="0"
                                  value={selectedNode.data.validation?.timeoutCompleteDays ?? 0}
                                  onChange={(e) => handleNodeDataChange({
                                    validation: { ...(selectedNode.data.validation || {}), timeoutCompleteDays: parseInt(e.target.value) || 0 }
                                  })}
                                  addonAfter={t('workflowDesigner.days')}
                                />
                                <Input
                                  type="number"
                                  min="0"
                                  max="23"
                                  placeholder="0"
                                  value={selectedNode.data.validation?.timeoutCompleteHours ?? 0}
                                  onChange={(e) => handleNodeDataChange({
                                    validation: { ...(selectedNode.data.validation || {}), timeoutCompleteHours: parseInt(e.target.value) || 0 }
                                  })}
                                  addonAfter={t('workflowDesigner.hours')}
                                />
                                <Input
                                  type="number"
                                  min="0"
                                  max="59"
                                  placeholder="0"
                                  value={selectedNode.data.validation?.timeoutCompleteMinutes ?? 0}
                                  onChange={(e) => handleNodeDataChange({
                                    validation: { ...(selectedNode.data.validation || {}), timeoutCompleteMinutes: parseInt(e.target.value) || 0 }
                                  })}
                                  addonAfter={t('workflowDesigner.minutes')}
                                />
                              </div>
                            </Form.Item>
                            <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>
                              {t('workflowDesigner.timeoutComplete.hint')}
                            </div>
                          </>
                        )}
                        <Divider style={{ margin: '16px 0' }} />
                        <Alert
                          type="info"
                          showIcon
                          message={t('workflowDesigner.autoComplete.aiBatchCount.description')}
                          style={{ marginBottom: 16 }}
                        />
                        <Form.Item label={t('workflowDesigner.autoComplete.aiBatchCount.enable')}>
                          <Switch
                            className="validator-switch"
                            checkedChildren={t('workflowDesigner.active')}
                            unCheckedChildren={t('workflowDesigner.inactive')}
                            checked={selectedNode.data.validation?.aiCompleteBatchCountEnabled ?? false}
                            onChange={(checked) => {
                              handleNodeDataChange({
                                validation: {
                                  ...(selectedNode.data.validation || {}),
                                  aiCompleteBatchCountEnabled: checked
                                }
                              });
                            }}
                          />
                        </Form.Item>
                        {(selectedNode.data.validation?.aiCompleteBatchCountEnabled ?? false) && (
                          <>
                            <Form.Item label={t('workflowDesigner.autoComplete.aiBatchCount.count')}>
                              <InputNumber
                                min={1}
                                max={10}
                                value={selectedNode.data.validation?.aiCompleteBatchCount ?? 1}
                                onChange={(v) => handleNodeDataChange({
                                  validation: { ...(selectedNode.data.validation || {}), aiCompleteBatchCount: v ?? 1 }
                                })}
                              />
                            </Form.Item>
                            <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>
                              {t('workflowDesigner.autoComplete.aiBatchCount.hint')}
                            </div>
                          </>
                        )}
                        <Divider style={{ margin: '16px 0' }} />
                        <Form.Item label={t('workflowDesigner.chatBot.batchRequireText.enable')}>
                          <Switch
                            className="validator-switch"
                            checkedChildren={t('workflowDesigner.active')}
                            unCheckedChildren={t('workflowDesigner.inactive')}
                            checked={selectedNode.data.validation?.batchRequireTextEnabled ?? false}
                            onChange={(checked) => {
                              handleNodeDataChange({
                                validation: {
                                  ...(selectedNode.data.validation || {}),
                                  batchRequireTextEnabled: checked
                                }
                              });
                            }}
                          />
                        </Form.Item>
                        {(selectedNode.data.validation?.batchRequireTextEnabled ?? false) && (
                          <>
                            <Form.Item label={t('workflowDesigner.chatBot.batchRequireText.waitSeconds')}>
                              <InputNumber
                                min={1}
                                max={30}
                                value={selectedNode.data.validation?.batchTextWaitSeconds ?? 5}
                                addonAfter={t('workflowDesigner.chatBot.batchRequireText.seconds')}
                                onChange={(v) => handleNodeDataChange({
                                  validation: { ...(selectedNode.data.validation || {}), batchTextWaitSeconds: v ?? 5 }
                                })}
                              />
                            </Form.Item>
                            <Form.Item label={t('workflowDesigner.chatBot.batchRequireText.prompt')}>
                              <Input.TextArea
                                value={selectedNode.data.validation?.batchRequireTextPrompt ?? ''}
                                placeholder={t('workflowDesigner.chatBot.batchRequireText.promptPlaceholder')}
                                autoSize={{ minRows: 2, maxRows: 4 }}
                                onChange={(e) => handleNodeDataChange({
                                  validation: { ...(selectedNode.data.validation || {}), batchRequireTextPrompt: e.target.value }
                                })}
                              />
                            </Form.Item>
                          </>
                        )}
                      </Card>
                    ),
                  },
                ]}
              />
            )}

            {/* ?? WhatsApp ???? */}
            {selectedNode.data.type === 'sendWhatsAppTemplate' && (
              <PropertySectionTabs
                resetKey={selectedNode.id}
                sections={[
                  {
                    key: 'recipient',
                    icon: <UserOutlined />,
                    tooltip: t('workflowDesigner.sectionRecipient'),
                    children: (
                      <Form.Item label={t('workflow.to')}>
                        <div style={{ position: 'relative' }}>
                          <RecipientSelector
                            value={selectedNode.data.to || ''}
                            recipientDetails={selectedNode.data.recipientDetails}
                            placeholder={t('workflowDesigner.selectRecipients')}
                            compact={true}
                            workflowDefinitionId={workflowId}
                            t={t}
                            onChange={(value, detailedValue) => {
                              if (value === '' && detailedValue === null) {
                                setIsRecipientModalVisible(true);
                              } else {
                                handleNodeDataChange({
                                  to: value,
                                  recipientDetails: detailedValue
                                });
                              }
                            }}
                          />
                          <div style={{
                            position: 'absolute',
                            right: '8px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            display: 'flex',
                            gap: '4px'
                          }}>
                            {selectedNode.data.to && (
                              <Button
                                type="text"
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleNodeDataChange({ to: '', recipientDetails: { users: [], contacts: [], groups: [], hashtags: [], useInitiator: false, phoneNumbers: [] } });
                                }}
                                style={{ padding: '0 4px', fontSize: '12px' }}
                              >
                                {t('workflowDesigner.clear')}
                              </Button>
                            )}
                          </div>
                        </div>
                      </Form.Item>
                    ),
                  },
                  {
                    key: 'template',
                    icon: <FileTextOutlined />,
                    tooltip: t('workflowDesigner.sectionTemplate'),
                    children: (
                      <>
                <Form.Item label={t('workflowDesigner.dataSet.template')}>
                  <div style={{ position: 'relative' }}>
                    <Input 
                      value={selectedNode.data.templateName || ''}
                      placeholder={t('workflowDesigner.selectTemplate')} 
                      readOnly 
                      onClick={() => setIsTemplateModalVisible(true)}
                      suffix={<FormOutlined />}
                    />
                    {selectedNode.data.templateId && (
                      <div style={{ 
                        position: 'absolute', 
                        right: '30px', 
                        top: '50%', 
                        transform: 'translateY(-50%)',
                        zIndex: 1
                      }}>
                        <Button 
                          type="text" 
                          size="small" 
                          onClick={(e) => {
                            e.stopPropagation();
                            handleNodeDataChange({ 
                              templateId: '', 
                              templateName: '', 
                              isMetaTemplate: false,
                              templateLanguage: null,
                              variables: {}
                            });
                          }}
                          style={{ padding: '0 4px', fontSize: '12px' }}
                        >
                          {t('workflowDesigner.clear')}
                        </Button>
                      </div>
                    )}
                  </div>
                </Form.Item>
                {selectedNode.data.templateId && (
                  <Card size="small" title={t('workflowDesigner.templateInfo')} style={{ marginBottom: 16 }}>
                    <p><strong>{t('workflowDesigner.templateId')}</strong>{selectedNode.data.templateId}</p>
                    <p><strong>{t('workflowDesigner.templateName')}</strong>{selectedNode.data.templateName}</p>
                  </Card>
                )}
                
                {/* ?????? */}
                {selectedNode.data.templateId && (
                  <Form.Item label={t('workflowDesigner.templateVariables')}>
                    <div style={{ marginBottom: 8 }}>
                      <Button 
                        type="dashed" 
                        onClick={() => {
                          const currentVariables = selectedNode.data.variables || {};
                          const newVariables = { ...currentVariables, [`var_${Date.now()}`]: '' };
                          handleNodeDataChange({ variables: newVariables });
                        }}
                        style={{ width: '100%' }}
                      >
                        <PlusOutlined /> {t('workflowDesigner.addVariable')}
                      </Button>
                    </div>
                    
                    {selectedNode.data.variables && Object.keys(selectedNode.data.variables).length > 0 && (
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        {Object.entries(selectedNode.data.variables).map(([key, value]) => (
                          <div key={key} style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                            <Input
                              placeholder={t('workflowDesigner.variableName')}
                              value={key}
                              onChange={(e) => {
                                const newVariables = { ...selectedNode.data.variables };
                                delete newVariables[key];
                                newVariables[e.target.value] = value;
                                handleNodeDataChange({ variables: newVariables });
                              }}
                              style={{ flex: 1 }}
                            />
                            <Input
                              placeholder={t('workflowDesigner.variableValue')}
                              value={value}
                              onChange={(e) => {
                                const newVariables = { ...selectedNode.data.variables };
                                newVariables[key] = e.target.value;
                                handleNodeDataChange({ variables: newVariables });
                              }}
                              style={{ flex: 2 }}
                            />
                            <Button
                              type="text"
                              danger
                              onClick={() => {
                                const newVariables = { ...selectedNode.data.variables };
                                delete newVariables[key];
                                handleNodeDataChange({ variables: newVariables });
                              }}
                            >
                              <DeleteOutlined />
                            </Button>
                          </div>
                        ))}
                      </div>
                    )}
                    
                  </Form.Item>
                )}

                {/* ?? Image/Document URL ?? - ????? image ? document header ??? */}
                {selectedNode.data.templateId && (selectedNode.data.templateHeaderType === 'image' || selectedNode.data.templateHeaderType === 'document') && (
                  <>
                    <Divider />
                    <Form.Item 
                      label={
                        selectedNode.data.templateHeaderType === 'image' 
                          ? t('workflowDesigner.templateImageUrl') 
                          : t('workflowDesigner.templateDocumentUrl')
                      }
                    >
                      <div style={{ marginBottom: 8 }}>
                        <Input
                          placeholder={
                            selectedNode.data.templateHeaderType === 'image'
                              ? t('workflowDesigner.templateImageUrlPlaceholder')
                              : t('workflowDesigner.templateDocumentUrlPlaceholder')
                          }
                          value={selectedNode.data.templateHeaderUrl || ''}
                          onChange={(e) => {
                            handleNodeDataChange({ templateHeaderUrl: e.target.value });
                          }}
                          onFocus={() => setActiveFlowField('templateHeaderUrl')}
                        />
                        <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                          {t('workflowDesigner.templateHeaderUrlHelp')}
                        </div>
                      </div>
                      {/* ???????? */}
                      <ProcessVariablesDisplay
                        processVariables={processVariables}
                        form={form}
                        t={t}
                        targetFieldName="templateHeaderUrl"
                        onInsert={(variableName) => {
                          const currentValue = selectedNode.data.templateHeaderUrl || '';
                          const newValue = currentValue + `\${${variableName}}`;
                          handleNodeDataChange({ templateHeaderUrl: newValue });
                        }}
                        showLabel={true}
                      />
                    </Form.Item>
                    
                    {/* Document ???Filename ?? */}
                    {selectedNode.data.templateHeaderType === 'document' && (
                      <Form.Item label={t('workflowDesigner.templateDocumentFilename')}>
                        <div style={{ marginBottom: 8 }}>
                          <Input
                            placeholder={t('workflowDesigner.templateDocumentFilenamePlaceholder')}
                            value={selectedNode.data.templateHeaderFilename || ''}
                            onChange={(e) => {
                              handleNodeDataChange({ templateHeaderFilename: e.target.value });
                            }}
                            onFocus={() => setActiveFlowField('templateHeaderFilename')}
                          />
                          <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                            {t('workflowDesigner.templateDocumentFilenameHelp')}
                          </div>
                        </div>
                        {/* ???????? */}
                        <ProcessVariablesDisplay
                          processVariables={processVariables}
                          form={form}
                          t={t}
                          targetFieldName="templateHeaderFilename"
                          onInsert={(variableName) => {
                            const currentValue = selectedNode.data.templateHeaderFilename || '';
                            const newValue = currentValue + `\${${variableName}}`;
                            handleNodeDataChange({ templateHeaderFilename: newValue });
                          }}
                          showLabel={true}
                        />
                      </Form.Item>
                    )}
                  </>
                )}
                      </>
                    ),
                  },
                ]}
              />
            )}

            {/* ?????? */}
            {selectedNode.data.type === 'waitReply' && (
              <PropertySectionTabs
                resetKey={selectedNode.id}
                sections={[
                  {
                    key: 'recipientAndMessage',
                    icon: <MessageOutlined />,
                    tooltip: t('workflowDesigner.sectionRecipientAndMessage'),
                    children: (
                      <>
                        <Form.Item label={t('workflowDesigner.replyType')} name="replyType">
                          <Select
                            options={[
                              { value: 'initiator', label: t('workflowDesigner.initiator') },
                              { value: 'specified', label: t('workflowDesigner.specifiedPerson') }
                            ]}
                          />
                        </Form.Item>

                        {selectedNode.data.replyType === 'specified' && (
                          <Form.Item label={t('workflowDesigner.specifiedPerson')}>
                            <div style={{ position: 'relative' }}>
                              <RecipientSelector
                                value={selectedNode.data.specifiedUsers || ''}
                                recipientDetails={selectedNode.data.recipientDetails}
                                placeholder={t('workflowDesigner.selectRecipients')}
                                compact={true}
                                workflowDefinitionId={workflowId}
                                onChange={(value, detailedValue) => {
                                  if (value === '' && detailedValue === null) {
                                    setIsRecipientModalVisible(true);
                                  } else {
                                    handleNodeDataChange({
                                      specifiedUsers: value,
                                      recipientDetails: detailedValue
                                    });
                                  }
                                }}
                              />
                              <div style={{
                                position: 'absolute',
                                right: '8px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                display: 'flex',
                                gap: '4px'
                              }}>
                                {selectedNode.data.specifiedUsers && (
                                  <Button
                                    type="text"
                                    size="small"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleNodeDataChange({ specifiedUsers: '', recipientDetails: null });
                                    }}
                                    style={{ padding: '0 4px', fontSize: '12px' }}
                                  >
                                    {t('workflowDesigner.clear')}
                                  </Button>
                                )}
                              </div>
                            </div>
                          </Form.Item>
                        )}
                        <Divider />
                        <WaitReplyMessageTabsComponent
                          selectedNode={selectedNode}
                          handleNodeDataChange={handleNodeDataChange}
                          setIsTemplateModalVisible={setIsTemplateModalVisible}
                          processVariables={processVariables}
                          form={form}
                          t={t}
                          metaTemplates={metaTemplates}
                        />
                      </>
                    ),
                  },
                  {
                    key: 'validation',
                    icon: <SafetyOutlined />,
                    tooltip: t('workflowDesigner.sectionValidation'),
                    children: (
                      <>
                <Form.Item label={t('workflowDesigner.validationConfig')}>
                  <Card 
                    size="small" 
                    title={t('workflowDesigner.validationSettings')} 
                    style={{ marginBottom: 16 }}
                  >
                    <Tabs
                      activeKey={activeValidatorTab}
                      onChange={(key) => setActiveValidatorTab(key)}
                    >
                      <Tabs.TabPane tab={t('workflowDesigner.aiValidator')} key="ai">
                        <Form.Item
                          label={t('workflowDesigner.validatorActiveLabel')}
                          name={['validation', 'aiIsActive']}
                          valuePropName="checked"
                        >
                          <Switch
                            className="validator-switch"
                            checkedChildren={t('workflowDesigner.active')}
                            unCheckedChildren={t('workflowDesigner.inactive')}
                            onChange={(checked) => handleValidatorToggle('ai', checked)}
                          />
                        </Form.Item>
                        {aiIsActive && activeValidatorTab === 'ai' && (
                          <>
                            {!loadingAiProviders && aiProviders.length === 0 && (
                              <Alert
                                type="warning"
                                showIcon
                                message={t('workflowDesigner.aiProviderNotConfigured')}
                                style={{ marginBottom: 12 }}
                              />
                            )}
                            {aiProvidersError && (
                              <Alert
                                type="error"
                                showIcon
                                message={t('workflowDesigner.aiProviderLoadFailed')}
                                description={aiProvidersError}
                                style={{ marginBottom: 12 }}
                              />
                            )}
                            <Form.Item
                              label={t('workflowDesigner.validationAiProvider')}
                              name={['validation', 'aiProviderKey']}
                              rules={[{ required: true, message: t('workflowDesigner.validationAiProviderRequired') }]}
                            >
                              <SelectWithClearButton
                                clearText={t('workflowDesigner.clear')}
                                loading={loadingAiProviders}
                                placeholder={t('workflowDesigner.validationAiProviderPlaceholder')}
                                options={aiProviderOptions}
                              />
                            </Form.Item>
                            <Form.Item label={t('workflowDesigner.voiceProviderKey') || 'Speech-to-Text Provider'}>
                              <SelectWithClearButton
                                clearText={t('workflowDesigner.clear')}
                                loading={loadingVoiceProviders}
                                placeholder={t('workflowDesigner.voiceProviderKeyPlaceholder') || 'Leave blank for company default'}
                                value={selectedNode.data.voiceProviderKey || undefined}
                                onChange={(v) => handleNodeDataChange({ voiceProviderKey: v || '' })}
                                options={voiceProviderOptions}
                              />
                            </Form.Item>
                            <AiStaffSelectField {...aiStaffSelectProps} />
                            <Form.Item
                              label={t('workflowDesigner.validationAiResultVariable')}
                              name={['validation', 'aiResultVariable']}
                              tooltip={t('workflowDesigner.validationAiResultVariableHelp')}
                            >
                              <SelectWithClearButton
                                clearText={t('workflowDesigner.clear')}
                                placeholder={t('workflowDesigner.validationAiResultVariablePlaceholder')}
                              >
                                {processVariables.map(pv => (
                                  <Select.Option key={pv.id} value={pv.variableName}>
                                    {pv.variableName} ({pv.dataType})
                                  </Select.Option>
                                ))}
                              </SelectWithClearButton>
                            </Form.Item>
                            <Form.Item
                              label={t('workflowDesigner.validationAiSuggestionVariable')}
                              name={['validation', 'aiSuggestionVariable']}
                              tooltip={t('workflowDesigner.validationAiSuggestionVariableHelp')}
                            >
                              <SelectWithClearButton
                                clearText={t('workflowDesigner.clear')}
                                placeholder={t('workflowDesigner.validationAiSuggestionVariablePlaceholder')}
                              >
                                {textOrStringProcessVariables.map(pv => (
                                  <Select.Option key={pv.id} value={pv.variableName}>
                                    {pv.variableName} ({pv.dataType})
                                  </Select.Option>
                                ))}
                              </SelectWithClearButton>
                            </Form.Item>
                            <Form.Item
                              label={t('workflowDesigner.validationAiFailReasonVariable')}
                              name={['validation', 'aiFailReasonVariable']}
                              tooltip={t('workflowDesigner.validationAiFailReasonVariableHelp')}
                            >
                              <SelectWithClearButton
                                clearText={t('workflowDesigner.clear')}
                                placeholder={t('workflowDesigner.validationAiFailReasonVariablePlaceholder')}
                              >
                                {textOrStringProcessVariables.map(pv => (
                                  <Select.Option key={pv.id} value={pv.variableName}>
                                    {pv.variableName} ({pv.dataType})
                                  </Select.Option>
                                ))}
                              </SelectWithClearButton>
                            </Form.Item>
                            <Form.Item label={t('workflowDesigner.promptText')} name={['validation', 'prompt']}>
                              <Input.TextArea
                                placeholder={t('workflowDesigner.promptTextPlaceholder')}
                                rows={6}
                              />
                            </Form.Item>
                            <Form.Item label={t('workflowDesigner.retryMessage')} name={['validation', 'retryMessage']}>
                              <Input placeholder={t('workflowDesigner.retryMessagePlaceholder')} />
                            </Form.Item>
                            <Form.Item label={t('workflowDesigner.maxRetries')} name={['validation', 'maxRetries']}>
                              <Input type="number" min="1" max="10" />
                            </Form.Item>

                            <WorkflowKnowledgeBaseSettingsControl
                              showDivider
                              nodeData={selectedNode.data}
                              onApply={(patch) => handleNodeDataChange(patch)}
                              dataSets={dataSets}
                              loadingDataSets={loadingDataSets}
                              knowledgeStudioDocs={knowledgeStudioDocs}
                              loadingKnowledgeStudioDocs={loadingKnowledgeStudioDocs}
                              broadcastGroups={broadcastGroups}
                              loadingBroadcastGroups={loadingBroadcastGroups}
                              processVariables={processVariables}
                              generateWhereClause={generateWhereClause}
                              t={t}
                            />
                          </>
                        )}
                      </Tabs.TabPane>
                      <Tabs.TabPane tab={t('workflowDesigner.timeValidatorLabel')} key="time">
                        <Form.Item
                          label={t('workflowDesigner.validatorActiveLabel')}
                          name={['validation', 'timeIsActive']}
                          valuePropName="checked"
                        >
                          <Switch
                            className="validator-switch"
                            checkedChildren={t('workflowDesigner.active')}
                            unCheckedChildren={t('workflowDesigner.inactive')}
                            onChange={(checked) => handleValidatorToggle('time', checked)}
                          />
                        </Form.Item>
                        {timeIsActive && activeValidatorTab === 'time' && (
                          <>
                            <Form.Item label={t('workflowDesigner.timeValidator.retryInterval')}>
                              <div style={{
                                display: 'grid',
                                gridTemplateColumns: isFullscreen ? '1fr 1fr 1fr' : '1fr',
                                gap: isFullscreen ? '12px' : '8px'
                              }}>
                                <Input 
                                  type="number" 
                                  min="0" 
                                  placeholder="0"
                                  value={selectedNode.data.validation?.retryIntervalDays || 0}
                                  onChange={(e) => {
                                    const newValidation = {
                                      ...(selectedNode.data.validation || {}),
                                      retryIntervalDays: parseInt(e.target.value) || 0
                                    };
                                    handleNodeDataChange({ validation: newValidation });
                                  }}
                                  addonAfter={t('workflowDesigner.days')}
                                />
                                <Input 
                                  type="number" 
                                  min="0" 
                                  max="23"
                                  placeholder="0"
                                  value={selectedNode.data.validation?.retryIntervalHours || 0}
                                  onChange={(e) => {
                                    const newValidation = {
                                      ...(selectedNode.data.validation || {}),
                                      retryIntervalHours: parseInt(e.target.value) || 0
                                    };
                                    handleNodeDataChange({ validation: newValidation });
                                  }}
                                  addonAfter={t('workflowDesigner.hours')}
                                />
                                <Input 
                                  type="number" 
                                  min="0" 
                                  max="59"
                                  placeholder="30"
                                  value={selectedNode.data.validation?.retryIntervalMinutes || 0}
                                  onChange={(e) => {
                                    const newValidation = {
                                      ...(selectedNode.data.validation || {}),
                                      retryIntervalMinutes: parseInt(e.target.value) || 0
                                    };
                                    handleNodeDataChange({ validation: newValidation });
                                  }}
                                  addonAfter={t('workflowDesigner.minutes')}
                                />
                              </div>
                            </Form.Item>
                            <Form.Item label={t('workflowDesigner.timeValidator.retryLimit')}>
                              <Input
                                type="number"
                                min="1"
                                placeholder="5"
                                value={selectedNode.data.validation?.retryLimitValue || 5}
                                onChange={(e) => {
                                  const newValidation = {
                                    ...(selectedNode.data.validation || {}),
                                    retryLimitValue: parseInt(e.target.value) || 5
                                  };
                                  handleNodeDataChange({ validation: newValidation });
                                }}
                              />
                            </Form.Item>
                            <TimeValidatorConfigSection
                              type="retryMessage"
                              selectedNode={selectedNode}
                              handleNodeDataChange={handleNodeDataChange}
                              form={form}
                              processVariables={processVariables}
                              workflowDefinitionId={workflowId}
                              onOpenTemplateModal={() => {
                                setTemplateModalSource('retryMessage');
                                setIsTemplateModalVisible(true);
                              }}
                              onOpenRecipientModal={() => {
                                setTemplateModalSource('retryMessage');
                                setTimeValidatorRecipientModalVisible(true);
                              }}
                              t={t}
                              config={selectedNode?.data?.validation?.retryMessageConfig}
                              title={t('workflowDesigner.timeValidator.configureRetryMessage')}
                              recipientsLabel={t('workflowDesigner.timeValidator.retryMessageRecipients')}
                              recipientsDescription={t('workflowDesigner.timeValidator.retryMessageRecipientsDescription')}
                              messageLabel={t('workflowDesigner.timeValidator.retryMessage')}
                              messageDescription={t('workflowDesigner.timeValidator.retryMessageDescription')}
                              messagePlaceholder={t('workflowDesigner.timeValidator.retryMessagePlaceholder')}
                              messageTip={t('workflowDesigner.timeValidator.retryMessageTip')}
                              expanded={retryMessageExpanded}
                              onToggleExpanded={setRetryMessageExpanded}
                              metaTemplates={metaTemplates}
                            />
                            <TimeValidatorConfigSection
                              type="escalation"
                              selectedNode={selectedNode}
                              handleNodeDataChange={handleNodeDataChange}
                              form={form}
                              processVariables={processVariables}
                              workflowDefinitionId={workflowId}
                              onOpenTemplateModal={() => {
                                setTemplateModalSource('escalation');
                                setIsTemplateModalVisible(true);
                              }}
                              onOpenRecipientModal={() => {
                                setTemplateModalSource('escalation');
                                setTimeValidatorRecipientModalVisible(true);
                              }}
                              t={t}
                              config={selectedNode?.data?.validation?.escalationConfig}
                              title={t('workflowDesigner.timeValidator.configureEscalation')}
                              recipientsLabel={t('workflowDesigner.timeValidator.escalationRecipients')}
                              recipientsDescription={t('workflowDesigner.timeValidator.escalationRecipientsDescription')}
                              messageLabel={t('workflowDesigner.timeValidator.escalationMessage')}
                              messageDescription={t('workflowDesigner.timeValidator.escalationMessageDescription')}
                              messagePlaceholder={t('workflowDesigner.timeValidator.escalationMessagePlaceholder')}
                              messageTip={t('workflowDesigner.timeValidator.escalationMessageTip')}
                              expanded={escalationConfigExpanded}
                              onToggleExpanded={setEscalationConfigExpanded}
                              metaTemplates={metaTemplates}
                            />
                          </>
                        )}
                      </Tabs.TabPane>
                      {renderTimeoutCompleteTabPane()}
                    </Tabs>
                  </Card>
                </Form.Item>
                      </>
                    ),
                  },
                  {
                    key: 'description',
                    icon: <InfoCircleOutlined />,
                    tooltip: t('workflowDesigner.sectionDescription'),
                    children: (
                      <Card size="small" title={t('workflowDesigner.functionDescription')} style={{ marginTop: 16 }}>
                        <p style={{ fontSize: '12px', margin: '4px 0' }}>
                          {t('workflowDesigner.waitReplyDescription1')}
                        </p>
                        <p style={{ fontSize: '12px', margin: '4px 0' }}>
                          {t('workflowDesigner.waitReplyDescription2')}
                        </p>
                        <p style={{ fontSize: '12px', margin: '4px 0' }}>
                          {t('workflowDesigner.waitReplyDescription3')}
                        </p>
                        <p style={{ fontSize: '12px', margin: '4px 0', color: '#1890ff' }}>
                          {t('workflowDesigner.waitReplyDescription4')}
                        </p>
                      </Card>
                    ),
                  },
                ]}
              />
            )}

            {/* ?? QR Code ?? */}
            {selectedNode.data.type === 'waitForQRCode' && (
              <PropertySectionTabs
                resetKey={selectedNode.id}
                sections={[
                  {
                    key: 'recipientAndMessage',
                    icon: <MessageOutlined />,
                    tooltip: t('workflowDesigner.sectionRecipientAndMessage'),
                    children: (
                      <>
                        <Form.Item label={t('workflowDesigner.replyType')} name="replyType">
                          <Select
                            options={[
                              { value: 'initiator', label: t('workflowDesigner.initiator') },
                              { value: 'specified', label: t('workflowDesigner.specifiedPerson') }
                            ]}
                          />
                        </Form.Item>

                        {selectedNode.data.replyType === 'specified' && (
                          <Form.Item label={t('workflowDesigner.specifiedPerson')}>
                            <div style={{ position: 'relative' }}>
                              <RecipientSelector
                                value={selectedNode.data.specifiedUsers || ''}
                                recipientDetails={selectedNode.data.recipientDetails}
                                placeholder={t('workflowDesigner.selectRecipients')}
                                compact={true}
                                workflowDefinitionId={workflowId}
                                onChange={(value, detailedValue) => {
                                  if (value === '' && detailedValue === null) {
                                    setIsRecipientModalVisible(true);
                                  } else {
                                    handleNodeDataChange({
                                      specifiedUsers: value,
                                      recipientDetails: detailedValue
                                    });
                                  }
                                }}
                              />
                              <div style={{
                                position: 'absolute',
                                right: '8px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                display: 'flex',
                                gap: '4px'
                              }}>
                                {selectedNode.data.specifiedUsers && (
                                  <Button
                                    type="text"
                                    size="small"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleNodeDataChange({ specifiedUsers: '', recipientDetails: null });
                                    }}
                                    style={{ padding: '0 4px', fontSize: '12px' }}
                                  >
                                    {t('workflowDesigner.clear')}
                                  </Button>
                                )}
                              </div>
                            </div>
                          </Form.Item>
                        )}
                        <Divider />
                        <Form.Item label={t('workflowDesigner.qrCodeVariable')} name="qrCodeVariable">
                          <Select
                            placeholder={t('workflowDesigner.selectProcessVariable')}
                            allowClear
                          >
                            {processVariables.map(pv => (
                              <Select.Option key={pv.id} value={pv.variableName}>
                                {pv.variableName} ({pv.dataType})
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>

                        <QRCodeMessageTabsComponent
                          selectedNode={selectedNode}
                          handleNodeDataChange={handleNodeDataChange}
                          setIsTemplateModalVisible={setIsTemplateModalVisible}
                          processVariables={processVariables}
                          form={form}
                          t={t}
                          metaTemplates={metaTemplates}
                        />

                        <Form.Item label={t('workflowDesigner.timeout')} name="timeout">
                          <Input
                            type="number"
                            placeholder="300"
                            addonAfter={t('workflowDesigner.seconds')}
                          />
                        </Form.Item>
                      </>
                    ),
                  },
                  {
                    key: 'validation',
                    icon: <SafetyOutlined />,
                    tooltip: t('workflowDesigner.sectionValidation'),
                    children: (
                      <>
                <Form.Item label={t('workflowDesigner.validationConfig')}>
                  <Card 
                    size="small" 
                    title={t('workflowDesigner.validationSettings')} 
                    style={{ marginBottom: 16 }}
                  >
                    <Tabs
                      activeKey={activeValidatorTab}
                      onChange={(key) => setActiveValidatorTab(key)}
                    >
                      <Tabs.TabPane tab={t('workflowDesigner.aiValidator')} key="ai">
                        <Form.Item
                          label={t('workflowDesigner.validatorActiveLabel')}
                          name={['validation', 'aiIsActive']}
                          valuePropName="checked"
                        >
                          <Switch
                            className="validator-switch"
                            checkedChildren={t('workflowDesigner.active')}
                            unCheckedChildren={t('workflowDesigner.inactive')}
                            onChange={(checked) => handleValidatorToggle('ai', checked)}
                          />
                        </Form.Item>
                        {aiIsActive && activeValidatorTab === 'ai' && (
                          <>
                            {!loadingAiProviders && aiProviders.length === 0 && (
                              <Alert
                                type="warning"
                                showIcon
                                message={t('workflowDesigner.aiProviderNotConfigured')}
                                style={{ marginBottom: 12 }}
                              />
                            )}
                            {aiProvidersError && (
                              <Alert
                                type="error"
                                showIcon
                                message={t('workflowDesigner.aiProviderLoadFailed')}
                                description={aiProvidersError}
                                style={{ marginBottom: 12 }}
                              />
                            )}
                            <Form.Item
                              label={t('workflowDesigner.validationAiProvider')}
                              name={['validation', 'aiProviderKey']}
                              rules={[{ required: true, message: t('workflowDesigner.validationAiProviderRequired') }]}
                            >
                              <SelectWithClearButton
                                clearText={t('workflowDesigner.clear')}
                                loading={loadingAiProviders}
                                placeholder={t('workflowDesigner.validationAiProviderPlaceholder')}
                                options={aiProviderOptions}
                              />
                            </Form.Item>
                            <AiStaffSelectField {...aiStaffSelectProps} />
                            <Form.Item
                              label={t('workflowDesigner.validationAiResultVariable')}
                              name={['validation', 'aiResultVariable']}
                              tooltip={t('workflowDesigner.validationAiResultVariableHelp')}
                            >
                              <SelectWithClearButton
                                clearText={t('workflowDesigner.clear')}
                                placeholder={t('workflowDesigner.validationAiResultVariablePlaceholder')}
                              >
                                {processVariables.map(pv => (
                                  <Select.Option key={pv.id} value={pv.variableName}>
                                    {pv.variableName} ({pv.dataType})
                                  </Select.Option>
                                ))}
                              </SelectWithClearButton>
                            </Form.Item>
                            <Form.Item
                              label={t('workflowDesigner.validationAiSuggestionVariable')}
                              name={['validation', 'aiSuggestionVariable']}
                              tooltip={t('workflowDesigner.validationAiSuggestionVariableHelp')}
                            >
                              <SelectWithClearButton
                                clearText={t('workflowDesigner.clear')}
                                placeholder={t('workflowDesigner.validationAiSuggestionVariablePlaceholder')}
                              >
                                {textOrStringProcessVariables.map(pv => (
                                  <Select.Option key={pv.id} value={pv.variableName}>
                                    {pv.variableName} ({pv.dataType})
                                  </Select.Option>
                                ))}
                              </SelectWithClearButton>
                            </Form.Item>
                            <Form.Item
                              label={t('workflowDesigner.validationAiFailReasonVariable')}
                              name={['validation', 'aiFailReasonVariable']}
                              tooltip={t('workflowDesigner.validationAiFailReasonVariableHelp')}
                            >
                              <SelectWithClearButton
                                clearText={t('workflowDesigner.clear')}
                                placeholder={t('workflowDesigner.validationAiFailReasonVariablePlaceholder')}
                              >
                                {textOrStringProcessVariables.map(pv => (
                                  <Select.Option key={pv.id} value={pv.variableName}>
                                    {pv.variableName} ({pv.dataType})
                                  </Select.Option>
                                ))}
                              </SelectWithClearButton>
                            </Form.Item>
                            <Form.Item 
                              label={t('workflowDesigner.promptText')} 
                              name={['validation', 'prompt']}
                              tooltip={t('workflowDesigner.qrCodeAiValidatorPromptHelp')}
                            >
                              <Input.TextArea
                                placeholder={t('workflowDesigner.qrCodeAiValidatorPromptPlaceholder')}
                                rows={6}
                              />
                            </Form.Item>
                            <Form.Item label={t('workflowDesigner.retryMessage')} name={['validation', 'retryMessage']}>
                              <Input placeholder={t('workflowDesigner.retryMessagePlaceholder')} />
                            </Form.Item>
                            <Form.Item label={t('workflowDesigner.maxRetries')} name={['validation', 'maxRetries']}>
                              <Input type="number" min="1" max="10" />
                            </Form.Item>
                          </>
                        )}
                      </Tabs.TabPane>
                      <Tabs.TabPane tab={t('workflowDesigner.timeValidatorLabel')} key="time">
                        <Form.Item
                          label={t('workflowDesigner.validatorActiveLabel')}
                          name={['validation', 'timeIsActive']}
                          valuePropName="checked"
                        >
                          <Switch
                            className="validator-switch"
                            checkedChildren={t('workflowDesigner.active')}
                            unCheckedChildren={t('workflowDesigner.inactive')}
                            onChange={(checked) => handleValidatorToggle('time', checked)}
                          />
                        </Form.Item>
                        {timeIsActive && activeValidatorTab === 'time' && (
                          <>
                            <Form.Item label={t('workflowDesigner.timeValidator.retryInterval')}>
                              <div style={{
                                display: 'grid',
                                gridTemplateColumns: isFullscreen ? '1fr 1fr 1fr' : '1fr',
                                gap: isFullscreen ? '12px' : '8px'
                              }}>
                                <Input 
                                  type="number" 
                                  min="0" 
                                  placeholder="0"
                                  value={selectedNode.data.validation?.retryIntervalDays || 0}
                                  onChange={(e) => {
                                    const newValidation = {
                                      ...(selectedNode.data.validation || {}),
                                      retryIntervalDays: parseInt(e.target.value) || 0
                                    };
                                    handleNodeDataChange({ validation: newValidation });
                                  }}
                                  addonAfter={t('workflowDesigner.days')}
                                />
                                <Input 
                                  type="number" 
                                  min="0" 
                                  max="23"
                                  placeholder="0"
                                  value={selectedNode.data.validation?.retryIntervalHours || 0}
                                  onChange={(e) => {
                                    const newValidation = {
                                      ...(selectedNode.data.validation || {}),
                                      retryIntervalHours: parseInt(e.target.value) || 0
                                    };
                                    handleNodeDataChange({ validation: newValidation });
                                  }}
                                  addonAfter={t('workflowDesigner.hours')}
                                />
                                <Input 
                                  type="number" 
                                  min="0" 
                                  max="59"
                                  placeholder="30"
                                  value={selectedNode.data.validation?.retryIntervalMinutes || 0}
                                  onChange={(e) => {
                                    const newValidation = {
                                      ...(selectedNode.data.validation || {}),
                                      retryIntervalMinutes: parseInt(e.target.value) || 0
                                    };
                                    handleNodeDataChange({ validation: newValidation });
                                  }}
                                  addonAfter={t('workflowDesigner.minutes')}
                                />
                              </div>
                            </Form.Item>
                            <Form.Item label={t('workflowDesigner.timeValidator.retryLimit')}>
                              <Input
                                type="number"
                                min="1"
                                placeholder="5"
                                value={selectedNode.data.validation?.retryLimitValue || 5}
                                onChange={(e) => {
                                  const newValidation = {
                                    ...(selectedNode.data.validation || {}),
                                    retryLimitValue: parseInt(e.target.value) || 5
                                  };
                                  handleNodeDataChange({ validation: newValidation });
                                }}
                              />
                            </Form.Item>
                            <TimeValidatorConfigSection
                              type="retryMessage"
                              selectedNode={selectedNode}
                              handleNodeDataChange={handleNodeDataChange}
                              form={form}
                              processVariables={processVariables}
                              workflowDefinitionId={workflowId}
                              onOpenTemplateModal={() => {
                                setTemplateModalSource('retryMessage');
                                setIsTemplateModalVisible(true);
                              }}
                              onOpenRecipientModal={() => {
                                setTemplateModalSource('retryMessage');
                                setTimeValidatorRecipientModalVisible(true);
                              }}
                              t={t}
                              config={selectedNode?.data?.validation?.retryMessageConfig}
                              title={t('workflowDesigner.timeValidator.configureRetryMessage')}
                              recipientsLabel={t('workflowDesigner.timeValidator.retryMessageRecipients')}
                              recipientsDescription={t('workflowDesigner.timeValidator.retryMessageRecipientsDescription')}
                              messageLabel={t('workflowDesigner.timeValidator.retryMessage')}
                              messageDescription={t('workflowDesigner.timeValidator.retryMessageDescription')}
                              messagePlaceholder={t('workflowDesigner.timeValidator.retryMessagePlaceholder')}
                              messageTip={t('workflowDesigner.timeValidator.retryMessageTip')}
                              expanded={retryMessageExpanded}
                              onToggleExpanded={setRetryMessageExpanded}
                              metaTemplates={metaTemplates}
                            />
                            <TimeValidatorConfigSection
                              type="escalation"
                              selectedNode={selectedNode}
                              handleNodeDataChange={handleNodeDataChange}
                              form={form}
                              processVariables={processVariables}
                              workflowDefinitionId={workflowId}
                              onOpenTemplateModal={() => {
                                setTemplateModalSource('escalation');
                                setIsTemplateModalVisible(true);
                              }}
                              onOpenRecipientModal={() => {
                                setTemplateModalSource('escalation');
                                setTimeValidatorRecipientModalVisible(true);
                              }}
                              t={t}
                              config={selectedNode?.data?.validation?.escalationConfig}
                              title={t('workflowDesigner.timeValidator.configureEscalation')}
                              recipientsLabel={t('workflowDesigner.timeValidator.escalationRecipients')}
                              recipientsDescription={t('workflowDesigner.timeValidator.escalationRecipientsDescription')}
                              messageLabel={t('workflowDesigner.timeValidator.escalationMessage')}
                              messageDescription={t('workflowDesigner.timeValidator.escalationMessageDescription')}
                              messagePlaceholder={t('workflowDesigner.timeValidator.escalationMessagePlaceholder')}
                              messageTip={t('workflowDesigner.timeValidator.escalationMessageTip')}
                              expanded={escalationConfigExpanded}
                              onToggleExpanded={setEscalationConfigExpanded}
                              metaTemplates={metaTemplates}
                            />
                          </>
                        )}
                      </Tabs.TabPane>
                      {renderTimeoutCompleteTabPane()}
                    </Tabs>
                  </Card>
                </Form.Item>
                
                      </>
                    ),
                  },
                  {
                    key: 'description',
                    icon: <InfoCircleOutlined />,
                    tooltip: t('workflowDesigner.sectionDescription'),
                    children: (
                      <Card size="small" title={t('workflowDesigner.functionDescription')} style={{ marginTop: 16 }}>
                        <p style={{ fontSize: '12px', margin: '4px 0' }}>
                          {t('workflowDesigner.qrCodeDescription1')}
                        </p>
                        <p style={{ fontSize: '12px', margin: '4px 0' }}>
                          {t('workflowDesigner.qrCodeDescription2')}
                        </p>
                        <p style={{ fontSize: '12px', margin: '4px 0', color: '#1890ff' }}>
                          {t('workflowDesigner.qrCodeDescription3')}
                        </p>
                      </Card>
                    ),
                  },
                ]}
              />
            )}

            {/* ???????????? */}
            {selectedNode.data.type === 'waitForLocation' && (
              <PropertySectionTabs
                resetKey={selectedNode.id}
                sections={[
                  {
                    key: 'recipientAndMessage',
                    icon: <MessageOutlined />,
                    tooltip: t('workflowDesigner.sectionRecipientAndMessage'),
                    children: (
                      <>
                <Form.Item label={t('workflowDesigner.replyType')} name="replyType">
                  <Select
                    options={[
                      { value: 'initiator', label: t('workflowDesigner.initiator') },
                      { value: 'specified', label: t('workflowDesigner.specifiedPerson') },
                    ]}
                  />
                </Form.Item>

                {selectedNode.data.replyType === 'specified' && (
                  <Form.Item label={t('workflowDesigner.specifiedPerson')}>
                    <div style={{ position: 'relative' }}>
                      <RecipientSelector
                        value={selectedNode.data.specifiedUsers || ''}
                        recipientDetails={selectedNode.data.recipientDetails}
                        placeholder={t('workflowDesigner.selectRecipients')}
                        compact={true}
                        workflowDefinitionId={workflowId}
                        onChange={(value, detailedValue) => {
                          if (value === '' && detailedValue === null) {
                            setIsRecipientModalVisible(true);
                          } else {
                            handleNodeDataChange({
                              specifiedUsers: value,
                              recipientDetails: detailedValue,
                            });
                          }
                        }}
                      />
                      <div
                        style={{
                          position: 'absolute',
                          right: '8px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          display: 'flex',
                          gap: '4px',
                        }}
                      >
                        {selectedNode.data.specifiedUsers && (
                          <Button
                            type="text"
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleNodeDataChange({ specifiedUsers: '', recipientDetails: null });
                            }}
                            style={{ padding: '0 4px', fontSize: '12px' }}
                          >
                            {t('workflowDesigner.clear')}
                          </Button>
                        )}
                      </div>
                    </div>
                  </Form.Item>
                )}

                <Divider />
                <WaitReplyMessageTabsComponent
                  selectedNode={selectedNode}
                  handleNodeDataChange={handleNodeDataChange}
                  setIsTemplateModalVisible={setIsTemplateModalVisible}
                  processVariables={processVariables}
                  form={form}
                  t={t}
                  metaTemplates={metaTemplates}
                  hideEmailTab
                  promptMessageHelpKey="workflowDesigner.waitForLocationPromptMessageHelp"
                />
                      </>
                    ),
                  },
                  {
                    key: 'validation',
                    icon: <SafetyOutlined />,
                    tooltip: t('workflowDesigner.sectionValidation'),
                    children: (
                      <Form.Item label={t('workflowDesigner.validationConfig')}>
                  <Card
                    size="small"
                    title={t('workflowDesigner.validationSettings')}
                    style={{ marginBottom: 16 }}
                  >
                    <Tabs
                      activeKey={activeValidatorTab}
                      onChange={(key) => setActiveValidatorTab(key)}
                    >
                      <Tabs.TabPane tab={t('workflowDesigner.aiValidator')} key="ai">
                        <Form.Item
                          label={t('workflowDesigner.validatorActiveLabel')}
                          name={['validation', 'aiIsActive']}
                          valuePropName="checked"
                        >
                          <Switch
                            className="validator-switch"
                            checkedChildren={t('workflowDesigner.active')}
                            unCheckedChildren={t('workflowDesigner.inactive')}
                            onChange={(checked) => handleValidatorToggle('ai', checked)}
                          />
                        </Form.Item>
                        {aiIsActive && activeValidatorTab === 'ai' && (
                          <>
                            {!loadingAiProviders && aiProviders.length === 0 && (
                              <Alert
                                type="warning"
                                showIcon
                                message={t('workflowDesigner.aiProviderNotConfigured')}
                                style={{ marginBottom: 12 }}
                              />
                            )}
                            {aiProvidersError && (
                              <Alert
                                type="error"
                                showIcon
                                message={t('workflowDesigner.aiProviderLoadFailed')}
                                description={aiProvidersError}
                                style={{ marginBottom: 12 }}
                              />
                            )}
                            <Form.Item
                              label={t('workflowDesigner.validationAiProvider')}
                              name={['validation', 'aiProviderKey']}
                              rules={[{ required: true, message: t('workflowDesigner.validationAiProviderRequired') }]}
                            >
                              <SelectWithClearButton
                                clearText={t('workflowDesigner.clear')}
                                loading={loadingAiProviders}
                                placeholder={t('workflowDesigner.validationAiProviderPlaceholder')}
                                options={aiProviderOptions}
                              />
                            </Form.Item>
                            <AiStaffSelectField {...aiStaffSelectProps} />
                            <Form.Item
                              label={t('workflowDesigner.validationAiResultVariable')}
                              name={['validation', 'aiResultVariable']}
                              tooltip={t('workflowDesigner.validationAiResultVariableHelp')}
                            >
                              <SelectWithClearButton
                                clearText={t('workflowDesigner.clear')}
                                placeholder={t('workflowDesigner.validationAiResultVariablePlaceholder')}
                              >
                                {processVariables.map(pv => (
                                  <Select.Option key={pv.id} value={pv.variableName}>
                                    {pv.variableName} ({pv.dataType})
                                  </Select.Option>
                                ))}
                              </SelectWithClearButton>
                            </Form.Item>
                            <Form.Item
                              label={t('workflowDesigner.validationAiSuggestionVariable')}
                              name={['validation', 'aiSuggestionVariable']}
                              tooltip={t('workflowDesigner.validationAiSuggestionVariableHelp')}
                            >
                              <SelectWithClearButton
                                clearText={t('workflowDesigner.clear')}
                                placeholder={t('workflowDesigner.validationAiSuggestionVariablePlaceholder')}
                              >
                                {textOrStringProcessVariables.map(pv => (
                                  <Select.Option key={pv.id} value={pv.variableName}>
                                    {pv.variableName} ({pv.dataType})
                                  </Select.Option>
                                ))}
                              </SelectWithClearButton>
                            </Form.Item>
                            <Form.Item
                              label={t('workflowDesigner.validationAiFailReasonVariable')}
                              name={['validation', 'aiFailReasonVariable']}
                              tooltip={t('workflowDesigner.validationAiFailReasonVariableHelp')}
                            >
                              <SelectWithClearButton
                                clearText={t('workflowDesigner.clear')}
                                placeholder={t('workflowDesigner.validationAiFailReasonVariablePlaceholder')}
                              >
                                {textOrStringProcessVariables.map(pv => (
                                  <Select.Option key={pv.id} value={pv.variableName}>
                                    {pv.variableName} ({pv.dataType})
                                  </Select.Option>
                                ))}
                              </SelectWithClearButton>
                            </Form.Item>
                            <Form.Item label={t('workflowDesigner.promptText')} name={['validation', 'prompt']}>
                              <Input.TextArea
                                placeholder={t('workflowDesigner.promptTextPlaceholder')}
                                rows={6}
                              />
                            </Form.Item>
                            <Form.Item label={t('workflowDesigner.retryMessage')} name={['validation', 'retryMessage']}>
                              <Input placeholder={t('workflowDesigner.retryMessagePlaceholder')} />
                            </Form.Item>
                            <Form.Item label={t('workflowDesigner.maxRetries')} name={['validation', 'maxRetries']}>
                              <Input type="number" min="1" max="10" />
                            </Form.Item>

                            <WorkflowKnowledgeBaseSettingsControl
                              showDivider
                              nodeData={selectedNode.data}
                              onApply={(patch) => handleNodeDataChange(patch)}
                              dataSets={dataSets}
                              loadingDataSets={loadingDataSets}
                              knowledgeStudioDocs={knowledgeStudioDocs}
                              loadingKnowledgeStudioDocs={loadingKnowledgeStudioDocs}
                              broadcastGroups={broadcastGroups}
                              loadingBroadcastGroups={loadingBroadcastGroups}
                              processVariables={processVariables}
                              generateWhereClause={generateWhereClause}
                              t={t}
                            />
                          </>
                        )}
                      </Tabs.TabPane>
                      <Tabs.TabPane tab={t('workflowDesigner.timeValidatorLabel')} key="time">
                        <Form.Item
                          label={t('workflowDesigner.validatorActiveLabel')}
                          name={['validation', 'timeIsActive']}
                          valuePropName="checked"
                        >
                          <Switch
                            className="validator-switch"
                            checkedChildren={t('workflowDesigner.active')}
                            unCheckedChildren={t('workflowDesigner.inactive')}
                            onChange={(checked) => handleValidatorToggle('time', checked)}
                          />
                        </Form.Item>
                        {timeIsActive && activeValidatorTab === 'time' && (
                          <>
                            <Form.Item label={t('workflowDesigner.timeValidator.retryInterval')}>
                              <div style={{
                                display: 'grid',
                                gridTemplateColumns: isFullscreen ? '1fr 1fr 1fr' : '1fr',
                                gap: isFullscreen ? '12px' : '8px'
                              }}>
                                <Input
                                  type="number"
                                  min="0"
                                  placeholder="0"
                                  value={selectedNode.data.validation?.retryIntervalDays || 0}
                                  onChange={(e) => {
                                    const newValidation = {
                                      ...(selectedNode.data.validation || {}),
                                      retryIntervalDays: parseInt(e.target.value) || 0
                                    };
                                    handleNodeDataChange({ validation: newValidation });
                                  }}
                                  addonAfter={t('workflowDesigner.days')}
                                />
                                <Input
                                  type="number"
                                  min="0"
                                  max="23"
                                  placeholder="0"
                                  value={selectedNode.data.validation?.retryIntervalHours || 0}
                                  onChange={(e) => {
                                    const newValidation = {
                                      ...(selectedNode.data.validation || {}),
                                      retryIntervalHours: parseInt(e.target.value) || 0
                                    };
                                    handleNodeDataChange({ validation: newValidation });
                                  }}
                                  addonAfter={t('workflowDesigner.hours')}
                                />
                                <Input
                                  type="number"
                                  min="0"
                                  max="59"
                                  placeholder="30"
                                  value={selectedNode.data.validation?.retryIntervalMinutes || 0}
                                  onChange={(e) => {
                                    const newValidation = {
                                      ...(selectedNode.data.validation || {}),
                                      retryIntervalMinutes: parseInt(e.target.value) || 0
                                    };
                                    handleNodeDataChange({ validation: newValidation });
                                  }}
                                  addonAfter={t('workflowDesigner.minutes')}
                                />
                              </div>
                            </Form.Item>
                            <Form.Item label={t('workflowDesigner.timeValidator.retryLimit')}>
                              <Input
                                type="number"
                                min="1"
                                placeholder="5"
                                value={selectedNode.data.validation?.retryLimitValue || 5}
                                onChange={(e) => {
                                  const newValidation = {
                                    ...(selectedNode.data.validation || {}),
                                    retryLimitValue: parseInt(e.target.value) || 5
                                  };
                                  handleNodeDataChange({ validation: newValidation });
                                }}
                              />
                            </Form.Item>
                            <TimeValidatorConfigSection
                              type="retryMessage"
                              selectedNode={selectedNode}
                              handleNodeDataChange={handleNodeDataChange}
                              form={form}
                              processVariables={processVariables}
                              workflowDefinitionId={workflowId}
                              onOpenTemplateModal={() => {
                                setTemplateModalSource('retryMessage');
                                setIsTemplateModalVisible(true);
                              }}
                              onOpenRecipientModal={() => {
                                setTemplateModalSource('retryMessage');
                                setTimeValidatorRecipientModalVisible(true);
                              }}
                              t={t}
                              config={selectedNode?.data?.validation?.retryMessageConfig}
                              title={t('workflowDesigner.timeValidator.configureRetryMessage')}
                              recipientsLabel={t('workflowDesigner.timeValidator.retryMessageRecipients')}
                              recipientsDescription={t('workflowDesigner.timeValidator.retryMessageRecipientsDescription')}
                              messageLabel={t('workflowDesigner.timeValidator.retryMessage')}
                              messageDescription={t('workflowDesigner.timeValidator.retryMessageDescription')}
                              messagePlaceholder={t('workflowDesigner.timeValidator.retryMessagePlaceholder')}
                              messageTip={t('workflowDesigner.timeValidator.retryMessageTip')}
                              expanded={retryMessageExpanded}
                              onToggleExpanded={setRetryMessageExpanded}
                              metaTemplates={metaTemplates}
                            />
                            <TimeValidatorConfigSection
                              type="escalation"
                              selectedNode={selectedNode}
                              handleNodeDataChange={handleNodeDataChange}
                              form={form}
                              processVariables={processVariables}
                              workflowDefinitionId={workflowId}
                              onOpenTemplateModal={() => {
                                setTemplateModalSource('escalation');
                                setIsTemplateModalVisible(true);
                              }}
                              onOpenRecipientModal={() => {
                                setTemplateModalSource('escalation');
                                setTimeValidatorRecipientModalVisible(true);
                              }}
                              t={t}
                              config={selectedNode?.data?.validation?.escalationConfig}
                              title={t('workflowDesigner.timeValidator.configureEscalation')}
                              recipientsLabel={t('workflowDesigner.timeValidator.escalationRecipients')}
                              recipientsDescription={t('workflowDesigner.timeValidator.escalationRecipientsDescription')}
                              messageLabel={t('workflowDesigner.timeValidator.escalationMessage')}
                              messageDescription={t('workflowDesigner.timeValidator.escalationMessageDescription')}
                              messagePlaceholder={t('workflowDesigner.timeValidator.escalationMessagePlaceholder')}
                              messageTip={t('workflowDesigner.timeValidator.escalationMessageTip')}
                              expanded={escalationConfigExpanded}
                              onToggleExpanded={setEscalationConfigExpanded}
                              metaTemplates={metaTemplates}
                            />
                          </>
                        )}
                      </Tabs.TabPane>
                      {renderTimeoutCompleteTabPane()}
                    </Tabs>
                  </Card>
                </Form.Item>
                    ),
                  },
                  {
                    key: 'location',
                    icon: <EnvironmentOutlined />,
                    tooltip: t('workflowDesigner.sectionLocation'),
                    children: (
                      <>
                        <Form.Item
                          label={t('workflowDesigner.locationRequestBody')}
                          name="locationRequestBody"
                          rules={[{ required: true, message: t('workflowDesigner.locationRequestBodyRequired') }]}
                        >
                          <Input.TextArea
                            rows={3}
                            maxLength={1024}
                            showCount
                            placeholder={t('workflowDesigner.locationRequestBodyPlaceholder')}
                            onChange={(e) => handleNodeDataChange({ locationRequestBody: e.target.value })}
                          />
                        </Form.Item>

                        <Form.Item label={t('workflowDesigner.locationResultVariable')} name="locationVariable">
                          <Select placeholder={t('workflowDesigner.selectProcessVariable')} allowClear>
                            {processVariables.map((pv) => (
                              <Select.Option key={pv.id} value={pv.variableName}>
                                {pv.variableName} ({pv.dataType})
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </>
                    ),
                  },
                  {
                    key: 'description',
                    icon: <InfoCircleOutlined />,
                    tooltip: t('workflowDesigner.sectionDescription'),
                    children: (
                      <Card size="small" title={t('workflowDesigner.functionDescription')} style={{ marginTop: 16 }}>
                        <p style={{ fontSize: '12px', margin: '4px 0' }}>{t('workflowDesigner.waitForLocationDesc1')}</p>
                        <p style={{ fontSize: '12px', margin: '4px 0', color: '#1890ff' }}>
                          {t('workflowDesigner.waitForLocationDesc2')}
                        </p>
                      </Card>
                    ),
                  },
                ]}
              />
            )}

            {/* ?? Email ???? */}
            {selectedNode.data.type === 'waitForEmailReply' && (
              <PropertySectionTabs
                resetKey={selectedNode.id}
                sections={[
                  {
                    key: 'recipient',
                    icon: <MailOutlined />,
                    tooltip: t('workflowDesigner.sectionRecipient'),
                    children: (
                      <>
                        <Form.Item label={t('workflowDesigner.emailProvider')} name="emailProviderKey">
                          <Select
                            allowClear
                            placeholder={t('workflowDesigner.emailProviderPlaceholder')}
                            loading={loadingEmailProviders}
                            options={emailProviders.map(p => ({ value: p.providerKey, label: p.displayName || p.name || p.providerKey }))}
                            notFoundContent={t('workflowDesigner.emailNoProviderConfigured')}
                          />
                        </Form.Item>
                        <Form.Item label={t('workflowDesigner.emailMonitorMailbox')} name="emailMonitorMailbox">
                          <Input placeholder={t('workflowDesigner.emailMonitorMailboxPlaceholder')} allowClear />
                        </Form.Item>
                      </>
                    ),
                  },
                  {
                    key: 'emailFilter',
                    icon: <FilterOutlined />,
                    tooltip: t('workflowDesigner.sectionEmailFilter'),
                    children: (
                      <>
                <Form.Item label={t('workflowDesigner.emailFilterSender')} name="emailFilterSender">
                  <Select mode="tags" placeholder={t('workflowDesigner.emailFilterSenderPlaceholder')} tokenSeparators={[',', '?']} style={{ width: '100%' }} open={undefined} maxTagCount="responsive" />
                </Form.Item>
                <Form.Item label={t('workflowDesigner.emailFilterSubject')} name="emailFilterSubject">
                  <Select mode="tags" placeholder={t('workflowDesigner.emailFilterSubjectPlaceholder')} tokenSeparators={[',', '?', '\n']} style={{ width: '100%' }} open={undefined} maxTagCount="responsive" />
                </Form.Item>
                <Form.Item label={t('workflowDesigner.emailFilterKeywordsRequired')} name="emailFilterKeywordsRequired">
                  <Select mode="tags" placeholder={t('workflowDesigner.emailFilterKeywordsRequiredPlaceholder')} tokenSeparators={[',', '?', '\n']} style={{ width: '100%' }} open={undefined} maxTagCount="responsive" />
                </Form.Item>
                <Alert type="info" showIcon message={t('workflowDesigner.emailFilterKeywordsMatchHint')} style={{ marginBottom: 16 }} />
                <Form.Item label={t('workflowDesigner.emailFilterSenderNot')} name="emailFilterSenderNot">
                  <Select mode="tags" placeholder={t('workflowDesigner.emailFilterSenderNotPlaceholder')} tokenSeparators={[',', '?']} style={{ width: '100%' }} open={undefined} maxTagCount="responsive" />
                </Form.Item>
                <Form.Item label={t('workflowDesigner.emailFilterSubjectNot')} name="emailFilterSubjectNot">
                  <Select mode="tags" placeholder={t('workflowDesigner.emailFilterSubjectNotPlaceholder')} tokenSeparators={[',', '?']} style={{ width: '100%' }} open={undefined} maxTagCount="responsive" />
                </Form.Item>
                <Form.Item label={t('workflowDesigner.emailFilterBodyKeywordsNot')} name="emailFilterBodyKeywordsNot">
                  <Select mode="tags" placeholder={t('workflowDesigner.emailFilterBodyKeywordsNotPlaceholder')} tokenSeparators={[',', '?', '\n']} style={{ width: '100%' }} open={undefined} maxTagCount="responsive" />
                </Form.Item>
                <Form.Item label={t('workflowDesigner.emailFilterHasAttachment')} name="emailFilterHasAttachment" valuePropName="checked">
                  <Switch checkedChildren={t('workflowDesigner.yes')} unCheckedChildren={t('workflowDesigner.no')} />
                </Form.Item>
                <Form.Item label={t('workflowDesigner.emailFilterAttachmentExtensions')} name="emailFilterAttachmentExtensions">
                  <Select mode="tags" placeholder={t('workflowDesigner.emailFilterAttachmentExtensionsPlaceholder')} tokenSeparators={[',', '?', '\n']} style={{ width: '100%' }} open={undefined} maxTagCount="responsive" />
                </Form.Item>
                <Form.Item label={t('workflowDesigner.emailFilterAttachmentFileName')} name="emailFilterAttachmentFileName">
                  <Select mode="tags" placeholder={t('workflowDesigner.emailFilterAttachmentFileNamePlaceholder')} tokenSeparators={[',', '?', '\n']} style={{ width: '100%' }} open={undefined} maxTagCount="responsive" />
                </Form.Item>
                <Form.Item label={t('workflowDesigner.emailFilterAttachmentFileNameNot')} name="emailFilterAttachmentFileNameNot">
                  <Select mode="tags" placeholder={t('workflowDesigner.emailFilterAttachmentFileNameNotPlaceholder')} tokenSeparators={[',', '?', '\n']} style={{ width: '100%' }} open={undefined} maxTagCount="responsive" />
                </Form.Item>
                      </>
                    ),
                  },
                  {
                    key: 'validation',
                    icon: <SafetyOutlined />,
                    tooltip: t('workflowDesigner.sectionValidation'),
                    children: (
                      <>
                <Form.Item label={t('workflowDesigner.validationConfig')}>
                  <Card size="small" title={t('workflowDesigner.validationSettings')} style={{ marginBottom: 16 }}>
                    <Tabs activeKey={activeValidatorTab} onChange={(key) => setActiveValidatorTab(key)}>
                      <Tabs.TabPane tab={t('workflowDesigner.aiValidator')} key="ai">
                        <Form.Item label={t('workflowDesigner.validatorActiveLabel')} name={['validation', 'aiIsActive']} valuePropName="checked">
                          <Switch className="validator-switch" checkedChildren={t('workflowDesigner.active')} unCheckedChildren={t('workflowDesigner.inactive')} onChange={(checked) => handleValidatorToggle('ai', checked)} />
                        </Form.Item>
                        {aiIsActive && activeValidatorTab === 'ai' && (
                          <>
                            <Form.Item
                              label={t('workflowDesigner.validationAiProvider')}
                              name={['validation', 'aiProviderKey']}
                              rules={[{ required: true, message: t('workflowDesigner.validationAiProviderRequired') }]}
                            >
                              <SelectWithClearButton clearText={t('workflowDesigner.clear')} loading={loadingAiProviders} placeholder={t('workflowDesigner.validationAiProviderPlaceholder')} options={aiProviderOptions} />
                            </Form.Item>
                            <AiStaffSelectField {...aiStaffSelectProps} />
                            <Form.Item label={t('workflowDesigner.promptText')} name={['validation', 'prompt']}>
                              <Input.TextArea placeholder={t('workflowDesigner.promptTextPlaceholder')} rows={6} />
                            </Form.Item>
                            <Form.Item label={t('workflowDesigner.retryMessage')} name={['validation', 'retryMessage']}>
                              <Input placeholder={t('workflowDesigner.retryMessagePlaceholder')} />
                            </Form.Item>
                            <Form.Item label={t('workflowDesigner.maxRetries')} name={['validation', 'maxRetries']}>
                              <Input type="number" min="1" max="10" />
                            </Form.Item>
                          </>
                        )}
                      </Tabs.TabPane>
                      <Tabs.TabPane tab={t('workflowDesigner.timeValidatorLabel')} key="time">
                        <Form.Item label={t('workflowDesigner.validatorActiveLabel')} name={['validation', 'timeIsActive']} valuePropName="checked">
                          <Switch className="validator-switch" checkedChildren={t('workflowDesigner.active')} unCheckedChildren={t('workflowDesigner.inactive')} onChange={(checked) => handleValidatorToggle('time', checked)} />
                        </Form.Item>
                        {timeIsActive && activeValidatorTab === 'time' && (
                          <>
                            <Form.Item label={t('workflowDesigner.timeValidator.retryInterval')}>
                              <div style={{ display: 'grid', gridTemplateColumns: isFullscreen ? '1fr 1fr 1fr' : '1fr', gap: isFullscreen ? '12px' : '8px' }}>
                                <Input type="number" min="0" placeholder="0" value={selectedNode.data.validation?.retryIntervalDays || 0} onChange={(e) => handleNodeDataChange({ validation: { ...(selectedNode.data.validation || {}), retryIntervalDays: parseInt(e.target.value) || 0 } })} addonAfter={t('workflowDesigner.days')} />
                                <Input type="number" min="0" max="23" placeholder="0" value={selectedNode.data.validation?.retryIntervalHours || 0} onChange={(e) => handleNodeDataChange({ validation: { ...(selectedNode.data.validation || {}), retryIntervalHours: parseInt(e.target.value) || 0 } })} addonAfter={t('workflowDesigner.hours')} />
                                <Input type="number" min="0" max="59" placeholder="30" value={selectedNode.data.validation?.retryIntervalMinutes || 0} onChange={(e) => handleNodeDataChange({ validation: { ...(selectedNode.data.validation || {}), retryIntervalMinutes: parseInt(e.target.value) || 0 } })} addonAfter={t('workflowDesigner.minutes')} />
                              </div>
                            </Form.Item>
                            <Form.Item label={t('workflowDesigner.timeValidator.retryLimit')}>
                              <Input type="number" min="1" placeholder="5" value={selectedNode.data.validation?.retryLimitValue || 5} onChange={(e) => handleNodeDataChange({ validation: { ...(selectedNode.data.validation || {}), retryLimitValue: parseInt(e.target.value) || 5 } })} />
                            </Form.Item>
                            <TimeValidatorConfigSection
                              type="retryMessage"
                              selectedNode={selectedNode}
                              handleNodeDataChange={handleNodeDataChange}
                              form={form}
                              processVariables={processVariables}
                              workflowDefinitionId={workflowId}
                              onOpenTemplateModal={() => { setTemplateModalSource('retryMessage'); setIsTemplateModalVisible(true); }}
                              onOpenRecipientModal={() => { setTemplateModalSource('retryMessage'); setTimeValidatorRecipientModalVisible(true); }}
                              t={t}
                              config={selectedNode?.data?.validation?.retryMessageConfig}
                              title={t('workflowDesigner.timeValidator.configureRetryMessage')}
                              recipientsLabel={t('workflowDesigner.timeValidator.retryMessageRecipients')}
                              recipientsDescription={t('workflowDesigner.timeValidator.retryMessageRecipientsDescription')}
                              messageLabel={t('workflowDesigner.timeValidator.retryMessage')}
                              messageDescription={t('workflowDesigner.timeValidator.retryMessageDescription')}
                              messagePlaceholder={t('workflowDesigner.timeValidator.retryMessagePlaceholder')}
                              messageTip={t('workflowDesigner.timeValidator.retryMessageTip')}
                              expanded={retryMessageExpanded}
                              onToggleExpanded={setRetryMessageExpanded}
                              metaTemplates={metaTemplates}
                            />
                            <TimeValidatorConfigSection
                              type="escalation"
                              selectedNode={selectedNode}
                              handleNodeDataChange={handleNodeDataChange}
                              form={form}
                              processVariables={processVariables}
                              workflowDefinitionId={workflowId}
                              onOpenTemplateModal={() => { setTemplateModalSource('escalation'); setIsTemplateModalVisible(true); }}
                              onOpenRecipientModal={() => { setTemplateModalSource('escalation'); setTimeValidatorRecipientModalVisible(true); }}
                              t={t}
                              config={selectedNode?.data?.validation?.escalationConfig}
                              title={t('workflowDesigner.timeValidator.configureEscalation')}
                              recipientsLabel={t('workflowDesigner.timeValidator.escalationRecipients')}
                              recipientsDescription={t('workflowDesigner.timeValidator.escalationRecipientsDescription')}
                              messageLabel={t('workflowDesigner.timeValidator.escalationMessage')}
                              messageDescription={t('workflowDesigner.timeValidator.escalationMessageDescription')}
                              messagePlaceholder={t('workflowDesigner.timeValidator.escalationMessagePlaceholder')}
                              messageTip={t('workflowDesigner.timeValidator.escalationMessageTip')}
                              expanded={escalationConfigExpanded}
                              onToggleExpanded={setEscalationConfigExpanded}
                              metaTemplates={metaTemplates}
                            />
                          </>
                        )}
                      </Tabs.TabPane>
                      {renderTimeoutCompleteTabPane()}
                    </Tabs>
                  </Card>
                </Form.Item>

                <Card size="small" title={t('workflowDesigner.waitForEmailReplyAutoCompleteTitle')} style={{ marginBottom: 16 }}>
                  <Form.Item label={t('workflowDesigner.waitForEmailReplyAutoCompleteEnable')} name={['validation', 'autoCompleteOnTimeout']} valuePropName="checked">
                    <Switch checkedChildren={t('workflowDesigner.active')} unCheckedChildren={t('workflowDesigner.inactive')} />
                  </Form.Item>
                  {selectedNode?.data?.validation?.autoCompleteOnTimeout && (
                    <Form.Item label={t('workflowDesigner.waitForEmailReplyAutoCompleteTimeout')}>
                      <div style={{ display: 'grid', gridTemplateColumns: isFullscreen ? '1fr 1fr 1fr' : '1fr', gap: isFullscreen ? '12px' : '8px' }}>
                        <Input type="number" min="0" placeholder="0" value={selectedNode.data.validation?.autoCompleteTimeoutDays || 0} onChange={(e) => handleNodeDataChange({ validation: { ...(selectedNode.data.validation || {}), autoCompleteTimeoutDays: parseInt(e.target.value) || 0 } })} addonAfter={t('workflowDesigner.days')} />
                        <Input type="number" min="0" max="23" placeholder="0" value={selectedNode.data.validation?.autoCompleteTimeoutHours || 0} onChange={(e) => handleNodeDataChange({ validation: { ...(selectedNode.data.validation || {}), autoCompleteTimeoutHours: parseInt(e.target.value) || 0 } })} addonAfter={t('workflowDesigner.hours')} />
                        <Input type="number" min="0" max="59" placeholder="0" value={selectedNode.data.validation?.autoCompleteTimeoutMinutes || 0} onChange={(e) => handleNodeDataChange({ validation: { ...(selectedNode.data.validation || {}), autoCompleteTimeoutMinutes: parseInt(e.target.value) || 0 } })} addonAfter={t('workflowDesigner.minutes')} />
                      </div>
                    </Form.Item>
                  )}
                </Card>
                      </>
                    ),
                  },
                ]}
              />
            )}

            {/* ??????? */}
            {selectedNode.data.type === 'processDataCell' && (
              <ProcessDataCellEditor
                assignmentRules={selectedNode.data.assignmentRules || []}
                onChange={(newRules) => handleNodeDataChange({ assignmentRules: newRules })}
                processVariables={processVariables}
                nodes={nodes}
                eformFieldsMap={eformFieldsMap}
                selectedNode={selectedNode}
                aiProviders={aiProviders}
                aiStaffs={aiStaffs}
                aiStaffOptions={aiStaffOptions}
                loadingAiStaffs={loadingAiStaffs}
                handleAiStaffChange={handleAiStaffChange}
                handleNodeDataChange={handleNodeDataChange}
                t={t}
              />
            )}

            {/* DataSet ???? */}
            {selectedNode.data.type === 'dataSetQuery' && (
              <PropertySectionTabs
                resetKey={selectedNode.id}
                sections={[
                  {
                    key: 'data',
                    icon: <DatabaseOutlined />,
                    tooltip: t('workflowDesigner.sectionData'),
                    children: (
                      <>
                <Form.Item label={t('workflowDesigner.dataSet.selectDataSet')} name="dataSetId">
                  <Select 
                    placeholder={t('workflowDesigner.dataSet.selectDataSetPlaceholder')}
                    loading={loadingDataSets}
                    onChange={(value) => {
                      handleNodeDataChange({ dataSetId: value });
                      loadDataSetColumns(value);
                    }}
                  >
                    {dataSets.map(ds => (
                      <Select.Option key={ds.id} value={ds.id}>
                        {ds.name} ({ds.dataSourceType})
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                
                <Form.Item label={t('workflowDesigner.dataSet.operationType')} name="operationType">
                  <Select 
                    placeholder={t('workflowDesigner.dataSet.operationTypePlaceholder')}
                    onChange={(value) => {
                      // ????????
                      setQueryPreviewData([]);
                      setQueryPreviewModalVisible(false);
                      handleNodeDataChange({ operationType: value });
                    }}
                  >
                    <Select.Option value="SELECT">{t('workflowDesigner.dataSet.select')}</Select.Option>
                    <Select.Option value="INSERT">{t('workflowDesigner.dataSet.insert')}</Select.Option>
                    <Select.Option value="UPDATE">{t('workflowDesigner.dataSet.update')}</Select.Option>
                    <Select.Option value="DELETE">{t('workflowDesigner.dataSet.delete')}</Select.Option>
                  </Select>
                </Form.Item>
                
                  {/* ???? - SELECT/UPDATE/DELETE ??? */}
                  {(selectedNode.data.operationType === 'SELECT' || 
                    selectedNode.data.operationType === 'UPDATE' || 
                    selectedNode.data.operationType === 'DELETE') && (
                    <Form.Item label={t('workflowDesigner.dataSet.queryConditions')}>
                      <DataSetQueryConditionGroupsEditor
                        conditionGroups={selectedNode.data.queryConditionGroups || []}
                        onConditionGroupsChange={(groups) => handleNodeDataChange({ queryConditionGroups: groups })}
                        generateWhereClause={generateWhereClause}
                        t={t}
                        processVariables={processVariables}
                        dataSetColumns={dataSetColumns}
                        loadDataSetColumns={loadDataSetColumns}
                        dataSetId={selectedNode.data.dataSetId}
                      />
                    </Form.Item>
                  )}
                
                {/* ???? - INSERT/UPDATE ??? */}
                {(selectedNode.data.operationType === 'INSERT' || 
                  selectedNode.data.operationType === 'UPDATE') && (
                  <>
                    <Form.Item label={t('workflowDesigner.dataSet.operationData')}>
                      <div style={{ marginBottom: '8px' }}>
                        <Button 
                          type="dashed" 
                          onClick={handleOpenOperationDataModal}
                          icon={<SettingOutlined />}
                          style={{ width: '100%' }}
                          disabled={!selectedNode.data.dataSetId}
                        >
                          {t('workflowDesigner.dataSet.setOperationData')}
                        </Button>
                      </div>
                      {operationDataFields.length > 0 && (
                        <div style={{ 
                          border: '1px solid #d9d9d9', 
                          borderRadius: '4px', 
                          padding: '8px', 
                          backgroundColor: '#f9f9f9',
                          fontSize: '12px',
                          color: '#666'
                        }}>
                          {t('workflowDesigner.dataSet.operationDataSummary', { count: operationDataFields.length })}
                        </div>
                      )}
                    </Form.Item>
                  </>
                )}
                
                  {/* TOP N - SELECT ??? */}
                  {selectedNode.data.operationType === 'SELECT' && (
                    <Form.Item
                      label={t('workflowDesigner.dataSet.queryTopRows')}
                      style={{ marginBottom: '12px' }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <InputNumber
                          min={1}
                          max={100000}
                          step={1}
                          precision={0}
                          style={{ width: '140px' }}
                          placeholder={t('workflowDesigner.dataSet.queryTopRowsPlaceholder')}
                          value={selectedNode.data.queryTopRows || null}
                          onChange={(value) => handleNodeDataChange({ queryTopRows: value || null })}
                          allowClear
                        />
                        <span style={{ fontSize: '12px', color: '#888' }}>
                          {t('workflowDesigner.dataSet.queryTopRowsHelp')}
                        </span>
                      </div>
                    </Form.Item>
                  )}

                  {/* ???? - SELECT ??? */}
                  {selectedNode.data.operationType === 'SELECT' && (
                    <Form.Item label={t('workflowDesigner.dataSet.orderByFields')}>
                      <DataSetQueryOrderByEditor
                        orderByFields={selectedNode.data.queryOrderBy || []}
                        onOrderByFieldsChange={(fields) => handleNodeDataChange({ queryOrderBy: fields })}
                        dataSetColumns={dataSetColumns}
                        t={t}
                      />
                    </Form.Item>
                  )}

                  {/* ???? - SELECT ??? */}
                  {selectedNode.data.operationType === 'SELECT' && (
                    <Form.Item label={t('workflowDesigner.dataSet.fieldMapping')}>
                      <div style={{ marginBottom: '8px' }}>
                        <Button 
                          type="dashed" 
                          onClick={() => {
                            const currentNode = nodes.find(node => node.id === selectedNode?.id);
                            const currentMappings = currentNode?.data?.mappedFields || [];
                            dataSetFieldMappingForm.setFieldsValue({ mappedFields: currentMappings });
                            setDataSetFieldMappingModalVisible(true);
                          }}
                          style={{ width: '100%' }}
                          disabled={!selectedNode.data.dataSetId}
                        >
                          {t('workflowDesigner.dataSet.setFieldMapping')}
                        </Button>
                      </div>
                      {(() => {
                        const currentNode = nodes.find(node => node.id === selectedNode?.id);
                        const mappedFields = currentNode?.data?.mappedFields || [];
                        if (mappedFields.length > 0) {
                          return (
                            <div style={{ 
                              border: '1px solid #d9d9d9', 
                              borderRadius: '4px', 
                              padding: '8px',
                              backgroundColor: '#fafafa'
                            }}>
                              <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>
                                {t('workflowDesigner.dataSet.fieldMappingSummary', { count: mappedFields.length })}:
                              </div>
                              {mappedFields.slice(0, 3).map((mapping, index) => (
                                <div key={index} style={{ fontSize: '11px', color: '#999', marginBottom: '2px' }}>
                                  {mapping.fieldName} ? ${mapping.variableName}
                                </div>
                              ))}
                              {mappedFields.length > 3 && (
                                <div style={{ fontSize: '11px', color: '#999' }}>
                                  +{mappedFields.length - 3} ???...
                                </div>
                              )}
                            </div>
                          );
                        }
                        return (
                          <div style={{ 
                            textAlign: 'center', 
                            padding: '20px', 
                            color: '#999',
                            border: '1px dashed #d9d9d9',
                            borderRadius: '4px'
                          }}>
                            {t('workflowDesigner.dataSet.noFieldMapping')}
                          </div>
                        );
                      })()}
                      <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                        {t('workflowDesigner.dataSet.clickToSetFieldMapping')}
                      </div>
                    </Form.Item>
                  )}
                
                  <Form.Item label={t('workflowDesigner.dataSet.operationPreview')}>
                    <div style={{ 
                      padding: '8px 12px', 
                      backgroundColor: '#f5f5f5', 
                      borderRadius: '4px',
                      fontSize: '12px',
                      color: '#666',
                      minHeight: '40px'
                    }}>
                      {selectedNode.data.dataSetId && selectedNode.data.operationType ? (
                        <div>
                          <div><strong>DataSet:</strong> {dataSets.find(ds => ds.id === selectedNode.data.dataSetId)?.name}</div>
                          <div><strong>{t('workflowDesigner.dataSet.operationType')}:</strong> {selectedNode.data.operationType}</div>
                          {(() => {
                            const currentNode = nodes.find(node => node.id === selectedNode?.id);
                            const conditionGroups = currentNode?.data?.queryConditionGroups || [];
                            if (conditionGroups.length > 0) {
                              const sqlPreview = generateWhereClause(conditionGroups);
                              return <div><strong>{t('workflowDesigner.dataSet.queryConditions')}:</strong> {sqlPreview}</div>;
                            }
                            return null;
                          })()}
                          {Object.keys(selectedNode.data.operationData || {}).length > 0 && (
                            <div><strong>{t('workflowDesigner.dataSet.operationData')}:</strong> {JSON.stringify(selectedNode.data.operationData)}</div>
                          )}
                          {(() => {
                            const currentNode = nodes.find(node => node.id === selectedNode?.id);
                            const mappedFields = currentNode?.data?.mappedFields || [];
                            if (mappedFields.length > 0) {
                              return (
                                <div>
                                  <strong>{t('workflowDesigner.dataSet.fieldMapping')}:</strong>
                                  <ul style={{ margin: '4px 0', paddingLeft: '16px' }}>
                                    {mappedFields.map((mapping, index) => (
                                      <li key={index}>
                                        {mapping.fieldName} ? ${mapping.variableName}
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              );
                            }
                            return null;
                          })()}
                        </div>
                      ) : (
                        t('workflowDesigner.dataSet.pleaseSelectDataSetAndOperationType')
                      )}
                    </div>
                  </Form.Item>
                

                <Form.Item>
                  <Button 
                    type="default" 
                    onClick={testDataSetOperation}
                    loading={testingOperation}
                    disabled={!selectedNode.data.dataSetId || !selectedNode.data.operationType}
                    style={{ width: '100%' }}
                  >
                    {t('workflowDesigner.dataSet.testOperation')}
                  </Button>
                </Form.Item>

                      </>
                    ),
                  },
                ]}
              />
            )}

            {/* API ???? */}
            {selectedNode.data.type === 'callApi' && (
              <PropertySectionTabs
                resetKey={selectedNode.id}
                sections={[
                  {
                    key: 'data',
                    icon: <ApiOutlined />,
                    tooltip: t('workflowDesigner.sectionData'),
                    children: (
                      <Form.Item label={t('workflow.apiUrl')} name="url">
                        <Input />
                      </Form.Item>
                    ),
                  },
                ]}
              />
            )}
            
            {/* ???? */}
            {selectedNode.data.type === 'sendEForm' && (() => {
              // ?? ???????? ??????????????????????????????????????????
              // ?????????sendEFormModes ?????? sendEFormMode ????
              const getEFormModes = () => {
                if (selectedNode.data.sendEFormModes?.length > 0) return selectedNode.data.sendEFormModes;
                const single = selectedNode.data.sendEFormMode || 'integrateWaitReply';
                return [single];
              };
              const currentEFormModes = getEFormModes();
              // ???????????
              const EXCLUSIVE_MODES = ['manualFill', 'integrateDataSetQuery'];
              const AI_SOURCE_MODES = ['integrateWaitReply', 'integrateChatBot', 'integrateChatOrderingCart', 'integrateEForm', 'integrateEmailStart', 'integrateManualStart'];
              const activeExclusiveMode = currentEFormModes.length === 1 && EXCLUSIVE_MODES.includes(currentEFormModes[0]) ? currentEFormModes[0] : null;
              const activeAiModes = currentEFormModes.filter(m => AI_SOURCE_MODES.includes(m));

              const handleExclusiveModeSelect = (mode) => {
                handleNodeDataChange({
                  sendEFormModes: [mode],
                  sendEFormMode: mode,
                  integratedDataSetQueryNodeId: mode === 'integrateDataSetQuery' ? (selectedNode.data.integratedDataSetQueryNodeId || '') : '',
                  integratedEFormNodeId: '',
                  integratedWaitReplyNodeId: '',
                  integratedChatBotNodeId: '',
                  integratedChatOrderingCartNodeId: '',
                  sendNotificationToRecipients: mode === 'manualFill' ? true : selectedNode.data.sendNotificationToRecipients,
                });
              };
              const handleAiSourceToggle = (mode, checked) => {
                let newModes = checked
                  ? [...new Set([...activeAiModes, mode])]
                  : activeAiModes.filter(m => m !== mode);
                if (newModes.length === 0) newModes = ['integrateWaitReply'];
                handleNodeDataChange({
                  sendEFormModes: newModes,
                  sendEFormMode: newModes[0],
                  integratedDataSetQueryNodeId: '',
                  integratedEFormNodeId: newModes.includes('integrateEForm') ? (selectedNode.data.integratedEFormNodeId || '') : '',
                  integratedWaitReplyNodeId: newModes.includes('integrateWaitReply') ? (selectedNode.data.integratedWaitReplyNodeId || '') : '',
                  integratedChatBotNodeId: newModes.includes('integrateChatBot') ? (selectedNode.data.integratedChatBotNodeId || '') : '',
                  integratedChatOrderingCartNodeId: newModes.includes('integrateChatOrderingCart') ? (selectedNode.data.integratedChatOrderingCartNodeId || '') : '',
                  sendNotificationToRecipients: selectedNode.data.sendNotificationToRecipients,
                });
              };
              // ?????????????????????????????????????????????????????????????

              const isMetaFlows = selectedNode.data.formType === 'MetaFlows';
              const isManualFill = activeExclusiveMode === 'manualFill';
              const isAiMode = activeAiModes.length > 0;
              const isIntegrateMode = isAiMode || activeExclusiveMode === 'integrateDataSetQuery';
              const sendEFormUpstreamNodes = (nodes || []).filter(n => n.data?.type === 'sendEForm' && n.id !== selectedNode.id);
              const waitReplyUpstreamNodes = (nodes || []).filter(n => n.data?.type === 'waitReply' && n.id !== selectedNode.id);
              const chatBotUpstreamNodes = (nodes || []).filter(n => n.data?.type === 'chatBot' && n.id !== selectedNode.id);
              const chatOrderingCartUpstreamNodes = (nodes || []).filter(n => n.data?.type === 'chatOrderingCart' && n.id !== selectedNode.id);
              const showRecipient = (isMetaFlows || isManualFill || (isIntegrateMode && selectedNode.data.sendNotificationToRecipients !== false));
              const showNotificationMessage = (!isMetaFlows && (isManualFill || (isIntegrateMode && selectedNode.data.sendNotificationToRecipients !== false)));
              // ? eforms ??????????????? template ????? hint ???
              // ? Meta Flow ?????? HEADER/BODY/CTA??? Template ???? UI?
              //    Meta Flow Template ?????????????HEADER/BODY/CTA override ??????log #7003 ????
              //    ???????????????????? placeholder ?????
              const selectedForm = (eforms || []).find(f => f.id === selectedNode.data.formId);
              // ???? hint????? placeholder template / ???? / ??/???
              const hasMetaFlowTemplateName = !!(selectedForm?.metaFlowTemplateName);
              const templateUsesPlaceholders = selectedForm?.metaFlowTemplateUsesPlaceholders === true;
              return (
              <PropertySectionTabs
                resetKey={selectedNode.id}
                sections={[
                  {
                    key: 'form',
                    icon: <FormOutlined />,
                    tooltip: t('workflowDesigner.sectionForm'),
                    children: (
                      <>
                <Form.Item label={t('workflowDesigner.selectForm')}>
                  <Input 
                    value={selectedNode.data.formName || ''}
                    placeholder={t('workflowDesigner.selectEFormPlaceholder')} 
                    readOnly 
                    onClick={() => setIsEFormModalVisible(true)}
                    suffix={
                      <Space>
                        {selectedNode.data.formName && (
                          <Button 
                            type="text" 
                            size="small" 
                            onClick={(e) => {
                              e.stopPropagation();
                              handleNodeDataChange({ 
                                formName: '', 
                                formId: '', 
                                formDescription: '' 
                              });
                            }}
                          >
                            {t('workflowList.clear')}
                          </Button>
                        )}
                        <Button 
                          type="text" 
                          size="small" 
                          onClick={() => setIsEFormModalVisible(true)}
                        >
                          {t('workflowDesigner.selectForm')}
                        </Button>
                      </Space>
                    }
                    style={{
                      color: selectedNode.data.formName ? '#000' : '#999',
                      backgroundColor: selectedNode.data.formName ? '#fff' : '#f5f5f5',
                      width: '100%'
                    }}
                  />
                </Form.Item>
                
                {selectedNode.data.formId && (
                  <Card size="small" title={t('workflowDesigner.formInfo')} style={{ marginBottom: 16 }}>
                    <p><strong>{t('workflowDesigner.formId')}</strong>{selectedNode.data.formId}</p>
                    <p><strong>{t('workflowDesigner.formName')}</strong>{selectedNode.data.formName}</p>
                    {selectedNode.data.formDescription && (
                      <p><strong>{t('workflowDesigner.formDescription')}</strong>{selectedNode.data.formDescription}</p>
                    )}
                  </Card>
                )}

                {isAiMode && (
                  <Form.Item label={t('workflowDesigner.sendEForm.resultMode')}>
                    <Radio.Group
                      value={selectedNode.data.multiFormMode || 'single'}
                      onChange={(e) => handleNodeDataChange({ multiFormMode: e.target.value })}
                    >
                      <div style={{ marginBottom: 8 }}>
                        <Radio value="single">
                          {t('workflowDesigner.sendEForm.singleResult')}
                        </Radio>
                      </div>
                      <div>
                        <Radio value="multi">
                          {t('workflowDesigner.sendEForm.multiResult')}
                        </Radio>
                      </div>
                    </Radio.Group>
                    <div style={{ 
                      marginTop: 8, 
                      padding: '8px 12px', 
                      backgroundColor: '#fff7e6', 
                      border: '1px solid #ffd591',
                      borderRadius: '6px',
                      fontSize: '12px',
                      color: '#d46b08'
                    }}>
                      <div>{t('workflowDesigner.sendEForm.singleResultDesc')}</div>
                      <div>{t('workflowDesigner.sendEForm.multiResultDesc')}</div>
                      <div>{t('workflowDesigner.sendEForm.multiResultNotice')}</div>
                    </div>
                  </Form.Item>
                )}

                <Form.Item label={t('workflowDesigner.sendEForm.fillMode')}>
                  {isMetaFlows && (
                    <div style={{ 
                      marginBottom: 8, 
                      padding: '8px 12px', 
                      backgroundColor: '#fff7e6', 
                      border: '1px solid #ffd591',
                      borderRadius: '4px',
                      fontSize: '12px',
                      color: '#d46b08'
                    }}>
                      ?? {t('workflowDesigner.sendEForm.metaFlowsManualFillOnly')}
                    </div>
                  )}

                  {/* ?? ?????????? */}
                  <div style={{ marginBottom: 6, fontSize: 11, color: '#888', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    {t('workflowDesigner.sendEForm.exclusiveModeLabel') || '????????'}
                  </div>
                  <div style={{ marginBottom: 4 }}>
                    <Radio
                      disabled={isMetaFlows}
                      checked={activeExclusiveMode === 'manualFill'}
                      onChange={() => !isMetaFlows && handleExclusiveModeSelect('manualFill')}
                    >
                      {t('workflowDesigner.sendEForm.manualFill')}
                    </Radio>
                  </div>
                  <div style={{ marginBottom: 12 }}>
                    <Radio
                      disabled={isMetaFlows}
                      checked={activeExclusiveMode === 'integrateDataSetQuery'}
                      onChange={() => !isMetaFlows && handleExclusiveModeSelect('integrateDataSetQuery')}
                    >
                      {t('workflowDesigner.sendEForm.integrateDataSetQuery')}
                    </Radio>
                  </div>

                  {/* ?? AI ??????????? */}
                  <div style={{ marginBottom: 6, fontSize: 11, color: '#888', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    {t('workflowDesigner.sendEForm.aiSourceLabel') || 'AI ?????????'}
                  </div>
                  <div style={{ marginBottom: 4 }}>
                    <Checkbox
                      disabled={isMetaFlows}
                      checked={activeAiModes.includes('integrateWaitReply')}
                      onChange={e => !isMetaFlows && handleAiSourceToggle('integrateWaitReply', e.target.checked)}
                    >
                      {t('workflowDesigner.sendEForm.integrateWaitReply')}
                    </Checkbox>
                  </div>
                  <div style={{ marginBottom: 4 }}>
                    <Checkbox
                      disabled={isMetaFlows}
                      checked={activeAiModes.includes('integrateChatBot')}
                      onChange={e => !isMetaFlows && handleAiSourceToggle('integrateChatBot', e.target.checked)}
                    >
                      {t('workflowDesigner.sendEForm.integrateChatBot') || '?? Chatbot ?? (AI ??)'}
                    </Checkbox>
                  </div>
                  <div style={{ marginBottom: 4 }}>
                    <Checkbox
                      disabled={isMetaFlows}
                      checked={activeAiModes.includes('integrateChatOrderingCart')}
                      onChange={e => !isMetaFlows && handleAiSourceToggle('integrateChatOrderingCart', e.target.checked)}
                    >
                      {t('workflowDesigner.sendEForm.integrateChatOrderingCart') || '?? Chatbot ????? (AI ??)'}
                    </Checkbox>
                  </div>
                  <div style={{ marginBottom: 4 }}>
                    <Checkbox
                      disabled={isMetaFlows}
                      checked={activeAiModes.includes('integrateEForm')}
                      onChange={e => !isMetaFlows && handleAiSourceToggle('integrateEForm', e.target.checked)}
                    >
                      {t('workflowDesigner.sendEForm.integrateEForm') || '???? eForm ??'}
                    </Checkbox>
                  </div>
                  <div style={{ marginBottom: 4 }}>
                    <Checkbox
                      disabled={isMetaFlows}
                      checked={activeAiModes.includes('integrateEmailStart')}
                      onChange={e => !isMetaFlows && handleAiSourceToggle('integrateEmailStart', e.target.checked)}
                    >
                      {t('workflowDesigner.sendEForm.integrateEmailStart')}
                    </Checkbox>
                  </div>
                  <div style={{ marginBottom: 8 }}>
                    <Checkbox
                      disabled={isMetaFlows}
                      checked={activeAiModes.includes('integrateManualStart')}
                      onChange={e => !isMetaFlows && handleAiSourceToggle('integrateManualStart', e.target.checked)}
                    >
                      {t('workflowDesigner.sendEForm.integrateManualStart')}
                    </Checkbox>
                  </div>
                  {activeAiModes.includes('integrateEmailStart') && activeAiModes.includes('integrateManualStart') && (
                    <div style={{ marginBottom: 8, padding: '6px 10px', backgroundColor: '#fff7e6', border: '1px solid #ffd591', borderRadius: 4, fontSize: 11, color: '#d46b08' }}>
                      ?? {t('workflowDesigner.sendEForm.emailAndManualBothWarning') || 'Email ?????????????????????????????????'}
                    </div>
                  )}

                  {/* ????? */}
                  <div style={{ 
                    padding: '8px 12px', 
                    backgroundColor: '#f0f8ff', 
                    border: '1px solid #1890ff',
                    borderRadius: '6px',
                    fontSize: '12px',
                    color: '#666',
                    marginTop: 8
                  }}>
                    {activeExclusiveMode === 'integrateDataSetQuery' && (
                      <div>{t('workflowDesigner.sendEForm.integrateDataSetQueryDesc')}</div>
                    )}
                    {activeExclusiveMode === 'manualFill' && (
                      <div>{t('workflowDesigner.sendEForm.manualFillDesc')}</div>
                    )}
                    {activeAiModes.length > 0 && (
                      <div>
                        {activeAiModes.includes('integrateEForm') && <div>{t('workflowDesigner.sendEForm.integrateEFormDesc')}</div>}
                        {activeAiModes.includes('integrateWaitReply') && <div>{t('workflowDesigner.sendEForm.integrateWaitReplyDesc')}</div>}
                        {activeAiModes.includes('integrateChatBot') && <div>{t('workflowDesigner.sendEForm.integrateChatBotDesc') || '???? Chatbot ????????? AI ??'}</div>}
                        {activeAiModes.includes('integrateChatOrderingCart') && <div>{t('workflowDesigner.sendEForm.integrateChatOrderingCartDesc') || '???? Chatbot ?????????????? AI ??'}</div>}
                        {activeAiModes.includes('integrateManualStart') && <div>{t('workflowDesigner.sendEForm.integrateManualStartDesc')}</div>}
                        {activeAiModes.includes('integrateEmailStart') && !activeAiModes.includes('integrateManualStart') && <div>{t('workflowDesigner.sendEForm.integrateEmailStartDesc')}</div>}
                        {activeAiModes.length > 1 && (
                          <div style={{ marginTop: 4, color: '#1890ff' }}>
                            {t('workflowDesigner.sendEForm.multiSourceDesc') || '?? AI ?????????? AI????????????'}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </Form.Item>

                {(activeAiModes.includes('integrateEmailStart') || activeAiModes.includes('integrateManualStart')) && (
                  <Form.Item
                    label={t('workflowDesigner.sendEForm.integrateEmailStartSendToAi')}
                    name="integrateEmailStartSendToAi"
                    tooltip={activeAiModes.includes('integrateManualStart') && !activeAiModes.includes('integrateEmailStart')
                      ? t('workflowDesigner.sendEForm.integrateManualStartSendToAiHelp')
                      : t('workflowDesigner.sendEForm.integrateEmailStartSendToAiHelp')}
                  >
                    <Radio.Group
                      value={selectedNode.data.integrateEmailStartSendToAi || 'attachment'}
                      onChange={(e) => handleNodeDataChange({ integrateEmailStartSendToAi: e.target.value })}
                    >
                      <Radio value="attachment">{t('workflowDesigner.sendEForm.integrateEmailStartSendToAiAttachment')}</Radio>
                      <Radio value="body">
                        {activeAiModes.includes('integrateManualStart') && !activeAiModes.includes('integrateEmailStart')
                          ? t('workflowDesigner.sendEForm.integrateManualStartSendToAiBody')
                          : t('workflowDesigner.sendEForm.integrateEmailStartSendToAiBody')}
                      </Radio>
                      <Radio value="both">{t('workflowDesigner.sendEForm.integrateEmailStartSendToAiBoth')}</Radio>
                    </Radio.Group>
                  </Form.Item>
                )}

                {activeExclusiveMode === 'integrateDataSetQuery' && (
                  <Form.Item label={t('workflowDesigner.sendEForm.selectDataSetQueryNode')}>
                    <Select
                      placeholder={t('workflowDesigner.sendEForm.selectDataSetQueryNodePlaceholder')}
                      value={selectedNode.data.integratedDataSetQueryNodeId || undefined}
                      onChange={(value) => handleNodeDataChange({ integratedDataSetQueryNodeId: value })}
                      allowClear
                    >
                      {(() => {
                        const dataSetQueryNodes = nodes.filter(node => 
                          node.data?.type === 'dataSetQuery' && 
                          node.data?.operationType === 'SELECT' &&
                          node.id !== selectedNode.id
                        );
                        if (dataSetQueryNodes.length === 0) {
                          return (
                            <Select.Option value="" disabled>
                              {t('workflowDesigner.sendEForm.noDataSetQueryNodes')}
                            </Select.Option>
                          );
                        }
                        return dataSetQueryNodes.map(node => (
                          <Select.Option key={node.id} value={node.id}>
                            {node.data?.taskName || node.data?.label || `DataSet Query Node ${node.id}`}
                          </Select.Option>
                        ));
                      })()}
                    </Select>
                    <div style={{ marginTop: 4, fontSize: '12px', color: '#666' }}>
                      {t('workflowDesigner.sendEForm.dataSetQueryNodeHelp')}
                    </div>
                  </Form.Item>
                )}

                {activeAiModes.includes('integrateWaitReply') && (
                  <Form.Item
                    label={t('workflowDesigner.sendEForm.selectUpstreamWaitReplyNode') || '???? waitReply ??'}
                    tooltip={t('workflowDesigner.sendEForm.selectUpstreamWaitReplyNodeHelp')
                      || '???? waitReply ?????????/????? AI ???????????????????????'}
                  >
                    <Select
                      placeholder={t('workflowDesigner.sendEForm.selectUpstreamWaitReplyNodePlaceholder') || '?? waitReply ?????=??????'}
                      value={selectedNode.data.integratedWaitReplyNodeId || undefined}
                      onChange={(value) => handleNodeDataChange({ integratedWaitReplyNodeId: value || '' })}
                      allowClear
                      notFoundContent={t('workflowDesigner.sendEForm.noUpstreamWaitReplyNode') || '????? waitReply ??'}
                    >
                      {waitReplyUpstreamNodes.map(node => (
                        <Select.Option key={node.id} value={node.id}>
                          {node.data?.taskName || node.id}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}

                {activeAiModes.includes('integrateChatBot') && (
                  <Form.Item
                    label={t('workflowDesigner.sendEForm.selectUpstreamChatBotNode') || '???? Chatbot ??'}
                    tooltip={t('workflowDesigner.sendEForm.selectUpstreamChatBotNodeHelp')
                      || '???? Chatbot ????????? AI ??????????????????? Chatbot session?'}
                  >
                    <Select
                      placeholder={t('workflowDesigner.sendEForm.selectUpstreamChatBotNodePlaceholder') || '?? Chatbot ?????=?? session??'}
                      value={selectedNode.data.integratedChatBotNodeId || undefined}
                      onChange={(value) => handleNodeDataChange({ integratedChatBotNodeId: value || '' })}
                      allowClear
                      notFoundContent={t('workflowDesigner.sendEForm.noUpstreamChatBotNode') || '????? Chatbot ??'}
                    >
                      {chatBotUpstreamNodes.map(node => (
                        <Select.Option key={node.id} value={node.id}>
                          {node.data?.taskName || node.id}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}

                {activeAiModes.includes('integrateChatOrderingCart') && (
                  <Form.Item
                    label={t('workflowDesigner.sendEForm.selectUpstreamChatOrderingCartNode') || '???? Chatbot ?????'}
                    tooltip={t('workflowDesigner.sendEForm.selectUpstreamChatOrderingCartNodeHelp')
                      || '???? Chatbot ?????????????? AI ?????????????????????? session?'}
                  >
                    <Select
                      placeholder={t('workflowDesigner.sendEForm.selectUpstreamChatOrderingCartNodePlaceholder') || '?? Chatbot ????????=?? session??'}
                      value={selectedNode.data.integratedChatOrderingCartNodeId || undefined}
                      onChange={(value) => handleNodeDataChange({ integratedChatOrderingCartNodeId: value || '' })}
                      allowClear
                      notFoundContent={t('workflowDesigner.sendEForm.noUpstreamChatOrderingCartNode') || '????? Chatbot ?????'}
                    >
                      {chatOrderingCartUpstreamNodes.map(node => (
                        <Select.Option key={node.id} value={node.id}>
                          {node.data?.taskName || node.id}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}

                {activeAiModes.includes('integrateEForm') && (
                  <Form.Item
                    label={t('workflowDesigner.sendEForm.selectUpstreamEFormNode') || '?? sendEForm ??'}
                    tooltip={t('workflowDesigner.sendEForm.selectUpstreamEFormNodeHelp')
                      || '????????????? sendEForm ?????????FilledHtmlCode?????????? AI ?????????????????????'}
                  >
                    <Select
                      placeholder={t('workflowDesigner.sendEForm.selectUpstreamEFormNodePlaceholder') || '?????? sendEForm ???'}
                      value={selectedNode.data.integratedEFormNodeId || undefined}
                      onChange={(value) => handleNodeDataChange({ integratedEFormNodeId: value || '' })}
                      allowClear
                      notFoundContent={t('workflowDesigner.sendEForm.noUpstreamEFormNode') || '????? sendEForm ??'}
                    >
                      {sendEFormUpstreamNodes.map(node => (
                        <Select.Option key={node.id} value={node.id}>
                          {node.data?.taskName || node.data?.formName || node.id}
                        </Select.Option>
                      ))}
                    </Select>
                    {sendEFormUpstreamNodes.length === 0 && (
                      <div style={{ marginTop: 6, color: '#ff7875', fontSize: 12 }}>
                        {t('workflowDesigner.sendEForm.noUpstreamEFormNode') || '????? sendEForm ??????? sendEForm ???'}
                      </div>
                    )}
                  </Form.Item>
                )}
                      </>
                    ),
                  },
                  {
                    key: 'ai',
                    icon: <RobotOutlined />,
                    tooltip: t('workflowDesigner.sectionAi'),
                    hidden: !isAiMode,
                    children: (
                      <>
                        {!loadingAiProviders && aiProviders.length === 0 && (
                          <Alert
                            type="warning"
                            showIcon
                            message={t('workflowDesigner.aiProviderNotConfigured')}
                            style={{ marginBottom: 12 }}
                          />
                        )}
                        {aiProvidersError && (
                          <Alert
                            type="error"
                            showIcon
                            message={t('workflowDesigner.aiProviderLoadFailed')}
                            description={aiProvidersError}
                            style={{ marginBottom: 12 }}
                          />
                        )}
                        <Form.Item
                          label={t('workflowDesigner.sendEForm.aiProvider')}
                          name="aiProviderKey"
                          rules={[{ required: true, message: t('workflowDesigner.sendEForm.aiProviderRequired') }]}
                        >
                          <SelectWithClearButton
                            clearText={t('workflowDesigner.clear')}
                            loading={loadingAiProviders}
                            placeholder={t('workflowDesigner.sendEForm.aiProviderPlaceholder')}
                            options={aiProviderOptions}
                          />
                        </Form.Item>
                        <AiStaffSelectField {...aiStaffSelectProps} fieldPath={['aiStaffId']} />
                        <Form.Item
                          label={t('workflowDesigner.sendEForm.fillFormAdditionalPrompt')}
                          name="fillFormAdditionalPrompt"
                          tooltip={t('workflowDesigner.sendEForm.fillFormAdditionalPromptHelp')}
                        >
                          <Input.TextArea
                            placeholder={t('workflowDesigner.sendEForm.fillFormAdditionalPromptPlaceholder')}
                            rows={4}
                            onChange={(e) => handleNodeDataChange({ fillFormAdditionalPrompt: e.target.value })}
                            value={selectedNode.data.fillFormAdditionalPrompt || ''}
                          />
                        </Form.Item>
                        {renderPromptVariablesDisplay('fillFormAdditionalPrompt')}
                        <Form.Item
                          label={t('workflowDesigner.sendEForm.additionalPrompt')}
                          name="additionalPrompt"
                          tooltip={t('workflowDesigner.sendEForm.additionalPromptHelp')}
                        >
                          <Input.TextArea
                            placeholder={t('workflowDesigner.sendEForm.additionalPromptPlaceholder')}
                            rows={4}
                            onChange={(e) => handleNodeDataChange({ additionalPrompt: e.target.value })}
                            value={selectedNode.data.additionalPrompt || ''}
                          />
                        </Form.Item>
                        {renderPromptVariablesDisplay('additionalPrompt')}
                        <Form.Item
                          label={t('workflowDesigner.sendEForm.jsonResultVariable')}
                          name="jsonResultVariable"
                          tooltip={t('workflowDesigner.sendEForm.jsonResultVariableHelp')}
                        >
                          <SelectWithClearButton
                            clearText={t('workflowDesigner.clear')}
                            placeholder={t('workflowDesigner.sendEForm.jsonResultVariablePlaceholder')}
                            value={selectedNode.data.jsonResultVariable || undefined}
                            onChange={(value) => handleNodeDataChange({ jsonResultVariable: value })}
                          >
                            {processVariables
                              .filter(pv => pv.dataType === 'json')
                              .map(pv => (
                                <Select.Option key={pv.id} value={pv.variableName}>
                                  {pv.variableName} ({pv.dataType})
                                </Select.Option>
                              ))}
                          </SelectWithClearButton>
                        </Form.Item>
                        <Form.Item
                          label={t('workflowDesigner.sendEForm.jsonResultAiSuggestionVariable')}
                          tooltip={t('workflowDesigner.sendEForm.jsonResultAiSuggestionVariableHelp')}
                        >
                          <SelectWithClearButton
                            clearText={t('workflowDesigner.clear')}
                            placeholder={t('workflowDesigner.sendEForm.jsonResultAiSuggestionVariablePlaceholder')}
                            value={selectedNode.data.jsonResultAiSuggestionVariable || undefined}
                            onChange={(value) => handleNodeDataChange({ jsonResultAiSuggestionVariable: value })}
                          >
                            {textOrStringProcessVariables.map(pv => (
                              <Select.Option key={pv.id} value={pv.variableName}>
                                {pv.variableName} ({pv.dataType})
                              </Select.Option>
                            ))}
                          </SelectWithClearButton>
                        </Form.Item>
                        <Form.Item
                          label={t('workflowDesigner.sendEForm.jsonResultAiFailReasonVariable')}
                          tooltip={t('workflowDesigner.sendEForm.jsonResultAiFailReasonVariableHelp')}
                        >
                          <SelectWithClearButton
                            clearText={t('workflowDesigner.clear')}
                            placeholder={t('workflowDesigner.sendEForm.jsonResultAiFailReasonVariablePlaceholder')}
                            value={selectedNode.data.jsonResultAiFailReasonVariable || undefined}
                            onChange={(value) => handleNodeDataChange({ jsonResultAiFailReasonVariable: value })}
                          >
                            {textOrStringProcessVariables.map(pv => (
                              <Select.Option key={pv.id} value={pv.variableName}>
                                {pv.variableName} ({pv.dataType})
                              </Select.Option>
                            ))}
                          </SelectWithClearButton>
                        </Form.Item>
                      </>
                    ),
                  },
                  {
                    key: 'knowledge',
                    icon: <ReadOutlined />,
                    tooltip: t('workflowDesigner.sectionKnowledgeBase'),
                    hidden: isMetaFlows || !isAiMode,
                    children: (
                      <WorkflowKnowledgeBaseSettingsControl
                        nodeData={selectedNode.data}
                        onApply={(patch) => handleNodeDataChange(patch)}
                        dataSets={dataSets}
                        loadingDataSets={loadingDataSets}
                        knowledgeStudioDocs={knowledgeStudioDocs}
                        loadingKnowledgeStudioDocs={loadingKnowledgeStudioDocs}
                        broadcastGroups={broadcastGroups}
                        loadingBroadcastGroups={loadingBroadcastGroups}
                        processVariables={processVariables}
                        generateWhereClause={generateWhereClause}
                        t={t}
                        labels={{
                          dataSetLabelKey: 'workflowDesigner.sendEForm.knowledgeBaseDataSet',
                          queryLabelKey: 'workflowDesigner.sendEForm.knowledgeBaseQueryConditions',
                        }}
                      />
                    ),
                  },
                  {
                    key: 'recipientAndMessage',
                    icon: <MessageOutlined />,
                    tooltip: t('workflowDesigner.sectionRecipientAndMessage'),
                    children: (
                      <>
                {isMetaFlows ? (
                  // ? Meta Flow ????? Template ???
                  //   - HEADER/BODY/CTA ? Meta Template ?????????? override ?????
                  //     ????????? user???????
                  //   - ???? Send Message ????? placeholder ?????PV ? {{1}} {{2}} ...??
                  <>
                    <Alert
                      type={hasMetaFlowTemplateName && !templateUsesPlaceholders ? 'warning' : 'info'}
                      showIcon
                      message={t('workflowDesigner.sendEForm.flowTemplateModeTitle')}
                      description={
                        !hasMetaFlowTemplateName
                          ? t('workflowDesigner.sendEForm.flowTemplateNotBuiltHint')
                          : !templateUsesPlaceholders
                            ? t('workflowDesigner.sendEForm.flowTemplateLegacyHint')
                            : t('workflowDesigner.sendEForm.flowTemplateModeHint')
                      }
                      style={{ marginBottom: 12 }}
                    />
                    <TemplateVariableConfig
                      templateId={selectedForm?.metaFlowTemplateName || ''}
                      isMetaTemplate={true}
                      processVariables={processVariables}
                      value={selectedNode.data.templateVariables || []}
                      onChange={(templateVariables) => handleNodeDataChange({ templateVariables })}
                      t={t}
                    />
                  </>
                ) : (
                  <>
                    <div style={{ marginBottom: 8 }}>
                      <div style={{ fontSize: '14px', fontWeight: 500, color: 'rgba(0, 0, 0, 0.88)', marginBottom: 4 }}>
                        {t('workflowDesigner.promptMessage')}
                      </div>
                      <div style={{ fontSize: '12px', color: 'rgba(0, 0, 0, 0.45)' }}>
                        {t('workflowDesigner.promptMessageHelp')}
                      </div>
                    </div>
                    <Form.Item 
                      name="promptMessage"
                      initialValue={selectedNode.data.promptMessage || ''}
                    >
                      <Input.TextArea 
                        rows={3} 
                        placeholder={t('workflowDesigner.sendEForm.promptMessagePlaceholder')}
                      />
                    </Form.Item>
                  </>
                )}

                {!isMetaFlows && isIntegrateMode && (
                  <Form.Item
                    label={t('workflowDesigner.sendEForm.sendNotificationToRecipients')}
                    tooltip={t('workflowDesigner.sendEForm.sendNotificationToRecipientsHelp')}
                  >
                    <Switch
                      checked={selectedNode.data.sendNotificationToRecipients !== false}
                      checkedChildren={t('workflowDesigner.sendEForm.sendNotificationOn')}
                      unCheckedChildren={t('workflowDesigner.sendEForm.sendNotificationOff')}
                      onChange={(checked) => {
                        const payload = { sendNotificationToRecipients: checked };
                        if (!checked) {
                          payload.to = '';
                          payload.recipientDetails = { users: [], contacts: [], groups: [], hashtags: [], useInitiator: false, phoneNumbers: [] };
                        }
                        handleNodeDataChange(payload);
                      }}
                    />
                  </Form.Item>
                )}

                {showRecipient && (
                  <Form.Item
                    label={t('workflow.to')}
                    required={isManualFill || isMetaFlows}
                  >
                    <div style={{ position: 'relative' }}>
                      <RecipientSelector
                        value={selectedNode.data.to || ''}
                        recipientDetails={selectedNode.data.recipientDetails}
                        placeholder={t('workflowDesigner.selectRecipients')}
                        compact={true}
                        workflowDefinitionId={workflowId}
                        t={t}
                        onChange={(value, detailedValue) => {
                          if (value === '' && detailedValue === null) {
                            setIsRecipientModalVisible(true);
                          } else {
                            handleNodeDataChange({ to: value, recipientDetails: detailedValue });
                          }
                        }}
                      />
                      <div style={{ position: 'absolute', right: '8px', top: '50%', transform: 'translateY(-50%)', display: 'flex', gap: '4px' }}>
                        {selectedNode.data.to && (
                          <Button
                            type="text"
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleNodeDataChange({ to: '', recipientDetails: { users: [], contacts: [], groups: [], hashtags: [], useInitiator: false, phoneNumbers: [] } });
                            }}
                            style={{ padding: '0 4px', fontSize: '12px' }}
                          >
                            {t('workflowDesigner.clear')}
                          </Button>
                        )}
                      </div>
                    </div>
                  </Form.Item>
                )}

                {showNotificationMessage && (
                  <>
                    <Divider />
                    <Form.Item label={t('workflowDesigner.sendEForm.notificationMessage')}>
                      <MessageModeTabsComponent
                        selectedNode={selectedNode}
                        handleNodeDataChange={handleNodeDataChange}
                        setIsTemplateModalVisible={setIsTemplateModalVisible}
                        processVariables={processVariables}
                        form={form}
                        t={t}
                        showProcessVariables={true}
                        fixedVariables={sendEFormFixedVariables}
                        metaTemplates={metaTemplates}
                        directMessageContent={(
                          <>
                            <div style={{ marginBottom: 8 }}>
                              <Radio.Group
                                value={selectedNode.data.useCustomMessage ? 'custom' : 'default'}
                                onChange={(e) => {
                                  const useCustom = e.target.value === 'custom';
                                  handleNodeDataChange({ 
                                    useCustomMessage: useCustom,
                                    messageTemplate: useCustom ? (selectedNode.data.messageTemplate || t('workflowDesigner.sendEForm.defaultNotificationMessage')) : t('workflowDesigner.sendEForm.defaultNotificationMessage')
                                  });
                                }}
                              >
                                <Radio value="default">{t('workflowDesigner.sendEForm.useDefaultMessage')}</Radio>
                                <Radio value="custom">{t('workflowDesigner.sendEForm.customMessage')}</Radio>
                              </Radio.Group>
                            </div>
                            {selectedNode.data.useCustomMessage && (
                              <>
                                <Input.TextArea
                                  value={selectedNode.data.messageTemplate || ''}
                                  placeholder={t('workflowDesigner.sendEForm.notificationMessagePlaceholder')}
                                  rows={4}
                                  onChange={(e) => handleNodeDataChange({ messageTemplate: e.target.value })}
                                />
                                <div style={{ marginTop: 4, fontSize: '12px', color: '#666' }}>
                                  {t('workflowDesigner.sendEForm.notificationMessageHelp')}
                                </div>
                                <ProcessVariablesDisplay
                                  processVariables={processVariables}
                                  form={form}
                                  t={t}
                                  targetFieldName="messageTemplate"
                                  onInsert={(v) => {
                                    const cur = selectedNode.data.messageTemplate || '';
                                    const next = cur + `\${${v}}`;
                                    handleNodeDataChange({ messageTemplate: next });
                                  }}
                                  showLabel={true}
                                />
                              </>
                            )}
                            {!selectedNode.data.useCustomMessage && (
                              <div style={{ 
                                padding: '8px 12px', 
                                backgroundColor: '#f5f5f5', 
                                border: '1px solid #d9d9d9',
                                borderRadius: '6px',
                                fontSize: '14px',
                                color: '#666'
                              }}>
                                {t('workflowDesigner.sendEForm.defaultNotificationMessage')}
                              </div>
                            )}
                          </>
                        )}
                      />
                    </Form.Item>
                  </>
                )}
                      </>
                    ),
                  },
                  {
                    key: 'approval',
                    icon: <AuditOutlined />,
                    tooltip: t('workflowDesigner.sectionApproval'),
                    children: (
                      <>
                        <div style={{ marginBottom: 16, padding: '12px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
                          <div style={{ fontSize: '12px', color: '#666', marginBottom: 8 }}>
                            {t('workflowDesigner.sendEForm.approvalSettingDescription') || 'eForm ??????????????????????????????????????????????????????'}
                          </div>
                          <Form.Item 
                            label={t('workflowDesigner.sendEForm.requireApproval') || '????'} 
                            name="requireApproval"
                            valuePropName="checked"
                            style={{ marginBottom: 0 }}
                          >
                            <Switch
                              checkedChildren={t('workflowDesigner.yes') || '?'}
                              unCheckedChildren={t('workflowDesigner.no') || '?'}
                              onChange={(checked) => {
                                handleNodeDataChange({ requireApproval: checked });
                                if (!checked) {
                                  handleNodeDataChange({ approvalResultVariable: '' });
                                  form.setFieldValue('approvalResultVariable', '');
                                }
                              }}
                            />
                          </Form.Item>
                        </div>
                        {selectedNode.data.requireApproval !== false && (
                          <>
                            <Space direction="vertical" style={{ width: '100%' }} size={0}>
                              <Form.Item
                                label={t('workflowDesigner.sendEForm.approveButtonLabel') || 'Approve ????'}
                                name="approveButtonLabel"
                              >
                                <Input
                                  placeholder={t('workflowDesigner.sendEForm.approveButtonLabelPlaceholder') || '????????'}
                                  maxLength={40}
                                  allowClear
                                />
                              </Form.Item>
                              <Form.Item
                                label={t('workflowDesigner.sendEForm.rejectButtonLabel') || 'Reject ????'}
                                name="rejectButtonLabel"
                              >
                                <Input
                                  placeholder={t('workflowDesigner.sendEForm.rejectButtonLabelPlaceholder') || '????????'}
                                  maxLength={40}
                                  allowClear
                                />
                              </Form.Item>
                            </Space>
                            <Form.Item label={t('workflowDesigner.approvalResultVariable')} name="approvalResultVariable">
                              <Select
                                placeholder={t('workflowDesigner.selectApprovalResultVariable')}
                                allowClear
                              >
                                {processVariables.map(pv => (
                                  <Select.Option key={pv.id} value={pv.variableName}>
                                    {pv.variableName} ({pv.dataType})
                                  </Select.Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </>
                        )}
                      </>
                    ),
                  },
                  {
                    key: 'validation',
                    icon: <SafetyOutlined />,
                    tooltip: t('workflowDesigner.sectionValidation'),
                    hidden: selectedNode.data.sendEFormMode !== 'manualFill',
                    children: (
                      <>
                {/* Validation Settings - ?? waitReply ?? - ?? manualFill ????? */}
                {selectedNode.data.sendEFormMode === 'manualFill' && (
                <Card 
                  size="small" 
                  title={t('workflowDesigner.validationSettings')} 
                  style={{ marginTop: 16, marginBottom: 16 }}
                >
                  <Tabs
                    activeKey={activeValidatorTab}
                    onChange={(key) => setActiveValidatorTab(key)}
                  >
                    <Tabs.TabPane tab={t('workflowDesigner.aiValidator')} key="ai">
                      <Form.Item
                        label={t('workflowDesigner.validatorActiveLabel')}
                        name={['validation', 'aiIsActive']}
                        valuePropName="checked"
                      >
                        <Switch
                          className="validator-switch"
                          checkedChildren={t('workflowDesigner.active')}
                          unCheckedChildren={t('workflowDesigner.inactive')}
                          onChange={(checked) => handleValidatorToggle('ai', checked)}
                        />
                      </Form.Item>
                      {aiIsActive && activeValidatorTab === 'ai' && (
                        <>
                          {!loadingAiProviders && aiProviders.length === 0 && (
                            <Alert
                              type="warning"
                              showIcon
                              message={t('workflowDesigner.aiProviderNotConfigured')}
                              style={{ marginBottom: 12 }}
                            />
                          )}
                          {aiProvidersError && (
                            <Alert
                              type="error"
                              showIcon
                              message={t('workflowDesigner.aiProviderLoadFailed')}
                              description={aiProvidersError}
                              style={{ marginBottom: 12 }}
                            />
                          )}
                          <Form.Item
                            label={t('workflowDesigner.validationAiProvider')}
                            name={['validation', 'aiProviderKey']}
                            rules={[{ required: true, message: t('workflowDesigner.validationAiProviderRequired') }]}
                          >
                            <SelectWithClearButton
                              clearText={t('workflowDesigner.clear')}
                              loading={loadingAiProviders}
                              placeholder={t('workflowDesigner.validationAiProviderPlaceholder')}
                              options={aiProviderOptions}
                            />
                          </Form.Item>
                          <AiStaffSelectField {...aiStaffSelectProps} />
                          <Form.Item
                            label={t('workflowDesigner.validationAiResultVariable')}
                            name={['validation', 'aiResultVariable']}
                            tooltip={t('workflowDesigner.validationAiResultVariableHelp')}
                          >
                            <SelectWithClearButton
                              clearText={t('workflowDesigner.clear')}
                              placeholder={t('workflowDesigner.validationAiResultVariablePlaceholder')}
                            >
                              {processVariables.map(pv => (
                                <Select.Option key={pv.id} value={pv.variableName}>
                                  {pv.variableName} ({pv.dataType})
                                </Select.Option>
                              ))}
                            </SelectWithClearButton>
                          </Form.Item>
                          <Form.Item
                            label={t('workflowDesigner.validationAiSuggestionVariable')}
                            name={['validation', 'aiSuggestionVariable']}
                            tooltip={t('workflowDesigner.validationAiSuggestionVariableHelp')}
                          >
                            <SelectWithClearButton
                              clearText={t('workflowDesigner.clear')}
                              placeholder={t('workflowDesigner.validationAiSuggestionVariablePlaceholder')}
                            >
                              {textOrStringProcessVariables.map(pv => (
                                <Select.Option key={pv.id} value={pv.variableName}>
                                  {pv.variableName} ({pv.dataType})
                                </Select.Option>
                              ))}
                            </SelectWithClearButton>
                          </Form.Item>
                          <Form.Item
                            label={t('workflowDesigner.validationAiFailReasonVariable')}
                            name={['validation', 'aiFailReasonVariable']}
                            tooltip={t('workflowDesigner.validationAiFailReasonVariableHelp')}
                          >
                            <SelectWithClearButton
                              clearText={t('workflowDesigner.clear')}
                              placeholder={t('workflowDesigner.validationAiFailReasonVariablePlaceholder')}
                            >
                              {textOrStringProcessVariables.map(pv => (
                                <Select.Option key={pv.id} value={pv.variableName}>
                                  {pv.variableName} ({pv.dataType})
                                </Select.Option>
                              ))}
                            </SelectWithClearButton>
                          </Form.Item>
                          <Form.Item label={t('workflowDesigner.promptText')} name={['validation', 'prompt']}>
                            <Input.TextArea
                              placeholder={t('workflowDesigner.promptTextPlaceholder')}
                              rows={6}
                            />
                          </Form.Item>
                          <Form.Item label={t('workflowDesigner.retryMessage')} name={['validation', 'retryMessage']}>
                            <Input placeholder={t('workflowDesigner.retryMessagePlaceholder')} />
                          </Form.Item>
                          <Form.Item label={t('workflowDesigner.maxRetries')} name={['validation', 'maxRetries']}>
                            <Input type="number" min="1" max="10" />
                          </Form.Item>
                        </>
                      )}
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={t('workflowDesigner.timeValidatorLabel')} key="time">
                      <Form.Item
                        label={t('workflowDesigner.validatorActiveLabel')}
                        name={['validation', 'timeIsActive']}
                        valuePropName="checked"
                      >
                        <Switch
                          className="validator-switch"
                          checkedChildren={t('workflowDesigner.active')}
                          unCheckedChildren={t('workflowDesigner.inactive')}
                          onChange={(checked) => handleValidatorToggle('time', checked)}
                        />
                      </Form.Item>
                      {timeIsActive && activeValidatorTab === 'time' && (
                        <>
                          <Form.Item label={t('workflowDesigner.timeValidator.retryInterval')}>
                            <div style={{
                              display: 'grid',
                              gridTemplateColumns: isFullscreen ? '1fr 1fr 1fr' : '1fr',
                              gap: isFullscreen ? '12px' : '8px'
                            }}>
                              <Input 
                                type="number" 
                                min="0" 
                                placeholder="0"
                                value={selectedNode.data.validation?.retryIntervalDays || 0}
                                onChange={(e) => {
                                  const newValidation = {
                                    ...(selectedNode.data.validation || {}),
                                    retryIntervalDays: parseInt(e.target.value) || 0
                                  };
                                  handleNodeDataChange({ validation: newValidation });
                                }}
                                addonAfter={t('workflowDesigner.days')}
                              />
                              <Input 
                                type="number" 
                                min="0" 
                                max="23"
                                placeholder="0"
                                value={selectedNode.data.validation?.retryIntervalHours || 0}
                                onChange={(e) => {
                                  const newValidation = {
                                    ...(selectedNode.data.validation || {}),
                                    retryIntervalHours: parseInt(e.target.value) || 0
                                  };
                                  handleNodeDataChange({ validation: newValidation });
                                }}
                                addonAfter={t('workflowDesigner.hours')}
                              />
                              <Input 
                                type="number" 
                                min="0" 
                                max="59"
                                placeholder="30"
                                value={selectedNode.data.validation?.retryIntervalMinutes || 0}
                                onChange={(e) => {
                                  const newValidation = {
                                    ...(selectedNode.data.validation || {}),
                                    retryIntervalMinutes: parseInt(e.target.value) || 0
                                  };
                                  handleNodeDataChange({ validation: newValidation });
                                }}
                                addonAfter={t('workflowDesigner.minutes')}
                              />
                            </div>
                          </Form.Item>
                          <Form.Item label={t('workflowDesigner.timeValidator.retryLimit')}>
                            <Input
                              type="number"
                              min="1"
                              placeholder="5"
                              value={selectedNode.data.validation?.retryLimitValue || 5}
                              onChange={(e) => {
                                const newValidation = {
                                  ...(selectedNode.data.validation || {}),
                                  retryLimitValue: parseInt(e.target.value) || 5
                                };
                                handleNodeDataChange({ validation: newValidation });
                              }}
                            />
                          </Form.Item>
                          <TimeValidatorConfigSection
                            type="retryMessage"
                            selectedNode={selectedNode}
                            handleNodeDataChange={handleNodeDataChange}
                            form={form}
                            processVariables={processVariables}
                            workflowDefinitionId={workflowId}
                            onOpenTemplateModal={() => {
                              setTemplateModalSource('retryMessage');
                              setIsTemplateModalVisible(true);
                            }}
                            onOpenRecipientModal={() => {
                              setTemplateModalSource('retryMessage');
                              setTimeValidatorRecipientModalVisible(true);
                            }}
                            t={t}
                            config={selectedNode?.data?.validation?.retryMessageConfig}
                            title={t('workflowDesigner.timeValidator.configureRetryMessage')}
                            recipientsLabel={t('workflowDesigner.timeValidator.retryMessageRecipients')}
                            recipientsDescription={t('workflowDesigner.timeValidator.retryMessageRecipientsDescription')}
                            messageLabel={t('workflowDesigner.timeValidator.retryMessage')}
                            messageDescription={t('workflowDesigner.timeValidator.retryMessageDescription')}
                            messagePlaceholder={t('workflowDesigner.timeValidator.retryMessagePlaceholder')}
                            messageTip={t('workflowDesigner.timeValidator.retryMessageTip')}
                            expanded={retryMessageExpanded}
                            onToggleExpanded={setRetryMessageExpanded}
                          />
                          <TimeValidatorConfigSection
                            type="escalation"
                            selectedNode={selectedNode}
                            handleNodeDataChange={handleNodeDataChange}
                            form={form}
                            processVariables={processVariables}
                            workflowDefinitionId={workflowId}
                            onOpenTemplateModal={() => {
                              setTemplateModalSource('escalation');
                              setIsTemplateModalVisible(true);
                            }}
                            onOpenRecipientModal={() => {
                              setTemplateModalSource('escalation');
                              setTimeValidatorRecipientModalVisible(true);
                            }}
                            t={t}
                            config={selectedNode?.data?.validation?.escalationConfig}
                            title={t('workflowDesigner.timeValidator.configureEscalation')}
                            recipientsLabel={t('workflowDesigner.timeValidator.escalationRecipients')}
                            recipientsDescription={t('workflowDesigner.timeValidator.escalationRecipientsDescription')}
                            messageLabel={t('workflowDesigner.timeValidator.escalationMessage')}
                            messageDescription={t('workflowDesigner.timeValidator.escalationMessageDescription')}
                            messagePlaceholder={t('workflowDesigner.timeValidator.escalationMessagePlaceholder')}
                            messageTip={t('workflowDesigner.timeValidator.escalationMessageTip')}
                            expanded={escalationConfigExpanded}
                            onToggleExpanded={setEscalationConfigExpanded}
                          />
                          </>
                        )}
                    </Tabs.TabPane>
                    {renderTimeoutCompleteTabPane()}
                  </Tabs>
                </Card>
                )}
                      </>
                    ),
                  },
                  {
                    key: 'description',
                    icon: <InfoCircleOutlined />,
                    tooltip: t('workflowDesigner.sectionDescription'),
                    children: (
                      <Card size="small" title={t('workflowDesigner.functionDescription')} style={{ marginTop: 16 }}>
                        <p style={{ fontSize: '12px', margin: '4px 0' }}>
                          {t('workflowDesigner.eFormDescription1')}
                        </p>
                        <p style={{ fontSize: '12px', margin: '4px 0' }}>
                          {t('workflowDesigner.eFormDescription2')}
                        </p>
                        <p style={{ fontSize: '12px', margin: '4px 0' }}>
                          {t('workflowDesigner.eFormDescription3')}
                        </p>
                        <p style={{ fontSize: '12px', margin: '4px 0' }}>
                          {t('workflowDesigner.eFormDescription4')}
                        </p>
                        <p style={{ fontSize: '12px', margin: '4px 0' }}>
                          {t('workflowDesigner.eFormDescription5')}
                        </p>
                        <p style={{ fontSize: '12px', margin: '4px 0' }}>
                          {t('workflowDesigner.eFormDescription6')}
                        </p>
                        <p style={{ fontSize: '12px', margin: '4px 0', color: '#1890ff' }}>
                          {t('workflowDesigner.eFormDescription7')}
                        </p>
                      </Card>
                    ),
                  },
                ]}
              />
              );
            })()}

            {(selectedNode.data.type === 'generateHtmlReport' || selectedNode.data.type === 'generateDocument') && (() => {
              // ?? ???????artifact ?????????????????????????????????
              const getArtifactModes = () => {
                if (selectedNode.data.generationModes?.length > 0) return selectedNode.data.generationModes;
                const single = selectedNode.data.generationMode || 'integrateWaitReply';
                return [single];
              };
              const currentArtifactModes = getArtifactModes();
              const artifactExclusiveMode = currentArtifactModes.length === 1 && currentArtifactModes[0] === 'integrateDataSetQuery' ? 'integrateDataSetQuery' : null;
              const artifactAiModes = currentArtifactModes.filter(m => ['integrateWaitReply', 'integrateChatBot', 'integrateChatOrderingCart', 'integrateEmailStart', 'integrateManualStart'].includes(m));
              const artifactIsAiMode = artifactAiModes.length > 0;
              const artifactWaitReplyNodes = (nodes || []).filter(n => n.data?.type === 'waitReply' && n.id !== selectedNode.id);
              const artifactChatBotNodes = (nodes || []).filter(n => n.data?.type === 'chatBot' && n.id !== selectedNode.id);
              const artifactChatOrderingCartNodes = (nodes || []).filter(n => n.data?.type === 'chatOrderingCart' && n.id !== selectedNode.id);

              const handleArtifactExclusiveMode = (mode) => {
                handleNodeDataChange({ generationModes: [mode], generationMode: mode, integratedDataSetQueryNodeId: '', integratedWaitReplyNodeId: '', integratedChatBotNodeId: '', integratedChatOrderingCartNodeId: '' });
              };
              const handleArtifactAiToggle = (mode, checked) => {
                let newModes = checked
                  ? [...new Set([...artifactAiModes, mode])]
                  : artifactAiModes.filter(m => m !== mode);
                if (newModes.length === 0) newModes = ['integrateWaitReply'];
                handleNodeDataChange({
                  generationModes: newModes,
                  generationMode: newModes[0],
                  integratedDataSetQueryNodeId: '',
                  integratedWaitReplyNodeId: newModes.includes('integrateWaitReply') ? (selectedNode.data.integratedWaitReplyNodeId || '') : '',
                  integratedChatBotNodeId: newModes.includes('integrateChatBot') ? (selectedNode.data.integratedChatBotNodeId || '') : '',
                  integratedChatOrderingCartNodeId: newModes.includes('integrateChatOrderingCart') ? (selectedNode.data.integratedChatOrderingCartNodeId || '') : '',
                });
              };
              // ?????????????????????????????????????????????????????????????
              return (
              <PropertySectionTabs
                resetKey={selectedNode.id}
                sections={[
                  {
                    key: 'form',
                    icon: <FileTextOutlined />,
                    tooltip: t('workflowDesigner.sectionForm'),
                    children: (
                      <>
                <Divider orientation="left">{t('workflowDesigner.artifact.generationMode')}</Divider>
                <Form.Item label={t('workflowDesigner.artifact.generationMode')}>
                  {/* ???? */}
                  <div style={{ marginBottom: 6, fontSize: 11, color: '#888', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    {t('workflowDesigner.sendEForm.exclusiveModeLabel') || '????????'}
                  </div>
                  <div style={{ marginBottom: 10 }}>
                    <Radio
                      checked={artifactExclusiveMode === 'integrateDataSetQuery'}
                      onChange={() => handleArtifactExclusiveMode('integrateDataSetQuery')}
                    >
                      {t('workflowDesigner.sendEForm.integrateDataSetQuery')}
                    </Radio>
                  </div>
                  {/* AI ???? */}
                  <div style={{ marginBottom: 6, fontSize: 11, color: '#888', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                    {t('workflowDesigner.sendEForm.aiSourceLabel') || 'AI ?????????'}
                  </div>
                  <div style={{ marginBottom: 4 }}>
                    <Checkbox
                      checked={artifactAiModes.includes('integrateWaitReply')}
                      onChange={e => handleArtifactAiToggle('integrateWaitReply', e.target.checked)}
                    >
                      {t('workflowDesigner.sendEForm.integrateWaitReply')}
                    </Checkbox>
                  </div>
                  <div style={{ marginBottom: 4 }}>
                    <Checkbox
                      checked={artifactAiModes.includes('integrateChatBot')}
                      onChange={e => handleArtifactAiToggle('integrateChatBot', e.target.checked)}
                    >
                      {t('workflowDesigner.sendEForm.integrateChatBot') || '?? Chatbot ?? (AI ??)'}
                    </Checkbox>
                  </div>
                  <div style={{ marginBottom: 4 }}>
                    <Checkbox
                      checked={artifactAiModes.includes('integrateChatOrderingCart')}
                      onChange={e => handleArtifactAiToggle('integrateChatOrderingCart', e.target.checked)}
                    >
                      {t('workflowDesigner.sendEForm.integrateChatOrderingCart') || '?? Chatbot ????? (AI ??)'}
                    </Checkbox>
                  </div>
                  <div style={{ marginBottom: 4 }}>
                    <Checkbox
                      checked={artifactAiModes.includes('integrateEmailStart')}
                      onChange={e => handleArtifactAiToggle('integrateEmailStart', e.target.checked)}
                    >
                      {t('workflowDesigner.sendEForm.integrateEmailStart')}
                    </Checkbox>
                  </div>
                  <div style={{ marginBottom: 8 }}>
                    <Checkbox
                      checked={artifactAiModes.includes('integrateManualStart')}
                      onChange={e => handleArtifactAiToggle('integrateManualStart', e.target.checked)}
                    >
                      {t('workflowDesigner.sendEForm.integrateManualStart')}
                    </Checkbox>
                  </div>
                  {artifactAiModes.includes('integrateEmailStart') && artifactAiModes.includes('integrateManualStart') && (
                    <div style={{ marginBottom: 8, padding: '6px 10px', backgroundColor: '#fff7e6', border: '1px solid #ffd591', borderRadius: 4, fontSize: 11, color: '#d46b08' }}>
                      ?? {t('workflowDesigner.sendEForm.emailAndManualBothWarning') || 'Email ????????????????'}
                    </div>
                  )}
                  {artifactAiModes.length > 1 && (
                    <div style={{ fontSize: 11, color: '#1890ff' }}>
                      {t('workflowDesigner.sendEForm.multiSourceDesc') || '?? AI ?????????? AI????????????'}
                    </div>
                  )}
                </Form.Item>
                {artifactAiModes.includes('integrateWaitReply') && (
                  <Form.Item
                    label={t('workflowDesigner.sendEForm.selectUpstreamWaitReplyNode') || '???? waitReply ??'}
                    tooltip={t('workflowDesigner.sendEForm.selectUpstreamWaitReplyNodeHelp') || '???? waitReply ??????? AI ?????=?????'}
                  >
                    <Select
                      placeholder={t('workflowDesigner.sendEForm.selectUpstreamWaitReplyNodePlaceholder') || '?? waitReply ?????=??????'}
                      value={selectedNode.data.integratedWaitReplyNodeId || undefined}
                      onChange={(value) => handleNodeDataChange({ integratedWaitReplyNodeId: value || '' })}
                      allowClear
                      notFoundContent={t('workflowDesigner.sendEForm.noUpstreamWaitReplyNode') || '????? waitReply ??'}
                    >
                      {artifactWaitReplyNodes.map(node => (
                        <Select.Option key={node.id} value={node.id}>
                          {node.data?.taskName || node.id}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}
                {artifactAiModes.includes('integrateChatBot') && (
                  <Form.Item
                    label={t('workflowDesigner.sendEForm.selectUpstreamChatBotNode') || '???? Chatbot ??'}
                    tooltip={t('workflowDesigner.sendEForm.selectUpstreamChatBotNodeHelp') || '???? Chatbot ????????? AI ?????=?? session?'}
                  >
                    <Select
                      placeholder={t('workflowDesigner.sendEForm.selectUpstreamChatBotNodePlaceholder') || '?? Chatbot ?????=?? session??'}
                      value={selectedNode.data.integratedChatBotNodeId || undefined}
                      onChange={(value) => handleNodeDataChange({ integratedChatBotNodeId: value || '' })}
                      allowClear
                      notFoundContent={t('workflowDesigner.sendEForm.noUpstreamChatBotNode') || '????? Chatbot ??'}
                    >
                      {artifactChatBotNodes.map(node => (
                        <Select.Option key={node.id} value={node.id}>
                          {node.data?.taskName || node.id}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}
                {artifactAiModes.includes('integrateChatOrderingCart') && (
                  <Form.Item
                    label={t('workflowDesigner.sendEForm.selectUpstreamChatOrderingCartNode') || '???? Chatbot ?????'}
                    tooltip={t('workflowDesigner.sendEForm.selectUpstreamChatOrderingCartNodeHelp') || '???? Chatbot ?????????????? AI ?????=?? session?'}
                  >
                    <Select
                      placeholder={t('workflowDesigner.sendEForm.selectUpstreamChatOrderingCartNodePlaceholder') || '?? Chatbot ????????=?? session??'}
                      value={selectedNode.data.integratedChatOrderingCartNodeId || undefined}
                      onChange={(value) => handleNodeDataChange({ integratedChatOrderingCartNodeId: value || '' })}
                      allowClear
                      notFoundContent={t('workflowDesigner.sendEForm.noUpstreamChatOrderingCartNode') || '????? Chatbot ?????'}
                    >
                      {artifactChatOrderingCartNodes.map(node => (
                        <Select.Option key={node.id} value={node.id}>
                          {node.data?.taskName || node.id}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}
                {(artifactAiModes.includes('integrateEmailStart') || artifactAiModes.includes('integrateManualStart')) && (
                  <Form.Item
                    label={t('workflowDesigner.sendEForm.integrateEmailStartSendToAi')}
                    tooltip={artifactAiModes.includes('integrateManualStart') && !artifactAiModes.includes('integrateEmailStart')
                      ? t('workflowDesigner.sendEForm.integrateManualStartSendToAiHelp')
                      : t('workflowDesigner.sendEForm.integrateEmailStartSendToAiHelp')}
                  >
                    <Radio.Group
                      value={selectedNode.data.integrateEmailStartSendToAi || 'attachment'}
                      onChange={(e) => handleNodeDataChange({ integrateEmailStartSendToAi: e.target.value })}
                    >
                      <Radio value="attachment">{t('workflowDesigner.sendEForm.integrateEmailStartSendToAiAttachment')}</Radio>
                      <Radio value="body">
                        {artifactAiModes.includes('integrateManualStart') && !artifactAiModes.includes('integrateEmailStart')
                          ? t('workflowDesigner.sendEForm.integrateManualStartSendToAiBody')
                          : t('workflowDesigner.sendEForm.integrateEmailStartSendToAiBody')}
                      </Radio>
                      <Radio value="both">{t('workflowDesigner.sendEForm.integrateEmailStartSendToAiBoth')}</Radio>
                    </Radio.Group>
                  </Form.Item>
                )}
                {artifactIsAiMode && (
                  <>
                    <Form.Item label={t('workflowDesigner.artifact.attachmentAiInputFormat')} tooltip={t('workflowDesigner.artifact.attachmentAiInputFormatHelp')}>
                      <Select
                        value={selectedNode.data.attachmentAiInputFormat || 'any'}
                        onChange={(v) => handleNodeDataChange({ attachmentAiInputFormat: v })}
                      >
                        <Select.Option value="any">{t('workflowDesigner.artifact.attachmentAiInputFormatAny')}</Select.Option>
                        <Select.Option value="pdf">PDF</Select.Option>
                        <Select.Option value="docx">DOCX</Select.Option>
                        <Select.Option value="xlsx">XLSX</Select.Option>
                        <Select.Option value="pptx">PPTX</Select.Option>
                      </Select>
                    </Form.Item>
                    <Form.Item label={t('workflowDesigner.artifact.attachmentBatchMode')} tooltip={t('workflowDesigner.artifact.attachmentBatchModeHelp')}>
                      <Radio.Group
                        value={selectedNode.data.attachmentBatchMode || 'all'}
                        onChange={(e) => handleNodeDataChange({ attachmentBatchMode: e.target.value })}
                      >
                        <Radio value="all">{t('workflowDesigner.artifact.attachmentBatchModeAll')}</Radio>
                        <Radio value="first">{t('workflowDesigner.artifact.attachmentBatchModeFirst')}</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </>
                )}
                {artifactExclusiveMode === 'integrateDataSetQuery' && (
                  <Form.Item label={t('workflowDesigner.sendEForm.selectDataSetQueryNode')}>
                    <Select
                      placeholder={t('workflowDesigner.sendEForm.selectDataSetQueryNodePlaceholder')}
                      value={selectedNode.data.integratedDataSetQueryNodeId || undefined}
                      onChange={(value) => handleNodeDataChange({ integratedDataSetQueryNodeId: value })}
                      allowClear
                    >
                      {nodes.filter(n => n.data?.type === 'dataSetQuery' && n.data?.operationType === 'SELECT' && n.id !== selectedNode.id).map(node => (
                        <Select.Option key={node.id} value={node.id}>
                          {node.data?.taskName || node.id}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}
                {selectedNode.data.type === 'generateDocument' && (
                  <>
                    <Form.Item
                      label={t('workflowDesigner.artifact.documentFormat')}
                      tooltip={selectedNode.data.documentOutputFormat === 'pdf' ? t('workflowDesigner.artifact.documentFormatPdfHelp') : undefined}
                    >
                      <Select
                        value={selectedNode.data.documentOutputFormat || 'docx'}
                        onChange={(v) => handleNodeDataChange({ documentOutputFormat: v })}
                      >
                        <Select.Option value="docx">DOCX</Select.Option>
                        <Select.Option value="xlsx">XLSX</Select.Option>
                        <Select.Option value="pptx">PPTX</Select.Option>
                        <Select.Option value="pdf">PDF</Select.Option>
                      </Select>
                    </Form.Item>
                    <Form.Item label={t('workflowDesigner.artifact.storageKind')}>
                      <Select
                        value={selectedNode.data.documentStorageKind || 'Local'}
                        onChange={(v) => handleNodeDataChange({ documentStorageKind: v })}
                      >
                        <Select.Option value="Local">{t('workflowDesigner.artifact.storageLocal')}</Select.Option>
                        <Select.Option value="GoogleDrive" disabled>Google Drive ({t('workflowDesigner.artifact.comingSoon')})</Select.Option>
                      </Select>
                    </Form.Item>
                  </>
                )}
                      </>
                    ),
                  },
                  {
                    key: 'ai',
                    icon: <RobotOutlined />,
                    tooltip: t('workflowDesigner.sectionAi'),
                    hidden: !artifactIsAiMode,
                    children: (
                      <>
                        {artifactIsAiMode && (
                          <>
                            <Form.Item label={t('workflowDesigner.sendEForm.aiProvider')} required>
                              <SelectWithClearButton
                                clearText={t('workflowDesigner.clear')}
                                loading={loadingAiProviders}
                                placeholder={t('workflowDesigner.sendEForm.aiProviderPlaceholder')}
                                value={selectedNode.data.aiProviderKey || undefined}
                                onChange={(v) => handleNodeDataChange({ aiProviderKey: v })}
                                options={aiProviderOptions}
                              />
                            </Form.Item>
                            <AiStaffSelectField {...aiStaffSelectProps} fieldPath={['aiStaffId']} />
                            <Form.Item label={t('workflowDesigner.sendEForm.fillFormAdditionalPrompt')}>
                              <Input.TextArea
                                rows={3}
                                value={selectedNode.data.fillFormAdditionalPrompt || ''}
                                onChange={(e) => handleNodeDataChange({ fillFormAdditionalPrompt: e.target.value })}
                                placeholder={t('workflowDesigner.sendEForm.fillFormAdditionalPromptPlaceholder')}
                              />
                              <div style={{ marginTop: 6, padding: '6px 8px', background: '#f0f5ff', borderRadius: 4, border: '1px solid #adc6ff', fontSize: 11, lineHeight: '1.7' }}>
                                <div style={{ fontWeight: 600, color: '#2f54eb', marginBottom: 2 }}>{'\u0040\u0040 \u6307\u4ee4\u8a9e\u6cd5\u63d0\u793a\uff1a'}</div>
                                <div><span style={{ color: '#389e0d', fontWeight: 600 }}>{'\u0040\u0040AUTO_FILL_TABLE'}</span>{' '}<span style={{ color: '#595959' }}>{'value=1.00 column=\u55ae\u50f9,\u7e3d\u6578,Rate,Unit Price,Amount qtycol=\u6578\u91cf,Qty sweep=on'}</span></div>
                                <div style={{ color: '#8c8c8c', marginLeft: 8, fontSize: 10 }}>{'\u2191 \u81ea\u52d5\u586b\u5145 BOQ \u91d1\u984d\u6b04\uff1bsweep=on \u88dc\u586b\u7121\u6578\u91cf\u884c'}</div>
                                <div style={{ marginTop: 2 }}><span style={{ color: '#c41d7f', fontWeight: 600 }}>{'\u0040\u0040SIGN_LABEL'}</span>{' '}<span style={{ color: '#595959' }}>{'labels=\u516c\u53f8\u6388\u6b0a\u4ee3\u8868\u7c3d\u7f72,\u6388\u6b0a\u4ee3\u8868,\u7c3d\u7f72\u53ca\u516c\u53f8\u5370,Signature max=1'}</span></div>
                                <div style={{ color: '#8c8c8c', marginLeft: 8, fontSize: 10 }}>{'\u2191 \u81ea\u52d5\u84cb\u7ae0\uff1blabels= \u6307\u5b9a\u5339\u914d\u6a19\u7c64\uff08\u9017\u865f\u5206\u9694\uff09\uff0cmax= \u6bcf\u9801\u6700\u591a\u5e7e\u500b'}</div>
                                <div style={{ marginTop: 2 }}><span style={{ color: '#0050b3', fontWeight: 600 }}>{'\u0040\u0040CHECKBOX'}</span>{' '}<span style={{ color: '#595959' }}>{'labels=No,Yes font=Webdings text=a size=10 page=1'}</span></div>
                                <div style={{ color: '#8c8c8c', marginLeft: 8, fontSize: 10 }}>{'\u2191 \u5728\u6307\u5b9a label \u5c0f\u65b9\u683c\u586b\u5165\u6253\u52fe\u7b26\u865f\uff1bfont= \u5b57\u9ad4\uff08Webdings/Wingdings\uff09\uff0ctext= \u5b57\u5143\uff0cpage= \u9801\u78bc\uff08\u5f9e0\u8a08\uff09'}</div>
                              </div>
                            </Form.Item>
                            {renderPromptVariablesDisplay('fillFormAdditionalPrompt')}
                            <Form.Item label={t('workflowDesigner.sendEForm.additionalPrompt')}>
                              <Input.TextArea
                                rows={2}
                                value={selectedNode.data.additionalPrompt || ''}
                                onChange={(e) => handleNodeDataChange({ additionalPrompt: e.target.value })}
                                placeholder={t('workflowDesigner.sendEForm.additionalPromptPlaceholder')}
                              />
                            </Form.Item>
                            {renderPromptVariablesDisplay('additionalPrompt')}
                            <Form.Item label={t('workflowDesigner.sendEForm.jsonResultVariable')}>
                              <SelectWithClearButton
                                clearText={t('workflowDesigner.clear')}
                                placeholder={t('workflowDesigner.sendEForm.jsonResultVariable')}
                                value={selectedNode.data.jsonResultVariable || undefined}
                                onChange={(v) => handleNodeDataChange({ jsonResultVariable: v })}
                              >
                                {processVariables.map(pv => (
                                  <Select.Option key={pv.id} value={pv.variableName}>{pv.variableName}</Select.Option>
                                ))}
                              </SelectWithClearButton>
                            </Form.Item>
                          </>
                        )}
                        {artifactExclusiveMode === 'integrateDataSetQuery' && (
                          <>
                            <Form.Item label={t('workflowDesigner.sendEForm.aiProvider')} required>
                              <SelectWithClearButton
                                clearText={t('workflowDesigner.clear')}
                                loading={loadingAiProviders}
                                placeholder={t('workflowDesigner.sendEForm.aiProviderPlaceholder')}
                                value={selectedNode.data.aiProviderKey || undefined}
                                onChange={(v) => handleNodeDataChange({ aiProviderKey: v })}
                                options={aiProviderOptions}
                              />
                            </Form.Item>
                            <AiStaffSelectField {...aiStaffSelectProps} fieldPath={['aiStaffId']} />
                            <Form.Item label={t('workflowDesigner.sendEForm.fillFormAdditionalPrompt')}>
                              <Input.TextArea
                                rows={3}
                                value={selectedNode.data.fillFormAdditionalPrompt || ''}
                                onChange={(e) => handleNodeDataChange({ fillFormAdditionalPrompt: e.target.value })}
                              />
                              <div style={{ marginTop: 6, padding: '6px 8px', background: '#f0f5ff', borderRadius: 4, border: '1px solid #adc6ff', fontSize: 11, lineHeight: '1.7' }}>
                                <div style={{ fontWeight: 600, color: '#2f54eb', marginBottom: 2 }}>{'\u0040\u0040 \u6307\u4ee4\u8a9e\u6cd5\u63d0\u793a\uff1a'}</div>
                                <div><span style={{ color: '#389e0d', fontWeight: 600 }}>{'\u0040\u0040AUTO_FILL_TABLE'}</span>{' '}<span style={{ color: '#595959' }}>{'value=1.00 column=\u55ae\u50f9,\u7e3d\u6578,Rate,Unit Price,Amount qtycol=\u6578\u91cf,Qty sweep=on'}</span></div>
                                <div style={{ color: '#8c8c8c', marginLeft: 8, fontSize: 10 }}>{'\u2191 \u81ea\u52d5\u586b\u5145 BOQ \u91d1\u984d\u6b04\uff1bsweep=on \u88dc\u586b\u7121\u6578\u91cf\u884c'}</div>
                                <div style={{ marginTop: 2 }}><span style={{ color: '#c41d7f', fontWeight: 600 }}>{'\u0040\u0040SIGN_LABEL'}</span>{' '}<span style={{ color: '#595959' }}>{'labels=\u516c\u53f8\u6388\u6b0a\u4ee3\u8868\u7c3d\u7f72,\u6388\u6b0a\u4ee3\u8868,\u7c3d\u7f72\u53ca\u516c\u53f8\u5370,Signature max=1'}</span></div>
                                <div style={{ color: '#8c8c8c', marginLeft: 8, fontSize: 10 }}>{'\u2191 \u81ea\u52d5\u84cb\u7ae0\uff1blabels= \u6307\u5b9a\u5339\u914d\u6a19\u7c64\uff08\u9017\u865f\u5206\u9694\uff09\uff0cmax= \u6bcf\u9801\u6700\u591a\u5e7e\u500b'}</div>
                                <div style={{ marginTop: 2 }}><span style={{ color: '#0050b3', fontWeight: 600 }}>{'\u0040\u0040CHECKBOX'}</span>{' '}<span style={{ color: '#595959' }}>{'labels=No,Yes font=Webdings text=a size=10 page=1'}</span></div>
                                <div style={{ color: '#8c8c8c', marginLeft: 8, fontSize: 10 }}>{'\u2191 \u5728\u6307\u5b9a label \u5c0f\u65b9\u683c\u586b\u5165\u6253\u52fe\u7b26\u865f\uff1bfont= \u5b57\u9ad4\uff08Webdings/Wingdings\uff09\uff0ctext= \u5b57\u5143\uff0cpage= \u9801\u78bc\uff08\u5f9e0\u8a08\uff09'}</div>
                              </div>
                            </Form.Item>
                            {renderPromptVariablesDisplay('fillFormAdditionalPrompt')}
                          </>
                        )}
                      </>
                    ),
                  },
                  {
                    key: 'knowledge',
                    icon: <ReadOutlined />,
                    tooltip: t('workflowDesigner.sectionKnowledgeBase'),
                    hidden: !artifactIsAiMode,
                    children: (
                      <WorkflowKnowledgeBaseSettingsControl
                        nodeData={selectedNode.data}
                        onApply={(patch) => handleNodeDataChange(patch)}
                        dataSets={dataSets}
                        loadingDataSets={loadingDataSets}
                        knowledgeStudioDocs={knowledgeStudioDocs}
                        loadingKnowledgeStudioDocs={loadingKnowledgeStudioDocs}
                        broadcastGroups={broadcastGroups}
                        loadingBroadcastGroups={loadingBroadcastGroups}
                        processVariables={processVariables}
                        generateWhereClause={generateWhereClause}
                        t={t}
                        labels={{
                          dataSetLabelKey: 'workflowDesigner.sendEForm.knowledgeBaseDataSet',
                          queryLabelKey: 'workflowDesigner.sendEForm.knowledgeBaseQueryConditions',
                        }}
                      />
                    ),
                  },
                  {
                    key: 'recipientAndMessage',
                    icon: <MessageOutlined />,
                    tooltip: t('workflowDesigner.sectionRecipientAndMessage'),
                    children: (
                      <>
                <Form.Item label={t('workflowDesigner.artifact.sendNotification')}>
                  <Switch
                    checked={selectedNode.data.sendNotificationToRecipients !== false}
                    onChange={(c) => {
                      const payload = { sendNotificationToRecipients: c };
                      if (!c) {
                        payload.to = '';
                        payload.recipientDetails = { users: [], contacts: [], groups: [], hashtags: [], useInitiator: false, phoneNumbers: [] };
                      }
                      handleNodeDataChange(payload);
                    }}
                  />
                </Form.Item>
                {selectedNode.data.sendNotificationToRecipients !== false && (
                  <>
                    <Form.Item label={t('workflow.to')}>
                      <div style={{ position: 'relative' }}>
                        <RecipientSelector
                          value={selectedNode.data.to || ''}
                          recipientDetails={selectedNode.data.recipientDetails}
                          placeholder={t('workflowDesigner.selectRecipients')}
                          compact={true}
                          workflowDefinitionId={workflowId}
                          t={t}
                          onChange={(value, detailedValue) => {
                            if (value === '' && detailedValue === null) {
                              setIsRecipientModalVisible(true);
                            } else {
                              handleNodeDataChange({ to: value, recipientDetails: detailedValue });
                            }
                          }}
                        />
                        <div style={{ position: 'absolute', right: '8px', top: '50%', transform: 'translateY(-50%)', display: 'flex', gap: '4px' }}>
                          {selectedNode.data.to && (
                            <Button
                              type="text"
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleNodeDataChange({ to: '', recipientDetails: { users: [], contacts: [], groups: [], hashtags: [], useInitiator: false, phoneNumbers: [] } });
                              }}
                              style={{ padding: '0 4px', fontSize: '12px' }}
                            >
                              {t('workflowDesigner.clear')}
                            </Button>
                          )}
                        </div>
                      </div>
                    </Form.Item>
                    <Divider />
                    <div style={{ marginBottom: 8 }}>
                      <MessageModeTabsComponent
                        selectedNode={selectedNode}
                        handleNodeDataChange={(payload) => {
                          const tp = selectedNode?.data?.type;
                          const isArtifact = tp === 'generateHtmlReport' || tp === 'generateDocument';
                          if (
                            isArtifact &&
                            payload &&
                            typeof payload === 'object' &&
                            Object.prototype.hasOwnProperty.call(payload, 'message') &&
                            (selectedNode.data.messageMode || 'direct') === 'direct'
                          ) {
                            handleNodeDataChange({ ...payload, messageTemplate: payload.message });
                          } else {
                            handleNodeDataChange(payload);
                          }
                        }}
                        setIsTemplateModalVisible={setIsTemplateModalVisible}
                        processVariables={processVariables}
                        form={form}
                        t={t}
                        messageLabel={t('workflow.message')}
                        messagePlaceholder="workflowDesigner.messageWithVariablesPlaceholder"
                        messageRows={4}
                        showProcessVariables
                        enableEmailMode
                        metaTemplates={metaTemplates}
                        fixedVariables={artifactReportDocFixedVariables}
                        onMessageModeTabChange={(key) => {
                          const d = selectedNode.data;
                          if (key === 'direct' && !(d.message || '').trim() && (d.messageTemplate || '').trim()) {
                            const mt = d.messageTemplate;
                            handleNodeDataChange({ messageMode: key, message: mt, messageTemplate: mt });
                            form.setFieldsValue({ message: mt });
                          } else {
                            handleNodeDataChange({ messageMode: key });
                          }
                        }}
                      />
                      <div style={{ fontSize: 12, color: '#666', marginTop: 8 }}>
                        {artifactReportDocFixedVariables.map((v) => (
                          <div key={v.id}>
                            <code>{v.displayName}</code> ? {v.description}
                          </div>
                        ))}
                      </div>
                    </div>
                  </>
                )}
                      </>
                    ),
                  },
                  {
                    key: 'embeddedImages',
                    icon: <PictureOutlined />,
                    tooltip: t('workflowDesigner.artifact.embeddedImages') || '????',
                    hidden: !artifactIsAiMode,
                    children: (() => {
                      const embeddedImages = selectedNode.data.embeddedImages || [];
                      const handleEmbeddedImageUpload = async (e) => {
                        const file = e.target.files && e.target.files[0];
                        if (!file) return;
                        if (!workflowId) {
                          message.error(t('workflowDesigner.artifact.embeddedImageNoWorkflowId') || '??????????????');
                          return;
                        }
                        const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/webp', 'image/svg+xml'];
                        if (!allowedTypes.includes(file.type)) {
                          message.error(t('workflowDesigner.artifact.embeddedImageInvalidType') || '??? jpg/png/gif/bmp/webp/svg ??');
                          return;
                        }
                        const formData = new FormData();
                        formData.append('file', file);
                        try {
                          const token = localStorage.getItem('token');
                          const resp = await fetch(`/api/ProcessDefinitionUploads/image?workflowDefinitionId=${encodeURIComponent(workflowId)}`, {
                            method: 'POST',
                            headers: { Authorization: `Bearer ${token}` },
                            body: formData,
                          });
                          if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
                          const data = await resp.json();
                          if (!data.success) throw new Error(data.error || '????');
                          const defaultName = (data.originalName || file.name).replace(/\.[^.]+$/, '');
                          const newItem = { name: defaultName, url: data.url };
                          handleNodeDataChange({ embeddedImages: [...embeddedImages, newItem] });
                          message.success(t('workflowDesigner.artifact.embeddedImageUploaded') || '??????');
                        } catch (err) {
                          message.error(`${t('workflowDesigner.artifact.embeddedImageUploadFailed') || '??????'}?${err.message}`);
                        }
                        e.target.value = '';
                      };
                      return (
                        <>
                          <div style={{ fontSize: 12, color: '#666', background: '#f9f9f9', border: '1px solid #e8e8e8', borderRadius: 4, padding: '8px 10px', marginBottom: 12 }}>
                            {t('workflowDesigner.artifact.embeddedImageDesc') || '??????????????????????????????????????????????????AI ?????????????'}
                          </div>
                          <div style={{ marginBottom: 8 }}>
                            <input
                              type="file"
                              accept="image/*"
                              id={`embedded-img-upload-${selectedNode.id}`}
                              style={{ display: 'none' }}
                              onChange={handleEmbeddedImageUpload}
                            />
                            <Button
                              icon={<PlusOutlined />}
                              size="small"
                              onClick={() => document.getElementById(`embedded-img-upload-${selectedNode.id}`)?.click()}
                            >
                              {t('workflowDesigner.artifact.embeddedImageUpload') || '????'}
                            </Button>
                            <span style={{ fontSize: 12, color: '#999', marginLeft: 8 }}>
                              {t('workflowDesigner.artifact.embeddedImageHint') || '?? jpg/png/gif/bmp/webp/svg?? additionalPrompt ????????????'}
                            </span>
                          </div>
                          {embeddedImages.map((img, idx) => (
                            <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8, padding: '6px 8px', border: '1px solid #e8e8e8', borderRadius: 4 }}>
                              <img src={img.url} alt={img.name} style={{ width: 40, height: 40, objectFit: 'contain', border: '1px solid #f0f0f0', borderRadius: 2, flexShrink: 0 }} />
                              <Input
                                size="small"
                                style={{ flex: 1 }}
                                value={img.name}
                                placeholder={t('workflowDesigner.artifact.embeddedImageName') || '?????? prompt ????'}
                                onChange={(e) => {
                                  const updated = embeddedImages.map((item, i) => i === idx ? { ...item, name: e.target.value } : item);
                                  handleNodeDataChange({ embeddedImages: updated });
                                }}
                              />
                              <Button
                                size="small"
                                type="text"
                                danger
                                icon={<DeleteOutlined />}
                                onClick={() => {
                                  handleNodeDataChange({ embeddedImages: embeddedImages.filter((_, i) => i !== idx) });
                                }}
                              />
                            </div>
                          ))}
                          {embeddedImages.length === 0 && (
                            <div style={{ color: '#aaa', fontSize: 12, textAlign: 'center', padding: '16px 0' }}>
                              {t('workflowDesigner.artifact.embeddedImageEmpty') || '????????'}
                            </div>
                          )}
                        </>
                      );
                    })(),
                  },
                ]}
              />
              );
            })()}

            {/* ???? */}
            {selectedNode.data.type === 'calendar' && (() => {
              // ?? ???????calendar ?????????????????????????????????
              const getCalendarModes = () => {
                if (selectedNode.data.generationModes?.length > 0) return selectedNode.data.generationModes;
                const single = selectedNode.data.generationMode || 'integrateWaitReply';
                return [single];
              };
              const currentCalendarModes = getCalendarModes();
              const CALENDAR_EXCLUSIVE = ['integrateDataSetQuery', 'staticJson', 'processVariable'];
              const calendarExclusiveMode = currentCalendarModes.length === 1 && CALENDAR_EXCLUSIVE.includes(currentCalendarModes[0]) ? currentCalendarModes[0] : null;
              const calendarAiModes = currentCalendarModes.filter(m => ['integrateWaitReply', 'integrateChatBot', 'integrateChatOrderingCart', 'integrateEForm', 'integrateEmailStart', 'integrateManualStart'].includes(m));
              const calendarIsAiMode = calendarAiModes.length > 0;

              const handleCalendarExclusiveMode = (mode) => {
                handleNodeDataChange({ generationModes: [mode], generationMode: mode, integratedDataSetQueryNodeId: '', integratedEFormNodeId: '', integratedWaitReplyNodeId: '', integratedChatBotNodeId: '', integratedChatOrderingCartNodeId: '' });
              };
              const handleCalendarAiToggle = (mode, checked) => {
                let newModes = checked
                  ? [...new Set([...calendarAiModes, mode])]
                  : calendarAiModes.filter(m => m !== mode);
                if (newModes.length === 0) newModes = ['integrateWaitReply'];
                handleNodeDataChange({
                  generationModes: newModes,
                  generationMode: newModes[0],
                  integratedDataSetQueryNodeId: '',
                  integratedEFormNodeId: newModes.includes('integrateEForm') ? (selectedNode.data.integratedEFormNodeId || '') : '',
                  integratedWaitReplyNodeId: newModes.includes('integrateWaitReply') ? (selectedNode.data.integratedWaitReplyNodeId || '') : '',
                  integratedChatBotNodeId: newModes.includes('integrateChatBot') ? (selectedNode.data.integratedChatBotNodeId || '') : '',
                  integratedChatOrderingCartNodeId: newModes.includes('integrateChatOrderingCart') ? (selectedNode.data.integratedChatOrderingCartNodeId || '') : '',
                });
              };
              // ?????????????????????????????????????????????????????????????
              const calendarSendEFormNodes = (nodes || []).filter(n => n.data?.type === 'sendEForm' && n.id !== selectedNode.id);
              const calendarWaitReplyNodes = (nodes || []).filter(n => n.data?.type === 'waitReply' && n.id !== selectedNode.id);
              const calendarChatBotNodes = (nodes || []).filter(n => n.data?.type === 'chatBot' && n.id !== selectedNode.id);
              const calendarChatOrderingCartNodes = (nodes || []).filter(n => n.data?.type === 'chatOrderingCart' && n.id !== selectedNode.id);
              return (
                <PropertySectionTabs
                  resetKey={selectedNode.id}
                  sections={[
                    {
                      key: 'source',
                      icon: <CalendarOutlined />,
                      tooltip: t('workflowDesigner.calendar.generationMode') || '????',
                      children: (
                        <>
                          <Divider orientation="left">
                            {t('workflowDesigner.calendar.generationMode') || '????'}
                          </Divider>
                          <Form.Item label={t('workflowDesigner.calendar.generationMode') || '????'}>
                            {/* ????????*/}
                            <div style={{ marginBottom: 6, fontSize: 11, color: '#888', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                              {t('workflowDesigner.sendEForm.exclusiveModeLabel') || '????????'}
                            </div>
                            <div style={{ marginBottom: 4 }}>
                              <Radio checked={calendarExclusiveMode === 'integrateDataSetQuery'} onChange={() => handleCalendarExclusiveMode('integrateDataSetQuery')}>
                                {t('workflowDesigner.sendEForm.integrateDataSetQuery')}
                              </Radio>
                            </div>
                            <div style={{ marginBottom: 4 }}>
                              <Radio checked={calendarExclusiveMode === 'processVariable'} onChange={() => handleCalendarExclusiveMode('processVariable')}>
                                Process Variable
                              </Radio>
                            </div>
                            <div style={{ marginBottom: 12 }}>
                              <Radio checked={calendarExclusiveMode === 'staticJson'} onChange={() => handleCalendarExclusiveMode('staticJson')}>
                                Static JSON
                              </Radio>
                            </div>
                            {/* AI ???????*/}
                            <div style={{ marginBottom: 6, fontSize: 11, color: '#888', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                              {t('workflowDesigner.sendEForm.aiSourceLabel') || 'AI ?????????'}
                            </div>
                            <div style={{ marginBottom: 4 }}>
                              <Checkbox checked={calendarAiModes.includes('integrateWaitReply')} onChange={e => handleCalendarAiToggle('integrateWaitReply', e.target.checked)}>
                                {t('workflowDesigner.sendEForm.integrateWaitReply')}
                              </Checkbox>
                            </div>
                            <div style={{ marginBottom: 4 }}>
                              <Checkbox checked={calendarAiModes.includes('integrateChatBot')} onChange={e => handleCalendarAiToggle('integrateChatBot', e.target.checked)}>
                                {t('workflowDesigner.sendEForm.integrateChatBot') || '?? Chatbot ?? (AI ??)'}
                              </Checkbox>
                            </div>
                            <div style={{ marginBottom: 4 }}>
                              <Checkbox checked={calendarAiModes.includes('integrateChatOrderingCart')} onChange={e => handleCalendarAiToggle('integrateChatOrderingCart', e.target.checked)}>
                                {t('workflowDesigner.sendEForm.integrateChatOrderingCart') || '?? Chatbot ????? (AI ??)'}
                              </Checkbox>
                            </div>
                            <div style={{ marginBottom: 4 }}>
                              <Checkbox checked={calendarAiModes.includes('integrateEForm')} onChange={e => handleCalendarAiToggle('integrateEForm', e.target.checked)}>
                                {t('workflowDesigner.sendEForm.integrateEForm') || '???? eForm ??'}
                              </Checkbox>
                            </div>
                            <div style={{ marginBottom: 4 }}>
                              <Checkbox checked={calendarAiModes.includes('integrateEmailStart')} onChange={e => handleCalendarAiToggle('integrateEmailStart', e.target.checked)}>
                                {t('workflowDesigner.sendEForm.integrateEmailStart')}
                              </Checkbox>
                            </div>
                            <div style={{ marginBottom: 8 }}>
                              <Checkbox checked={calendarAiModes.includes('integrateManualStart')} onChange={e => handleCalendarAiToggle('integrateManualStart', e.target.checked)}>
                                {t('workflowDesigner.sendEForm.integrateManualStart')}
                              </Checkbox>
                            </div>
                            {calendarAiModes.includes('integrateEmailStart') && calendarAiModes.includes('integrateManualStart') && (
                              <div style={{ marginBottom: 8, padding: '6px 10px', backgroundColor: '#fff7e6', border: '1px solid #ffd591', borderRadius: 4, fontSize: 11, color: '#d46b08' }}>
                                ?? {t('workflowDesigner.sendEForm.emailAndManualBothWarning') || 'Email ????????????????'}
                              </div>
                            )}
                            {calendarAiModes.length > 1 && (
                              <div style={{ fontSize: 11, color: '#1890ff' }}>
                                {t('workflowDesigner.sendEForm.multiSourceDesc') || '?? AI ?????????? AI????????????'}
                              </div>
                            )}
                          </Form.Item>

                          {calendarAiModes.includes('integrateWaitReply') && (
                            <Form.Item
                              label={t('workflowDesigner.sendEForm.selectUpstreamWaitReplyNode') || '???? waitReply ??'}
                              tooltip={t('workflowDesigner.sendEForm.selectUpstreamWaitReplyNodeHelp') || '???? waitReply ??????? AI ?????=?????'}
                            >
                              <Select
                                placeholder={t('workflowDesigner.sendEForm.selectUpstreamWaitReplyNodePlaceholder') || '?? waitReply ?????=??????'}
                                value={selectedNode.data.integratedWaitReplyNodeId || undefined}
                                onChange={(value) => handleNodeDataChange({ integratedWaitReplyNodeId: value || '' })}
                                allowClear
                                notFoundContent={t('workflowDesigner.sendEForm.noUpstreamWaitReplyNode') || '????? waitReply ??'}
                              >
                                {calendarWaitReplyNodes.map(node => (
                                  <Select.Option key={node.id} value={node.id}>
                                    {node.data?.taskName || node.id}
                                  </Select.Option>
                                ))}
                              </Select>
                            </Form.Item>
                          )}

                          {calendarAiModes.includes('integrateChatBot') && (
                            <Form.Item
                              label={t('workflowDesigner.sendEForm.selectUpstreamChatBotNode') || '???? Chatbot ??'}
                              tooltip={t('workflowDesigner.sendEForm.selectUpstreamChatBotNodeHelp') || '???? Chatbot ????????? AI ?????=?? session?'}
                            >
                              <Select
                                placeholder={t('workflowDesigner.sendEForm.selectUpstreamChatBotNodePlaceholder') || '?? Chatbot ?????=?? session??'}
                                value={selectedNode.data.integratedChatBotNodeId || undefined}
                                onChange={(value) => handleNodeDataChange({ integratedChatBotNodeId: value || '' })}
                                allowClear
                                notFoundContent={t('workflowDesigner.sendEForm.noUpstreamChatBotNode') || '????? Chatbot ??'}
                              >
                                {calendarChatBotNodes.map(node => (
                                  <Select.Option key={node.id} value={node.id}>
                                    {node.data?.taskName || node.id}
                                  </Select.Option>
                                ))}
                              </Select>
                            </Form.Item>
                          )}

                          {calendarAiModes.includes('integrateChatOrderingCart') && (
                            <Form.Item
                              label={t('workflowDesigner.sendEForm.selectUpstreamChatOrderingCartNode') || '???? Chatbot ?????'}
                              tooltip={t('workflowDesigner.sendEForm.selectUpstreamChatOrderingCartNodeHelp') || '???? Chatbot ?????????????? AI ?????=?? session?'}
                            >
                              <Select
                                placeholder={t('workflowDesigner.sendEForm.selectUpstreamChatOrderingCartNodePlaceholder') || '?? Chatbot ????????=?? session??'}
                                value={selectedNode.data.integratedChatOrderingCartNodeId || undefined}
                                onChange={(value) => handleNodeDataChange({ integratedChatOrderingCartNodeId: value || '' })}
                                allowClear
                                notFoundContent={t('workflowDesigner.sendEForm.noUpstreamChatOrderingCartNode') || '????? Chatbot ?????'}
                              >
                                {calendarChatOrderingCartNodes.map(node => (
                                  <Select.Option key={node.id} value={node.id}>
                                    {node.data?.taskName || node.id}
                                  </Select.Option>
                                ))}
                              </Select>
                            </Form.Item>
                          )}

                          {(calendarAiModes.includes('integrateEmailStart') || calendarAiModes.includes('integrateManualStart')) && (
                            <Form.Item
                              label={t('workflowDesigner.sendEForm.integrateEmailStartSendToAi')}
                              tooltip={calendarAiModes.includes('integrateManualStart') && !calendarAiModes.includes('integrateEmailStart')
                                ? t('workflowDesigner.sendEForm.integrateManualStartSendToAiHelp')
                                : t('workflowDesigner.sendEForm.integrateEmailStartSendToAiHelp')}
                            >
                              <Radio.Group
                                value={selectedNode.data.integrateEmailStartSendToAi || 'attachment'}
                                onChange={(e) => handleNodeDataChange({ integrateEmailStartSendToAi: e.target.value })}
                              >
                                <Radio value="attachment">{t('workflowDesigner.sendEForm.integrateEmailStartSendToAiAttachment')}</Radio>
                                <Radio value="body">
                                  {calendarAiModes.includes('integrateManualStart') && !calendarAiModes.includes('integrateEmailStart')
                                    ? t('workflowDesigner.sendEForm.integrateManualStartSendToAiBody')
                                    : t('workflowDesigner.sendEForm.integrateEmailStartSendToAiBody')}
                                </Radio>
                                <Radio value="both">{t('workflowDesigner.sendEForm.integrateEmailStartSendToAiBoth')}</Radio>
                              </Radio.Group>
                            </Form.Item>
                          )}

                          {calendarIsAiMode && (
                            <>
                              <Form.Item label={t('workflowDesigner.artifact.attachmentAiInputFormat')}>
                                <Select
                                  value={selectedNode.data.attachmentAiInputFormat || 'any'}
                                  onChange={(v) => handleNodeDataChange({ attachmentAiInputFormat: v })}
                                >
                                  <Select.Option value="any">{t('workflowDesigner.artifact.attachmentAiInputFormatAny')}</Select.Option>
                                  <Select.Option value="pdf">PDF</Select.Option>
                                  <Select.Option value="docx">DOCX</Select.Option>
                                  <Select.Option value="xlsx">XLSX</Select.Option>
                                  <Select.Option value="pptx">PPTX</Select.Option>
                                </Select>
                              </Form.Item>
                              <Form.Item label={t('workflowDesigner.artifact.attachmentBatchMode')}>
                                <Radio.Group
                                  value={selectedNode.data.attachmentBatchMode || 'all'}
                                  onChange={(e) => handleNodeDataChange({ attachmentBatchMode: e.target.value })}
                                >
                                  <Radio value="all">{t('workflowDesigner.artifact.attachmentBatchModeAll')}</Radio>
                                  <Radio value="first">{t('workflowDesigner.artifact.attachmentBatchModeFirst')}</Radio>
                                </Radio.Group>
                              </Form.Item>
                            </>
                          )}

                          {calendarExclusiveMode === 'integrateDataSetQuery' && (
                            <Form.Item label={t('workflowDesigner.sendEForm.selectDataSetQueryNode')}>
                              <Select
                                placeholder={t('workflowDesigner.sendEForm.selectDataSetQueryNodePlaceholder')}
                                value={selectedNode.data.integratedDataSetQueryNodeId || undefined}
                                onChange={(value) => handleNodeDataChange({ integratedDataSetQueryNodeId: value })}
                                allowClear
                              >
                                {nodes.filter(n => n.data?.type === 'dataSetQuery' && n.data?.operationType === 'SELECT' && n.id !== selectedNode.id).map(node => (
                                  <Select.Option key={node.id} value={node.id}>
                                    {node.data?.taskName || node.id}
                                  </Select.Option>
                                ))}
                              </Select>
                            </Form.Item>
                          )}

                          {calendarAiModes.includes('integrateEForm') && (
                            <Form.Item
                              label={t('workflowDesigner.sendEForm.selectUpstreamEFormNode') || '?? sendEForm ??'}
                              tooltip={t('workflowDesigner.sendEForm.selectUpstreamEFormNodeHelp')
                                || '????????????? sendEForm ?????????FilledHtmlCode?????????? AI ?????????????????????'}
                            >
                              <Select
                                placeholder={t('workflowDesigner.sendEForm.selectUpstreamEFormNodePlaceholder') || '?????? sendEForm ???'}
                                value={selectedNode.data.integratedEFormNodeId || undefined}
                                onChange={(value) => handleNodeDataChange({ integratedEFormNodeId: value || '' })}
                                allowClear
                                notFoundContent={t('workflowDesigner.sendEForm.noUpstreamEFormNode') || '????? sendEForm ??'}
                              >
                                {calendarSendEFormNodes.map(node => (
                                  <Select.Option key={node.id} value={node.id}>
                                    {node.data?.taskName || node.data?.formName || node.id}
                                  </Select.Option>
                                ))}
                              </Select>
                              {calendarSendEFormNodes.length === 0 && (
                                <div style={{ marginTop: 6, color: '#ff7875', fontSize: 12 }}>
                                  {t('workflowDesigner.sendEForm.noUpstreamEFormNode') || '????? sendEForm ??????? sendEForm ???'}
                                </div>
                              )}
                            </Form.Item>
                          )}

                          {calendarExclusiveMode === 'processVariable' && (
                            <Form.Item
                              label={t('workflowDesigner.calendar.calendarCommandVariable') || 'Process Variable'}
                              tooltip="?????? calendar JSON ????"
                            >
                              <SelectWithClearButton
                                clearText={t('workflowDesigner.clear')}
                                value={selectedNode.data.calendarCommandVariable || undefined}
                                onChange={(v) => handleNodeDataChange({ calendarCommandVariable: v })}
                              >
                                {processVariables.map(pv => (
                                  <Select.Option key={pv.id} value={pv.variableName}>{pv.variableName}</Select.Option>
                                ))}
                              </SelectWithClearButton>
                            </Form.Item>
                          )}

                          {calendarExclusiveMode === 'staticJson' && (
                            <Form.Item label="Static JSON">
                              <Input.TextArea
                                rows={6}
                                value={selectedNode.data.json || ''}
                                onChange={(e) => handleNodeDataChange({ json: e.target.value })}
                                placeholder='{"version":"1.0","commands":[...]}'
                              />
                            </Form.Item>
                          )}

                          <Divider orientation="left">{t('workflowDesigner.calendar.defaultWorkflowDefinitionLinkage') || 'Linkage'}</Divider>
                          <Form.Item
                            label={t('workflowDesigner.calendar.defaultWorkflowDefinitionLinkage') || '?????????????'}
                          >
                            <Switch
                              checked={selectedNode.data.defaultWorkflowDefinitionLinkage !== false}
                              onChange={(v) => handleNodeDataChange({ defaultWorkflowDefinitionLinkage: v })}
                            />
                          </Form.Item>
                          <Form.Item label={t('workflowDesigner.calendar.dryRun') || 'Dry Run'}>
                            <Switch
                              checked={!!selectedNode.data.dryRun}
                              onChange={(v) => handleNodeDataChange({ dryRun: v })}
                            />
                          </Form.Item>
                          <Form.Item label={t('workflowDesigner.calendar.failOnValidationError') || 'Fail on validation error'}>
                            <Switch
                              checked={!!selectedNode.data.failOnValidationError}
                              onChange={(v) => handleNodeDataChange({ failOnValidationError: v })}
                            />
                          </Form.Item>
                        </>
                      ),
                    },
                    {
                      key: 'ai',
                      icon: <RobotOutlined />,
                      tooltip: t('workflowDesigner.sectionAi'),
                      hidden: !calendarIsAiMode,
                      children: (
                        <>
                          <Form.Item label={t('workflowDesigner.sendEForm.aiProvider')} required>
                            <SelectWithClearButton
                              clearText={t('workflowDesigner.clear')}
                              loading={loadingAiProviders}
                              placeholder={t('workflowDesigner.sendEForm.aiProviderPlaceholder')}
                              value={selectedNode.data.aiProviderKey || undefined}
                              onChange={(v) => handleNodeDataChange({ aiProviderKey: v })}
                              options={aiProviderOptions}
                            />
                          </Form.Item>
                          <AiStaffSelectField {...aiStaffSelectProps} fieldPath={['aiStaffId']} />
                          <Form.Item label={t('workflowDesigner.calendar.fillCalendarAdditionalPrompt') || 'Fill Calendar Additional Prompt'}>
                            <Input.TextArea
                              rows={3}
                              value={selectedNode.data.fillCalendarAdditionalPrompt || ''}
                              onChange={(e) => handleNodeDataChange({ fillCalendarAdditionalPrompt: e.target.value })}
                              placeholder={t('workflowDesigner.calendar.fillCalendarAdditionalPromptPlaceholder') || ''}
                            />
                          </Form.Item>
                          {renderPromptVariablesDisplay('fillCalendarAdditionalPrompt')}
                          <Form.Item label={t('workflowDesigner.calendar.additionalPrompt') || 'Additional Prompt'}>
                            <Input.TextArea
                              rows={3}
                              value={selectedNode.data.additionalPrompt || ''}
                              onChange={(e) => handleNodeDataChange({ additionalPrompt: e.target.value })}
                              placeholder={t('workflowDesigner.calendar.additionalPromptPlaceholder') || ''}
                            />
                          </Form.Item>
                          {renderPromptVariablesDisplay('additionalPrompt')}
                          <Form.Item
                            label={t('workflowDesigner.calendar.resourceContactRefs') || '???????'}
                            tooltip={
                              t('workflowDesigner.calendar.resourceContactRefsHelp') ||
                              '???????????????????????? Contact?\n' +
                              '? ?????? 85296366318?\n' +
                              '? Email?? user@example.com?\n' +
                              '? {{initiator}} ? ?????????\n\n' +
                              '???? ? ?????????????? ? ??????????????????????'
                            }
                          >
                            <Input.TextArea
                              rows={3}
                              value={selectedNode.data.resourceContactRefs || ''}
                              onChange={(e) => handleNodeDataChange({ resourceContactRefs: e.target.value })}
                              placeholder={
                                t('workflowDesigner.calendar.resourceContactRefsPlaceholder') ||
                                '????????\n85296366318\nuser@example.com\n{{initiator}}'
                              }
                            />
                          </Form.Item>
                          <Form.Item
                            label={t('workflowDesigner.calendar.defaultEventTypeRef') || '????????'}
                            tooltip={
                              t('workflowDesigner.calendar.defaultEventTypeRefsHelp') ||
                              '?????????????????????\n' +
                              '? AI ?????? eventTypeId????????????????\n' +
                              '? AI ?? additional prompt ????????????? AI ????\n' +
                              '? ??????? ? ????eventTypeId ???? AI ???\n' +
                              '? ????????????? AI context???? additional prompt ???????'
                            }
                          >
                            <Input
                              value={selectedNode.data.defaultEventTypeRef || ''}
                              onChange={(e) => handleNodeDataChange({ defaultEventTypeRef: e.target.value })}
                              placeholder={t('workflowDesigner.calendar.defaultEventTypeRefPlaceholder') || '???????'}
                            />
                          </Form.Item>
                          <Form.Item label={t('workflowDesigner.calendar.calendarCommandVariable') || 'Save command JSON to variable'}>
                            <SelectWithClearButton
                              clearText={t('workflowDesigner.clear')}
                              value={selectedNode.data.calendarCommandVariable || undefined}
                              onChange={(v) => handleNodeDataChange({ calendarCommandVariable: v })}
                            >
                              {processVariables.map(pv => (
                                <Select.Option key={pv.id} value={pv.variableName}>{pv.variableName}</Select.Option>
                              ))}
                            </SelectWithClearButton>
                          </Form.Item>
                        </>
                      ),
                    },
                    {
                      key: 'snapshot',
                      icon: <FieldTimeOutlined />,
                      tooltip: t('workflowDesigner.calendar.snapshotSection') || '?????????',
                      hidden: !calendarIsAiMode,
                      children: (
                        <>
                          <Alert
                            type="info"
                            showIcon
                            style={{ marginBottom: 12 }}
                            message={t('workflowDesigner.calendar.snapshotHelp')
                              || '??? AI?????????? from/to/timezone?????? + ??????????????????? AI ??????????? commands?'}
                          />
                          <Form.Item label={t('workflowDesigner.calendar.disableTwoStage') || 'Disable two-stage AI'}>
                            <Switch
                              checked={!!selectedNode.data.disableTwoStage}
                              onChange={(v) => handleNodeDataChange({ disableTwoStage: v })}
                            />
                          </Form.Item>

                          <Divider orientation="left" style={{ margin: '8px 0' }}>
                            {t('workflowDesigner.calendar.windowDefaults') || '???????AI ??? fallback?'}
                          </Divider>
                          <Form.Item
                            label={t('workflowDesigner.calendar.analysisLookBackDaysDefault') || 'Look-back default (days)'}
                            tooltip="from = now - N day"
                          >
                            <InputNumber
                              min={0}
                              style={{ width: '100%' }}
                              value={selectedNode.data.analysisLookBackDaysDefault ?? 30}
                              onChange={(v) => handleNodeDataChange({ analysisLookBackDaysDefault: v })}
                            />
                          </Form.Item>
                          <Form.Item
                            label={t('workflowDesigner.calendar.analysisLookAheadDaysDefault') || 'Look-ahead default (days)'}
                            tooltip="to = now + N day"
                          >
                            <InputNumber
                              min={1}
                              style={{ width: '100%' }}
                              value={selectedNode.data.analysisLookAheadDaysDefault ?? 365}
                              onChange={(v) => handleNodeDataChange({ analysisLookAheadDaysDefault: v })}
                            />
                          </Form.Item>

                          <Divider orientation="left" style={{ margin: '8px 0' }}>
                            {t('workflowDesigner.calendar.windowMaxes') || '??????????'}
                          </Divider>
                          <Form.Item label={t('workflowDesigner.calendar.analysisLookBackDaysMax') || 'Look-back max (days)'}>
                            <InputNumber
                              min={0}
                              style={{ width: '100%' }}
                              value={selectedNode.data.analysisLookBackDaysMax ?? 90}
                              onChange={(v) => handleNodeDataChange({ analysisLookBackDaysMax: v })}
                            />
                          </Form.Item>
                          <Form.Item label={t('workflowDesigner.calendar.analysisLookAheadDaysMax') || 'Look-ahead max (days)'}>
                            <InputNumber
                              min={1}
                              style={{ width: '100%' }}
                              value={selectedNode.data.analysisLookAheadDaysMax ?? 1095}
                              onChange={(v) => handleNodeDataChange({ analysisLookAheadDaysMax: v })}
                            />
                          </Form.Item>

                          <Divider orientation="left" style={{ margin: '8px 0' }}>
                            {t('workflowDesigner.calendar.snapshotLimits') || '??????'}
                          </Divider>
                          <Form.Item
                            label={t('workflowDesigner.calendar.snapshotMaxEvents') || 'Snapshot max events'}
                            tooltip={t('workflowDesigner.calendar.snapshotMaxEventsHelp') || '??????? perDayCount ????? events ???'}
                          >
                            <InputNumber
                              min={1}
                              style={{ width: '100%' }}
                              value={selectedNode.data.snapshotMaxEvents ?? 500}
                              onChange={(v) => handleNodeDataChange({ snapshotMaxEvents: v })}
                            />
                          </Form.Item>
                          <Form.Item
                            label={t('workflowDesigner.calendar.snapshotIncludeEvents') || 'Include event details'}
                            tooltip={t('workflowDesigner.calendar.snapshotIncludeEventsHelp') || '????????????? token'}
                          >
                            <Switch
                              checked={selectedNode.data.snapshotIncludeEvents !== false}
                              onChange={(v) => handleNodeDataChange({ snapshotIncludeEvents: v })}
                            />
                          </Form.Item>
                        </>
                      ),
                    },
                    {
                      key: 'knowledge',
                      icon: <ReadOutlined />,
                      tooltip: t('workflowDesigner.sectionKnowledgeBase'),
                      hidden: !calendarIsAiMode,
                      children: (
                        <WorkflowKnowledgeBaseSettingsControl
                          nodeData={selectedNode.data}
                          onApply={(patch) => handleNodeDataChange(patch)}
                          dataSets={dataSets}
                          loadingDataSets={loadingDataSets}
                          knowledgeStudioDocs={knowledgeStudioDocs}
                          loadingKnowledgeStudioDocs={loadingKnowledgeStudioDocs}
                          broadcastGroups={broadcastGroups}
                          loadingBroadcastGroups={loadingBroadcastGroups}
                          processVariables={processVariables}
                          generateWhereClause={generateWhereClause}
                          t={t}
                          labels={{
                            dataSetLabelKey: 'workflowDesigner.sendEForm.knowledgeBaseDataSet',
                            queryLabelKey: 'workflowDesigner.sendEForm.knowledgeBaseQueryConditions',
                          }}
                        />
                      ),
                    },
                  ]}
                />
              );
            })()}

            {/* Odoo ERP ?? */}
            {selectedNode.data.type === 'odoo' && (() => {
              const odooMode = selectedNode.data.generationMode || 'formBased';
              const odooIsAiMode = ['integrateWaitReply', 'integrateEmailStart', 'integrateManualStart', 'integrateDataSetQuery'].includes(odooMode);
              const odooIsFormMode = odooMode === 'formBased';
              const odooIsDsMode = odooMode === 'integrateDataSetQuery';
              const odooIsMappingMode = odooIsFormMode || odooIsDsMode;
              const odooSendEFormNodes = (nodes || []).filter(n => n.data?.type === 'sendEForm' && n.data?.formId);
              const odooSelectedSendEForm = odooSendEFormNodes.find(n => n.id === selectedNode.data.sourceEFormNodeId);
              const odooEFormFields = odooSelectedSendEForm
                ? (eformFieldsMap[odooSelectedSendEForm.data.formId] || [])
                : [];
              const odooDataSetNodes = (nodes || []).filter(n => n.data?.type === 'dataSetQuery' && n.data?.operationType === 'SELECT' && n.id !== selectedNode.id);
              const odooSelectedDataSetNode = odooDataSetNodes.find(n => n.id === selectedNode.data.integratedDataSetQueryNodeId);
              const odooDataSetColumns = (() => {
                const ds = odooSelectedDataSetNode;
                if (!ds) return [];
                const mf = Array.isArray(ds.data?.mappedFields) ? ds.data.mappedFields : [];
                const odf = Array.isArray(ds.data?.operationDataFields) ? ds.data.operationDataFields : [];
                const cols = new Set();
                mf.forEach(f => { if (f?.fieldName) cols.add(f.fieldName); });
                odf.forEach(f => { if (f?.name) cols.add(f.name); });
                return Array.from(cols);
              })();
              const odooSourceTypeOptions = odooIsDsMode
                ? [
                    { value: 'datasetColumn', label: t('workflowDesigner.odoo.sourceDatasetColumn') || 'DataSet ?' },
                    { value: 'variable', label: t('workflowDesigner.odoo.sourceVariable') || 'Process Variable' },
                    { value: 'static', label: t('workflowDesigner.odoo.sourceStatic') || 'Static' }
                  ]
                : [
                    { value: 'eFormField', label: t('workflowDesigner.odoo.sourceEFormField') || 'eForm Field' },
                    { value: 'variable', label: t('workflowDesigner.odoo.sourceVariable') || 'Process Variable' },
                    { value: 'static', label: t('workflowDesigner.odoo.sourceStatic') || 'Static' }
                  ];
              const operationOptions = [
                { value: 'createPO', label: t('workflowDesigner.odoo.op.createPO') || 'Create Purchase Order (PO)' },
                { value: 'createQuotation', label: t('workflowDesigner.odoo.op.createQuotation') || 'Create Quotation (draft SO)' },
                { value: 'createSO', label: t('workflowDesigner.odoo.op.createSO') || 'Create Sales Order (SO)' },
                { value: 'confirmSO', label: t('workflowDesigner.odoo.op.confirmSO') || 'Confirm Sales Order' },
                { value: 'createInvoice', label: t('workflowDesigner.odoo.op.createInvoice') || 'Create Invoice (INV)' },
                { value: 'postInvoice', label: t('workflowDesigner.odoo.op.postInvoice') || 'Post Invoice' },
                { value: 'createDeliveryNote', label: t('workflowDesigner.odoo.op.createDeliveryNote') || 'Create Delivery Note (DN)' },
                { value: 'createGoodsReceive', label: t('workflowDesigner.odoo.op.createGoodsReceive') || 'Create Goods Receive (GR)' },
                { value: 'createReturn', label: t('workflowDesigner.odoo.op.createReturn') || 'Create Return' },
                { value: 'createCreditNote', label: t('workflowDesigner.odoo.op.createCreditNote') || 'Create Credit Note' },
                { value: 'registerPayment', label: t('workflowDesigner.odoo.op.registerPayment') || 'Register Payment' },
                { value: 'lookupPartner', label: t('workflowDesigner.odoo.op.lookupPartner') || 'Lookup Partner / Customer / Vendor' },
                { value: 'lookupProduct', label: t('workflowDesigner.odoo.op.lookupProduct') || 'Lookup Product' },
                { value: 'lookupStock', label: t('workflowDesigner.odoo.op.lookupStock') || 'Lookup Stock' }
              ];
              const opType = selectedNode.data.operationType || 'createSO';
              const isPicking = opType === 'createDeliveryNote' || opType === 'createGoodsReceive';
              const isInvoice = opType === 'createInvoice' || opType === 'postInvoice' || opType === 'createCreditNote';
              const isPo = opType === 'createPO';

              const mappedFields = Array.isArray(selectedNode.data.mappedFields) ? selectedNode.data.mappedFields : [];
              const updateMappedFields = (next) => handleNodeDataChange({ mappedFields: next });
              const defaultSourceTypeForMode = odooIsDsMode ? 'datasetColumn' : 'eFormField';
              const addMappedField = () => updateMappedFields([
                ...mappedFields,
                {
                  id: `m_${Date.now()}`,
                  odooField: '',
                  sourceType: defaultSourceTypeForMode,
                  sourceValue: '',
                  scope: odooIsDsMode ? 'master' : undefined
                }
              ]);
              const removeMappedField = (idx) => updateMappedFields(mappedFields.filter((_, i) => i !== idx));
              const patchMappedField = (idx, patch) => updateMappedFields(mappedFields.map((m, i) => (i === idx ? { ...m, ...patch } : m)));

              const insertAtCursor = (text) => {
                const ta = odooPromptRef.current?.resizableTextArea?.textArea
                        || odooPromptRef.current?.input
                        || null;
                const cur = selectedNode.data.additionalPrompt || '';
                if (!ta) {
                  handleNodeDataChange({ additionalPrompt: cur + (cur && !cur.endsWith(' ') ? ' ' : '') + text });
                  return;
                }
                const start = typeof ta.selectionStart === 'number' ? ta.selectionStart : cur.length;
                const end = typeof ta.selectionEnd === 'number' ? ta.selectionEnd : cur.length;
                const next = cur.slice(0, start) + text + cur.slice(end);
                handleNodeDataChange({ additionalPrompt: next });
                requestAnimationFrame(() => {
                  try {
                    ta.focus();
                    const pos = start + text.length;
                    ta.setSelectionRange(pos, pos);
                  } catch (_) { /* ignore */ }
                });
              };

              return (
                <PropertySectionTabs
                  resetKey={selectedNode.id}
                  sections={[
                    {
                      key: 'data',
                      icon: <ApiOutlined />,
                      tooltip: t('workflowDesigner.odoo.tabData') || 'Operation',
                      children: (
                        <>
                          <Alert
                            type="info"
                            showIcon
                            style={{ marginBottom: 12 }}
                            message={t('workflowDesigner.odoo.intro') || 'Odoo 19 ERP integration. ??ERP ???Tab ?? odoo provider ?????'}
                          />
                          <Form.Item
                            label={t('workflowDesigner.odoo.apiProviderKey') || 'Odoo Provider'}
                            tooltip={t('workflowDesigner.odoo.apiProviderKeyTip') || '?? API Provider Management ? ERP ?? ? odoo'}
                          >
                            <Input
                              value={selectedNode.data.apiProviderKey || 'odoo'}
                              onChange={(e) => handleNodeDataChange({ apiProviderKey: e.target.value })}
                              placeholder="odoo"
                            />
                          </Form.Item>

                          <Form.Item
                            label={t('workflowDesigner.odoo.operationType') || 'Operation Type'}
                            required
                          >
                            <Select
                              value={opType}
                              options={operationOptions}
                              onChange={(v) => handleNodeDataChange({ operationType: v })}
                              showSearch
                              filterOption={(input, option) => (option?.label || '').toLowerCase().includes(input.toLowerCase())}
                            />
                          </Form.Item>

                          <Form.Item
                            label={t('workflowDesigner.odoo.defaultCompanyId') || 'Default Company ID'}
                            tooltip={t('workflowDesigner.odoo.defaultCompanyIdTip') || '???????? Odoo context.allowed_company_ids'}
                          >
                            <InputNumber
                              style={{ width: '100%' }}
                              min={1}
                              value={selectedNode.data.defaultCompanyId ?? null}
                              onChange={(v) => handleNodeDataChange({ defaultCompanyId: v ?? null })}
                            />
                          </Form.Item>

                          {isPo && (
                            <Form.Item label={t('workflowDesigner.odoo.autoConfirm') || 'Auto button_confirm after create'}>
                              <Switch
                                checked={selectedNode.data.autoConfirm !== false}
                                onChange={(v) => handleNodeDataChange({ autoConfirm: v })}
                              />
                            </Form.Item>
                          )}

                          {isInvoice && (
                            <Form.Item label={t('workflowDesigner.odoo.autoPost') || 'Auto action_post after create'}>
                              <Switch
                                checked={!!selectedNode.data.autoPost}
                                onChange={(v) => handleNodeDataChange({ autoPost: v })}
                              />
                            </Form.Item>
                          )}

                          {isPicking && (
                            <Form.Item
                              label={t('workflowDesigner.odoo.autoValidate') || 'Auto validate (action_assign + button_validate)'}
                              tooltip={t('workflowDesigner.odoo.autoValidateTip') || '????????????? false ???? Odoo ??'}
                            >
                              <Switch
                                checked={!!selectedNode.data.autoValidate}
                                onChange={(v) => handleNodeDataChange({ autoValidate: v })}
                              />
                            </Form.Item>
                          )}
                        </>
                      ),
                    },
                    {
                      key: 'mode',
                      icon: <ThunderboltOutlined />,
                      tooltip: t('workflowDesigner.odoo.tabMode') || 'Generation Mode',
                      children: (
                        <>
                          <Form.Item label={t('workflowDesigner.odoo.generationMode') || 'Generation Mode'}>
                            <Radio.Group
                              value={odooMode}
                              onChange={(e) => handleNodeDataChange({ generationMode: e.target.value })}
                            >
                              <Radio value="formBased">{t('workflowDesigner.odoo.modeFormBased') || 'Form-based (manual mapping)'}</Radio>
                              <Radio value="integrateDataSetQuery">{t('workflowDesigner.sendEForm.integrateDataSetQuery')}</Radio>
                              <Radio value="integrateWaitReply">{t('workflowDesigner.sendEForm.integrateWaitReply')}</Radio>
                              <Radio value="integrateEmailStart">{t('workflowDesigner.sendEForm.integrateEmailStart')}</Radio>
                              <Radio value="integrateManualStart">{t('workflowDesigner.sendEForm.integrateManualStart')}</Radio>
                              <Radio value="staticJson">Static JSON</Radio>
                            </Radio.Group>
                          </Form.Item>

                          {(odooMode === 'integrateEmailStart' || odooMode === 'integrateManualStart') && (
                            <Form.Item
                              label={t('workflowDesigner.sendEForm.integrateEmailStartSendToAi')}
                              tooltip={odooMode === 'integrateManualStart'
                                ? t('workflowDesigner.sendEForm.integrateManualStartSendToAiHelp')
                                : t('workflowDesigner.sendEForm.integrateEmailStartSendToAiHelp')}
                            >
                              <Radio.Group
                                value={selectedNode.data.integrateEmailStartSendToAi || 'attachment'}
                                onChange={(e) => handleNodeDataChange({ integrateEmailStartSendToAi: e.target.value })}
                              >
                                <Radio value="attachment">{t('workflowDesigner.sendEForm.integrateEmailStartSendToAiAttachment')}</Radio>
                                <Radio value="body">
                                  {odooMode === 'integrateManualStart'
                                    ? t('workflowDesigner.sendEForm.integrateManualStartSendToAiBody')
                                    : t('workflowDesigner.sendEForm.integrateEmailStartSendToAiBody')}
                                </Radio>
                                <Radio value="both">{t('workflowDesigner.sendEForm.integrateEmailStartSendToAiBoth')}</Radio>
                              </Radio.Group>
                            </Form.Item>
                          )}

                          {(odooMode === 'integrateWaitReply' || odooMode === 'integrateEmailStart' || odooMode === 'integrateManualStart') && (
                            <>
                              <Form.Item label={t('workflowDesigner.artifact.attachmentAiInputFormat')}>
                                <Select
                                  value={selectedNode.data.attachmentAiInputFormat || 'any'}
                                  onChange={(v) => handleNodeDataChange({ attachmentAiInputFormat: v })}
                                >
                                  <Select.Option value="any">{t('workflowDesigner.artifact.attachmentAiInputFormatAny')}</Select.Option>
                                  <Select.Option value="pdf">PDF</Select.Option>
                                  <Select.Option value="docx">DOCX</Select.Option>
                                  <Select.Option value="xlsx">XLSX</Select.Option>
                                  <Select.Option value="pptx">PPTX</Select.Option>
                                </Select>
                              </Form.Item>
                              <Form.Item label={t('workflowDesigner.artifact.attachmentBatchMode')}>
                                <Radio.Group
                                  value={selectedNode.data.attachmentBatchMode || 'all'}
                                  onChange={(e) => handleNodeDataChange({ attachmentBatchMode: e.target.value })}
                                >
                                  <Radio value="all">{t('workflowDesigner.artifact.attachmentBatchModeAll')}</Radio>
                                  <Radio value="first">{t('workflowDesigner.artifact.attachmentBatchModeFirst')}</Radio>
                                </Radio.Group>
                              </Form.Item>
                            </>
                          )}

                          {odooMode === 'integrateDataSetQuery' && (
                            <Form.Item label={t('workflowDesigner.sendEForm.selectDataSetQueryNode')}>
                              <Select
                                placeholder={t('workflowDesigner.sendEForm.selectDataSetQueryNodePlaceholder')}
                                value={selectedNode.data.integratedDataSetQueryNodeId || undefined}
                                onChange={(value) => handleNodeDataChange({ integratedDataSetQueryNodeId: value })}
                                allowClear
                              >
                                {nodes.filter(n => n.data?.type === 'dataSetQuery' && n.data?.operationType === 'SELECT' && n.id !== selectedNode.id).map(node => (
                                  <Select.Option key={node.id} value={node.id}>
                                    {node.data?.taskName || node.id}
                                  </Select.Option>
                                ))}
                              </Select>
                            </Form.Item>
                          )}

                          {odooMode === 'staticJson' && (
                            <Form.Item label="Static JSON">
                              <Input.TextArea
                                rows={8}
                                value={selectedNode.data.json || ''}
                                onChange={(e) => handleNodeDataChange({ json: e.target.value })}
                                placeholder='{"version":"1.0","operations":[{"action":"createSO","partner":{...},"lines":[...]}]}'
                              />
                            </Form.Item>
                          )}
                        </>
                      ),
                    },
                    {
                      key: 'mapping',
                      icon: <DatabaseOutlined />,
                      tooltip: t('workflowDesigner.odoo.tabMapping') || 'Field Mapping',
                      hidden: !odooIsMappingMode,
                      children: (
                        <>
                          <OdooOperationSchemaPanel operationType={opType} t={t} />

                          {odooIsFormMode && (
                            <Form.Item
                              label={t('workflowDesigner.odoo.selectUpstreamEForm') || '?? sendEForm ??'}
                              tooltip={t('workflowDesigner.odoo.selectUpstreamEFormTip') || '?????? eForm instance?????? mapping value ??'}
                              required
                            >
                              <Select
                                placeholder={t('workflowDesigner.odoo.selectUpstreamEFormPlaceholder') || '???? sendEForm?'}
                                value={selectedNode.data.sourceEFormNodeId || undefined}
                                onChange={(v) => handleNodeDataChange({ sourceEFormNodeId: v || '' })}
                                allowClear
                              >
                                {odooSendEFormNodes.map(n => (
                                  <Select.Option key={n.id} value={n.id}>
                                    {n.data?.taskName || n.data?.formName || n.id}
                                  </Select.Option>
                                ))}
                              </Select>
                              {!selectedNode.data.sourceEFormNodeId && odooSendEFormNodes.length === 0 && (
                                <Alert
                                  type="warning"
                                  showIcon
                                  style={{ marginTop: 8 }}
                                  message={t('workflowDesigner.odoo.noUpstreamEForm') || '????? sendEForm ?????????? formId'}
                                />
                              )}
                            </Form.Item>
                          )}

                          {odooIsDsMode && (
                            <Form.Item
                              label={t('workflowDesigner.sendEForm.selectDataSetQueryNode')}
                              required
                            >
                              <Select
                                placeholder={t('workflowDesigner.sendEForm.selectDataSetQueryNodePlaceholder')}
                                value={selectedNode.data.integratedDataSetQueryNodeId || undefined}
                                onChange={(v) => handleNodeDataChange({ integratedDataSetQueryNodeId: v || '' })}
                                allowClear
                              >
                                {odooDataSetNodes.map(node => (
                                  <Select.Option key={node.id} value={node.id}>
                                    {node.data?.taskName || node.id}
                                  </Select.Option>
                                ))}
                              </Select>
                            </Form.Item>
                          )}

                          <Alert
                            type="info"
                            showIcon
                            style={{ marginBottom: 12 }}
                            message={odooIsDsMode
                              ? (t('workflowDesigner.odoo.mappingHelpDataSet')
                                  || 'DataSet ???scope=master ???? row?scope=line ?? row ???? lines[]?mappedFields ??? fallback AI')
                              : (t('workflowDesigner.odoo.mappingHelpForm')
                                  || 'Form ????? sendEForm ?? / Process Variable / ?????? Odoo ???partner.id?partner.name?lines[0].product.code?lines[0].qty???mappedFields ??? fallback AI')}
                          />

                          {mappedFields.length === 0 && (
                            <Alert
                              type="warning"
                              showIcon
                              style={{ marginBottom: 12 }}
                              message={t('workflowDesigner.odoo.mappingEmptyHint')
                                || '?????? mapping??? AI ???????????????????? prompt?'}
                            />
                          )}

                          <Table
                            size="small"
                            pagination={false}
                            rowKey={(r) => r.id}
                            dataSource={mappedFields}
                            columns={[
                              {
                                title: t('workflowDesigner.odoo.mappingOdooField') || 'Odoo Field',
                                dataIndex: 'odooField',
                                width: odooIsDsMode ? '32%' : '36%',
                                render: (value, _row, idx) => (
                                  <OdooFieldAutoComplete
                                    providerKey={selectedNode.data.apiProviderKey}
                                    operationType={selectedNode.data.operationType}
                                    value={value || ''}
                                    onChange={(v) => patchMappedField(idx, { odooField: v })}
                                  />
                                )
                              },
                              ...(odooIsDsMode ? [{
                                title: t('workflowDesigner.odoo.scope') || 'Scope',
                                dataIndex: 'scope',
                                width: 100,
                                render: (value, _row, idx) => (
                                  <Select
                                    style={{ width: '100%' }}
                                    value={value || 'master'}
                                    onChange={(v) => patchMappedField(idx, { scope: v })}
                                  >
                                    <Select.Option value="master">{t('workflowDesigner.odoo.scopeMaster') || 'master'}</Select.Option>
                                    <Select.Option value="line">{t('workflowDesigner.odoo.scopeLine') || 'line'}</Select.Option>
                                  </Select>
                                )
                              }] : []),
                              {
                                title: t('workflowDesigner.odoo.mappingSourceType') || 'Source',
                                dataIndex: 'sourceType',
                                width: '18%',
                                render: (value, _row, idx) => {
                                  const current = value || (odooIsDsMode ? 'datasetColumn' : 'eFormField');
                                  const isLegacyExpr = (value || '').toLowerCase() === 'expr';
                                  const opts = [...odooSourceTypeOptions];
                                  if (isLegacyExpr) {
                                    opts.push({
                                      value: 'expr',
                                      label: `${t('workflowDesigner.odoo.sourceExpressionLegacy') || 'Expression (deprecated)'}`
                                    });
                                  }
                                  return (
                                    <Select
                                      style={{ width: '100%' }}
                                      value={current}
                                      onChange={(v) => patchMappedField(idx, { sourceType: v, sourceValue: '' })}
                                      options={opts}
                                    />
                                  );
                                }
                              },
                              {
                                title: t('workflowDesigner.odoo.mappingSourceValue') || 'Value',
                                dataIndex: 'sourceValue',
                                render: (value, row, idx) => (
                                  <OdooSourceValueSelect
                                    sourceType={row.sourceType}
                                    value={value}
                                    onChange={(v) => patchMappedField(idx, { sourceValue: v })}
                                    eFormFields={odooEFormFields}
                                    datasetColumns={odooDataSetColumns}
                                    processVariables={processVariables}
                                    t={t}
                                  />
                                )
                              },
                              {
                                title: '',
                                key: 'op',
                                width: 40,
                                render: (_v, _row, idx) => (
                                  <Button
                                    type="text"
                                    danger
                                    icon={<DeleteOutlined />}
                                    onClick={() => removeMappedField(idx)}
                                  />
                                )
                              }
                            ]}
                          />
                          <Button
                            type="dashed"
                            block
                            style={{ marginTop: 8 }}
                            icon={<PlusOutlined />}
                            onClick={addMappedField}
                          >
                            {t('workflowDesigner.odoo.mappingAdd') || 'Add field mapping'}
                          </Button>
                        </>
                      ),
                    },
                    {
                      key: 'ai',
                      icon: <RobotOutlined />,
                      tooltip: t('workflowDesigner.sectionAi'),
                      hidden: !odooIsAiMode,
                      children: (
                        <>
                          <Form.Item label={t('workflowDesigner.sendEForm.aiProvider')} required>
                            <SelectWithClearButton
                              clearText={t('workflowDesigner.clear')}
                              loading={loadingAiProviders}
                              placeholder={t('workflowDesigner.sendEForm.aiProviderPlaceholder')}
                              value={selectedNode.data.aiProviderKey || undefined}
                              onChange={(v) => handleNodeDataChange({ aiProviderKey: v })}
                              options={aiProviderOptions}
                            />
                          </Form.Item>
                          <AiStaffSelectField {...aiStaffSelectProps} fieldPath={['aiStaffId']} />
                          <OdooOperationSchemaPanel operationType={opType} t={t} />
                          <Form.Item
                            label={
                              <Space>
                                <span>{t('workflowDesigner.odoo.fillOdooAdditionalPrompt') || 'Fill Odoo Additional Prompt'}</span>
                                <OdooPromptFieldPicker
                                  operationType={opType}
                                  providerKey={selectedNode.data.apiProviderKey}
                                  onInsert={(text) => {
                                    const cur = selectedNode.data.fillOdooAdditionalPrompt || '';
                                    const sep = cur && !cur.endsWith(' ') && !cur.endsWith('\n') ? ' ' : '';
                                    handleNodeDataChange({ fillOdooAdditionalPrompt: cur + sep + text });
                                  }}
                                  t={t}
                                />
                              </Space>
                            }
                          >
                            <Input.TextArea
                              rows={3}
                              value={selectedNode.data.fillOdooAdditionalPrompt || ''}
                              onChange={(e) => handleNodeDataChange({ fillOdooAdditionalPrompt: e.target.value })}
                              placeholder={t('workflowDesigner.odoo.fillOdooAdditionalPromptPlaceholder') || '??? PDF ????????SKU ? 5 ? line items'}
                            />
                          </Form.Item>
                          {renderPromptVariablesDisplay('fillOdooAdditionalPrompt')}
                          <Form.Item
                            label={
                              <Space>
                                <span>{t('workflowDesigner.calendar.additionalPrompt') || 'Additional Prompt'}</span>
                                <OdooPromptFieldPicker
                                  operationType={opType}
                                  providerKey={selectedNode.data.apiProviderKey}
                                  onInsert={insertAtCursor}
                                  t={t}
                                />
                              </Space>
                            }
                          >
                            <Input.TextArea
                              ref={odooPromptRef}
                              rows={3}
                              value={selectedNode.data.additionalPrompt || ''}
                              onChange={(e) => handleNodeDataChange({ additionalPrompt: e.target.value })}
                            />
                          </Form.Item>
                          {renderPromptVariablesDisplay('additionalPrompt')}
                        </>
                      ),
                    },
                    {
                      key: 'knowledge',
                      icon: <ReadOutlined />,
                      tooltip: t('workflowDesigner.sectionKnowledgeBase'),
                      hidden: !odooIsAiMode,
                      children: (
                        <WorkflowKnowledgeBaseSettingsControl
                          nodeData={selectedNode.data}
                          onApply={(patch) => handleNodeDataChange(patch)}
                          dataSets={dataSets}
                          loadingDataSets={loadingDataSets}
                          knowledgeStudioDocs={knowledgeStudioDocs}
                          loadingKnowledgeStudioDocs={loadingKnowledgeStudioDocs}
                          broadcastGroups={broadcastGroups}
                          loadingBroadcastGroups={loadingBroadcastGroups}
                          processVariables={processVariables}
                          generateWhereClause={generateWhereClause}
                          t={t}
                          labels={{
                            dataSetLabelKey: 'workflowDesigner.sendEForm.knowledgeBaseDataSet',
                            queryLabelKey: 'workflowDesigner.sendEForm.knowledgeBaseQueryConditions',
                          }}
                        />
                      ),
                    },
                    {
                      key: 'result',
                      icon: <SettingOutlined />,
                      tooltip: t('workflowDesigner.odoo.tabResult') || 'Result & Behavior',
                      children: (
                        <>
                          <Form.Item
                            label={t('workflowDesigner.odoo.commandVariable') || 'Save commands JSON to variable'}
                            tooltip={t('workflowDesigner.odoo.commandVariableTip') || '????????? Odoo ? commands JSON ??'}
                          >
                            <SelectWithClearButton
                              clearText={t('workflowDesigner.clear')}
                              value={selectedNode.data.odooCommandVariable || undefined}
                              onChange={(v) => handleNodeDataChange({ odooCommandVariable: v || '' })}
                            >
                              {processVariables.map(pv => (
                                <Select.Option key={pv.id} value={pv.variableName}>{pv.variableName}</Select.Option>
                              ))}
                            </SelectWithClearButton>
                          </Form.Item>
                          <Form.Item
                            label={t('workflowDesigner.odoo.resultVariable') || 'Save Odoo result to variable'}
                            tooltip={t('workflowDesigner.odoo.resultVariableTip') || '?? OdooCommandExecutionReport???? doc id / state?'}
                          >
                            <SelectWithClearButton
                              clearText={t('workflowDesigner.clear')}
                              value={selectedNode.data.odooResultVariable || undefined}
                              onChange={(v) => handleNodeDataChange({ odooResultVariable: v || '' })}
                            >
                              {processVariables.map(pv => (
                                <Select.Option key={pv.id} value={pv.variableName}>{pv.variableName}</Select.Option>
                              ))}
                            </SelectWithClearButton>
                          </Form.Item>
                          <Form.Item label={t('workflowDesigner.calendar.dryRun') || 'Dry Run'}>
                            <Switch
                              checked={!!selectedNode.data.dryRun}
                              onChange={(v) => handleNodeDataChange({ dryRun: v })}
                            />
                          </Form.Item>
                          <Form.Item label={t('workflowDesigner.calendar.failOnValidationError') || 'Fail on validation error'}>
                            <Switch
                              checked={!!selectedNode.data.failOnValidationError}
                              onChange={(v) => handleNodeDataChange({ failOnValidationError: v })}
                            />
                          </Form.Item>
                        </>
                      ),
                    }
                  ]}
                />
              );
            })()}

            {/* ?????? */}
            {selectedNode.data.type === 'switch' && (
              <PropertySectionTabs
                resetKey={selectedNode.id}
                sections={[
                  {
                    key: 'branch',
                    icon: <BranchesOutlined />,
                    tooltip: t('workflowDesigner.sectionBranch'),
                    children: (
                      <>
                <Form.Item label={t('workflowDesigner.conditionGroups')}>
                  <div style={{ marginBottom: '8px' }}>
                    <Button 
                      type="dashed" 
                      onClick={() => {
                        const newGroup = {
                          id: `group${Date.now()}`,
                          relation: 'and',
                          conditions: [],
                          outputPath: '',
                          groupIndex: -1
                        };
                        setEditingConditionGroup(newGroup);
                        setConditionGroupModalVisible(true);
                      }}
                      style={{ width: '100%' }}
                    >
                      {t('workflowDesigner.addConditionGroup')}
                    </Button>
                  </div>
                  {(() => {
                    const currentNode = nodes.find(node => node.id === selectedNode?.id);
                    const currentConditionGroups = currentNode?.data?.conditionGroups || [];
                    return currentConditionGroups.map((group, groupIndex) => (
                      <Card 
                        key={group.id} 
                        size="small" 
                        style={{ 
                          marginBottom: '8px', 
                          border: '1px solid #d9d9d9',
                          cursor: 'pointer'
                        }}
                        onClick={() => {
                          setEditingConditionGroup({ ...group, groupIndex });
                          setConditionGroupModalVisible(true);
                        }}
                      >
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <div>
                            <div style={{ fontWeight: 'bold', fontSize: '14px', marginBottom: '4px' }}>
                              {t('workflowDesigner.conditionGroup')} {groupIndex + 1}
                            </div>
                            <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>
                              {t('workflowDesigner.conditions')}: {group.conditions?.length || 0}
                              {group.relation && ` ? ${group.relation.toUpperCase()}`}
                            </div>
                            {group.conditions && group.conditions.length > 0 && (
                              <div style={{ fontSize: '11px', color: '#999' }}>
                                {group.conditions.slice(0, 2).map(condition => 
                                  `${condition.variableName} ${condition.operator} ${condition.value}`
                                ).join(', ')}
                                {group.conditions.length > 2 && ` +${group.conditions.length - 2} more`}
                              </div>
                            )}
                            {group.outputPath && selectedNode && (
                              <div style={{ fontSize: '11px', color: '#1890ff', marginTop: '2px' }}>
                                ? {getAvailableOutputPaths(selectedNode.id, edges, nodes, t).find(p => p.id === group.outputPath)?.label || group.outputPath}
                              </div>
                            )}
                          </div>
                          <div style={{ display: 'flex', gap: '4px' }}>
                            <Button 
                              type="text" 
                              size="small"
                              icon={<EditOutlined />}
                              onClick={(e) => {
                                e.stopPropagation();
                                setEditingConditionGroup({ ...group, groupIndex });
                                setConditionGroupModalVisible(true);
                              }}
                            />
                            <Button 
                              type="text" 
                              danger 
                              size="small"
                              icon={<DeleteOutlined />}
                              onClick={(e) => {
                                e.stopPropagation();
                                const currentNode = nodes.find(node => node.id === selectedNode?.id);
                                const currentGroups = currentNode?.data?.conditionGroups || [];
                                const newGroups = currentGroups.filter((_, i) => i !== groupIndex);
                                handleNodeDataChange({ conditionGroups: newGroups });
                              }}
                            />
                          </div>
                        </div>
                      </Card>
                    ));
                  })()}
                </Form.Item>
                
                <Form.Item label={t('workflowDesigner.defaultPath')}>
                  <div style={{ 
                    padding: '8px 12px', 
                    border: '1px solid #d9d9d9', 
                    borderRadius: '6px',
                    backgroundColor: '#fafafa',
                    cursor: 'pointer'
                  }}
                  onClick={() => {
                    setDefaultPathModalVisible(true);
                  }}
                  >
                    {selectedNode?.data?.defaultPath ? (
                      <span style={{ color: '#1890ff' }}>
                        ? {selectedNode && getAvailableOutputPaths(selectedNode.id, edges, nodes, t).find(p => p.id === selectedNode.data.defaultPath)?.label || selectedNode?.data?.defaultPath}
                      </span>
                    ) : (
                      <span style={{ color: '#999' }}>
                        {t('workflowDesigner.clickToSelectDefaultPath')}
                      </span>
                    )}
                  </div>
                </Form.Item>
                
                      </>
                    ),
                  },
                  {
                    key: 'description',
                    icon: <InfoCircleOutlined />,
                    tooltip: t('workflowDesigner.sectionDescription'),
                    children: (
                      <Card size="small" title={t('workflowDesigner.functionDescription')} style={{ marginTop: 16 }}>
                        <p style={{ fontSize: '12px', margin: '4px 0' }}>
                          {t('workflowDesigner.switchDescription1')}
                        </p>
                        <p style={{ fontSize: '12px', margin: '4px 0' }}>
                          {t('workflowDesigner.switchDescription2')}
                        </p>
                        <p style={{ fontSize: '12px', margin: '4px 0', color: '#1890ff' }}>
                          {t('workflowDesigner.switchDescription3')}
                        </p>
                      </Card>
                    ),
                  },
                ]}
              />
            )}
          </Form>
        )}
        
        {/* Start ???? */}
        {selectedNode && selectedNode.data.type === 'start' && (
          <div style={{ color: '#888' }}>
            <Form
              form={form}
              key={selectedNode.id}
              layout="vertical"
              onValuesChange={handleFormValuesChange}
            >
              <Form.Item label={t('workflowDesigner.taskNameLabel')} name="taskName">
                <Input 
                  placeholder={t('workflowDesigner.taskNamePlaceholder')}
                  onBlur={(e) => {
                    const value = e.target.value;
                    if (value !== selectedNode.data.taskName) {
                      handleNodeDataChange({ taskName: value });
                    }
                  }}
                />
              </Form.Item>
              
              <PropertySectionTabs
                resetKey={selectedNode.id}
                sections={[
                  {
                    key: 'trigger',
                    icon: <ThunderboltOutlined />,
                    tooltip: t('workflowDesigner.sectionTrigger'),
                    children: (
                      <>
              <h4>{t('workflowDesigner.activationConfig')}</h4>
              <Form.Item label={t('workflowDesigner.activationType')} name="activationType">
                <Select
                  options={[
                    { value: 'manual', label: t('workflowDesigner.manualActivation') },
                    { value: 'webhook', label: t('workflowDesigner.metaWebhookCall') },
                    { value: 'scheduled', label: t('workflowDesigner.scheduledTableWatch') },
                    { value: 'email', label: t('workflowDesigner.emailMonitor') }
                  ]}
                />
              </Form.Item>
              
              {selectedNode.data.activationType === 'email' && (
                <>
                  <Form.Item label={t('workflowDesigner.emailProvider')} name="emailProviderKey">
                    <Select
                      allowClear
                      placeholder={t('workflowDesigner.emailProviderPlaceholder')}
                      loading={loadingEmailProviders}
                      options={emailProviders.map(p => ({ value: p.providerKey, label: p.displayName || p.name || p.providerKey }))}
                      notFoundContent={t('workflowDesigner.emailNoProviderConfigured')}
                    />
                  </Form.Item>
                  <Form.Item label={t('workflowDesigner.emailMonitorMailbox')} name="emailMonitorMailbox">
                    <Input placeholder={t('workflowDesigner.emailMonitorMailboxPlaceholder')} allowClear />
                  </Form.Item>
                  <Form.Item label={t('workflowDesigner.emailFilterSender')} name="emailFilterSender">
                    <Select
                      mode="tags"
                      placeholder={t('workflowDesigner.emailFilterSenderPlaceholder')}
                      tokenSeparators={[',', '?']}
                      style={{ width: '100%' }}
                      open={undefined}
                      maxTagCount="responsive"
                    />
                  </Form.Item>
                  <Form.Item label={t('workflowDesigner.emailFilterSubject')} name="emailFilterSubject">
                    <Select
                      mode="tags"
                      placeholder={t('workflowDesigner.emailFilterSubjectPlaceholder')}
                      tokenSeparators={[',', '?', '\n']}
                      style={{ width: '100%' }}
                      open={undefined}
                      maxTagCount="responsive"
                    />
                  </Form.Item>
                  <Form.Item label={t('workflowDesigner.emailFilterKeywordsRequired')} name="emailFilterKeywordsRequired">
                    <Select
                      mode="tags"
                      placeholder={t('workflowDesigner.emailFilterKeywordsRequiredPlaceholder')}
                      tokenSeparators={[',', '?', '\n']}
                      style={{ width: '100%' }}
                      open={undefined}
                      maxTagCount="responsive"
                    />
                  </Form.Item>
                  <Alert type="info" showIcon message={t('workflowDesigner.emailFilterKeywordsMatchHint')} style={{ marginBottom: 16 }} />
                  <Form.Item label={t('workflowDesigner.emailFilterSenderNot')} name="emailFilterSenderNot">
                    <Select
                      mode="tags"
                      placeholder={t('workflowDesigner.emailFilterSenderNotPlaceholder')}
                      tokenSeparators={[',', '?']}
                      style={{ width: '100%' }}
                      open={undefined}
                      maxTagCount="responsive"
                    />
                  </Form.Item>
                  <Form.Item label={t('workflowDesigner.emailFilterSubjectNot')} name="emailFilterSubjectNot">
                    <Select
                      mode="tags"
                      placeholder={t('workflowDesigner.emailFilterSubjectNotPlaceholder')}
                      tokenSeparators={[',', '?']}
                      style={{ width: '100%' }}
                      open={undefined}
                      maxTagCount="responsive"
                    />
                  </Form.Item>
                  <Form.Item label={t('workflowDesigner.emailFilterBodyKeywordsNot')} name="emailFilterBodyKeywordsNot">
                    <Select
                      mode="tags"
                      placeholder={t('workflowDesigner.emailFilterBodyKeywordsNotPlaceholder')}
                      tokenSeparators={[',', '?', '\n']}
                      style={{ width: '100%' }}
                      open={undefined}
                      maxTagCount="responsive"
                    />
                  </Form.Item>
                  <Form.Item label={t('workflowDesigner.emailFilterHasAttachment')} name="emailFilterHasAttachment" valuePropName="checked">
                    <Switch checkedChildren={t('workflowDesigner.yes')} unCheckedChildren={t('workflowDesigner.no')} />
                  </Form.Item>
                  <Form.Item label={t('workflowDesigner.emailFilterAttachmentExtensions')} name="emailFilterAttachmentExtensions">
                    <Select
                      mode="tags"
                      placeholder={t('workflowDesigner.emailFilterAttachmentExtensionsPlaceholder')}
                      tokenSeparators={[',', '?', '\n']}
                      style={{ width: '100%' }}
                      open={undefined}
                      maxTagCount="responsive"
                    />
                  </Form.Item>
                  <Form.Item label={t('workflowDesigner.emailFilterAttachmentFileName')} name="emailFilterAttachmentFileName">
                    <Select
                      mode="tags"
                      placeholder={t('workflowDesigner.emailFilterAttachmentFileNamePlaceholder')}
                      tokenSeparators={[',', '?', '\n']}
                      style={{ width: '100%' }}
                      open={undefined}
                      maxTagCount="responsive"
                    />
                  </Form.Item>
                  <Form.Item label={t('workflowDesigner.emailFilterAttachmentFileNameNot')} name="emailFilterAttachmentFileNameNot">
                    <Select
                      mode="tags"
                      placeholder={t('workflowDesigner.emailFilterAttachmentFileNameNotPlaceholder')}
                      tokenSeparators={[',', '?', '\n']}
                      style={{ width: '100%' }}
                      open={undefined}
                      maxTagCount="responsive"
                    />
                  </Form.Item>
                  <Card size="small" title={t('workflowDesigner.emailMonitorInfo')} style={{ marginTop: 16 }}>
                    <p style={{ fontSize: '12px', margin: '4px 0' }}>
                      {t('workflowDesigner.emailMonitorDescription1')}
                    </p>
                    <p style={{ fontSize: '12px', margin: '4px 0' }}>
                      {t('workflowDesigner.emailMonitorDescription2')}
                    </p>
                  </Card>
                </>
              )}
              
              {selectedNode.data.activationType === 'webhook' && (
                <>
                  <Form.Item label={t('workflowDesigner.whatsAppMenuName')} name="whatsAppMenuName">
                    <Input
                      placeholder={t('workflowDesigner.whatsAppMenuNamePlaceholder')}
                      allowClear
                    />
                  </Form.Item>

                  <Divider style={{ margin: '12px 0' }} />

                  <Form.Item
                    label={t('workflowDesigner.webhookAccess.modeLabel')}
                    name="webhookAccessMode"
                  >
                    <Radio.Group
                      onChange={(e) => handleNodeDataChange({ webhookAccessMode: e.target.value })}
                    >
                      <Radio value="public">{t('workflowDesigner.webhookAccess.modePublic')}</Radio>
                      <Radio value="restricted">{t('workflowDesigner.webhookAccess.modeRestricted')}</Radio>
                    </Radio.Group>
                  </Form.Item>

                  {selectedNode.data.webhookAccessMode === 'restricted' && (
                    <Form.Item label={t('workflowDesigner.webhookAccess.allowedRecipientsLabel')}>
                      <WebhookAccessControlField
                        value={{
                          contacts: selectedNode.data.webhookAllowedContacts || [],
                          groups: selectedNode.data.webhookAllowedGroups || [],
                          hashtags: selectedNode.data.webhookAllowedHashtags || [],
                        }}
                        onClick={() => setWebhookAccessModalVisible(true)}
                      />
                      <div style={{ marginTop: 8, color: '#888', fontSize: 12 }}>
                        {t('workflowDesigner.webhookAccess.allowedRecipientsHelp')}
                      </div>
                    </Form.Item>
                  )}

                  <Card size="small" title={t('workflowDesigner.webhookInfo')} style={{ marginTop: 16 }}>
                    <p style={{ fontSize: '12px', margin: '4px 0' }}>
                      {t('workflowDesigner.webhookDescription1')}
                    </p>
                    <p style={{ fontSize: '12px', margin: '4px 0' }}>
                      {t('workflowDesigner.webhookDescription2')}
                    </p>
                    <p style={{ fontSize: '12px', margin: '4px 0', color: '#1890ff' }}>
                      ?? {t('workflowDesigner.webhookDescription3')}
                    </p>
                    {selectedNode.data.webhookAccessMode === 'restricted' && (
                      <p style={{ fontSize: '12px', margin: '4px 0', color: '#fa8c16' }}>
                        ?? {t('workflowDesigner.webhookAccess.restrictedInfo')}
                      </p>
                    )}
                  </Card>
                </>
              )}
              
              {selectedNode.data.activationType === 'scheduled' && (
                <>
                  {(selectedNode.data.scheduledTable || selectedNode.data.scheduledQuery) && (
                    <Alert
                      type="warning"
                      showIcon
                      style={{ marginBottom: 12 }}
                      message={t('workflowDesigner.scheduledLegacySqlDeprecated')}
                    />
                  )}
                  <Form.Item label={t('workflowDesigner.scheduledDataSet')} name="scheduledDataSetId">
                    <Select
                      placeholder={t('workflowDesigner.dataSet.selectDataSetPlaceholder')}
                      loading={loadingDataSets}
                      allowClear
                      onChange={(value) => {
                        handleNodeDataChange({ scheduledDataSetId: value || '' });
                        if (value) {
                          loadDataSetColumns(value);
                        }
                      }}
                    >
                      {dataSets.map(ds => (
                        <Select.Option key={ds.id} value={ds.id}>
                          {ds.name} ({ds.dataSourceType})
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>

                  <Form.Item label={t('workflowDesigner.scheduledTriggerConditions')}>
                    <DataSetQueryConditionGroupsEditor
                      conditionGroups={selectedNode.data.scheduledQueryConditionGroups || []}
                      onConditionGroupsChange={(groups) => handleNodeDataChange({ scheduledQueryConditionGroups: groups })}
                      generateWhereClause={generateWhereClause}
                      t={t}
                      processVariables={processVariables}
                      dataSetColumns={dataSetColumns}
                      loadDataSetColumns={loadDataSetColumns}
                      dataSetId={selectedNode.data.scheduledDataSetId}
                    />
                  </Form.Item>

                  <Form.Item label={t('workflowDesigner.scheduledFieldMapping')}>
                    <div style={{ marginBottom: '8px' }}>
                      <Button
                        type="dashed"
                        onClick={() => {
                          const currentNode = nodes.find(node => node.id === selectedNode?.id);
                          const currentMappings = currentNode?.data?.scheduledMappedFields || [];
                          dataSetFieldMappingForm.setFieldsValue({ mappedFields: currentMappings });
                          setDataSetFieldMappingModalVisible(true);
                        }}
                        style={{ width: '100%' }}
                        disabled={!selectedNode.data.scheduledDataSetId}
                      >
                        {t('workflowDesigner.dataSet.setFieldMapping')}
                      </Button>
                    </div>
                    {(() => {
                      const currentNode = nodes.find(node => node.id === selectedNode?.id);
                      const mappedFields = currentNode?.data?.scheduledMappedFields || [];
                      if (mappedFields.length > 0) {
                        return (
                          <div style={{
                            border: '1px solid #d9d9d9',
                            borderRadius: '4px',
                            padding: '8px',
                            backgroundColor: '#fafafa'
                          }}>
                            <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>
                              {t('workflowDesigner.dataSet.fieldMappingSummary', { count: mappedFields.length })}:
                            </div>
                            {mappedFields.slice(0, 5).map((mapping, index) => (
                              <div key={index} style={{ fontSize: '11px', color: '#999', marginBottom: '2px' }}>
                                {mapping.fieldName} ? ${mapping.variableName}
                              </div>
                            ))}
                            {mappedFields.length > 5 && (
                              <div style={{ fontSize: '11px', color: '#999' }}>
                                +{mappedFields.length - 5} ?
                              </div>
                            )}
                          </div>
                        );
                      }
                      return null;
                    })()}
                  </Form.Item>

                  <Form.Item label={t('workflowDesigner.scheduledPostSuccessWriteBack')}>
                    <div style={{ marginBottom: '8px' }}>
                      <Button
                        type="dashed"
                        onClick={handleOpenScheduledPostSuccessOperationModal}
                        icon={<SettingOutlined />}
                        style={{ width: '100%' }}
                        disabled={!selectedNode.data.scheduledDataSetId}
                      >
                        {t('workflowDesigner.scheduledPostSuccessSetWriteBack')}
                      </Button>
                    </div>
                    {scheduledPostSuccessOperationFields.length > 0 && (
                      <div style={{
                        border: '1px solid #d9d9d9',
                        borderRadius: '4px',
                        padding: '8px',
                        backgroundColor: '#f9f9f9',
                        fontSize: '12px',
                        color: '#666'
                      }}>
                        {t('workflowDesigner.scheduledPostSuccessWriteBackSummary', { count: scheduledPostSuccessOperationFields.length })}
                      </div>
                    )}
                  </Form.Item>

                  <Form.Item label={t('workflowDesigner.scheduledInterval')} name="scheduledInterval">
                    <Input
                      type="number"
                      placeholder="300"
                      addonAfter={t('workflowDesigner.seconds')}
                    />
                  </Form.Item>
                  <Card size="small" title={t('workflowDesigner.scheduledInfo')} style={{ marginTop: 16 }}>
                    <p style={{ fontSize: '12px', margin: '4px 0' }}>
                      {t('workflowDesigner.scheduledDescription1')}
                    </p>
                    <p style={{ fontSize: '12px', margin: '4px 0' }}>
                      {t('workflowDesigner.scheduledDescription2')}
                    </p>
                    <p style={{ fontSize: '12px', margin: '4px 0' }}>
                      {t('workflowDesigner.scheduledDescription3')}
                    </p>
                    <p style={{ fontSize: '12px', margin: '4px 0' }}>
                      {t('workflowDesigner.scheduledDescription4')}
                    </p>
                    <p style={{ fontSize: '12px', margin: '4px 0', color: '#1890ff' }}>
                      {t('workflowDesigner.scheduledDescription5')}
                    </p>
                  </Card>
                </>
              )}
              
                      </>
                    ),
                  },
                  {
                    key: 'overdue',
                    icon: <ClockCircleOutlined />,
                    tooltip: t('workflowDesigner.sectionOverdue'),
                    children: (
                      <>
              {/* Overdue Settings - ?????? */}
              <h4 style={{ marginTop: 24 }}>{t('workflowDesigner.overdueConfig')}</h4>
              <Card size="small" title={t('workflowDesigner.overdueSettings')} style={{ marginBottom: 16 }}>
                {/* Enable Overdue Monitoring */}
                <Form.Item label={t('workflowDesigner.overdue.enabled')} name={['overdueConfig', 'enabled']}>
                  <Select
                    options={[
                      { value: true, label: t('workflowDesigner.yes') },
                      { value: false, label: t('workflowDesigner.no') }
                    ]}
                  />
                </Form.Item>
                
                {selectedNode.data.overdueConfig?.enabled && (
                  <>
                    {/* Overdue Duration - ?/?/? */}
                    <Form.Item label={t('workflowDesigner.overdue.duration')}>
                      <div style={{
                        display: 'grid',
                        gridTemplateColumns: isFullscreen ? '1fr 1fr 1fr' : '1fr',
                        gap: isFullscreen ? '12px' : '8px'
                      }}>
                        <Input 
                          type="number" 
                          min="0" 
                          placeholder="7"
                          value={selectedNode.data.overdueConfig?.days || 0}
                          onChange={(e) => {
                            const newConfig = {
                              ...(selectedNode.data.overdueConfig || {}),
                              days: parseInt(e.target.value) || 0
                            };
                            handleNodeDataChange({ overdueConfig: newConfig });
                          }}
                          addonAfter={t('workflowDesigner.days')}
                        />
                        <Input 
                          type="number" 
                          min="0" 
                          max="23"
                          placeholder="8"
                          value={selectedNode.data.overdueConfig?.hours || 0}
                          onChange={(e) => {
                            const newConfig = {
                              ...(selectedNode.data.overdueConfig || {}),
                              hours: parseInt(e.target.value) || 0
                            };
                            handleNodeDataChange({ overdueConfig: newConfig });
                          }}
                          addonAfter={t('workflowDesigner.hours')}
                        />
                        <Input 
                          type="number" 
                          min="0" 
                          max="59"
                          placeholder="0"
                          value={selectedNode.data.overdueConfig?.minutes || 0}
                          onChange={(e) => {
                            const newConfig = {
                              ...(selectedNode.data.overdueConfig || {}),
                              minutes: parseInt(e.target.value) || 0
                            };
                            handleNodeDataChange({ overdueConfig: newConfig });
                          }}
                          addonAfter={t('workflowDesigner.minutes')}
                        />
                      </div>
                      <div style={{ marginTop: 4, fontSize: 12, color: '#999' }}>
                        ?? {t('workflowDesigner.overdue.durationHelp')}
                      </div>
                    </Form.Item>
                    
                    {/* Escalation ???? */}
                    <Form.Item label={t('workflowDesigner.overdue.escalation')}>
                      <TimeValidatorConfigSection
                        type="overdueEscalation"
                        selectedNode={selectedNode}
                        handleNodeDataChange={handleNodeDataChange}
                        form={form}
                        processVariables={processVariables}
                        workflowDefinitionId={workflowId}
                        onOpenTemplateModal={() => {
                          setTemplateModalSource('overdue');
                          setIsTemplateModalVisible(true);
                        }}
                        onOpenRecipientModal={() => {
                          setTemplateModalSource('overdue');
                          setTimeValidatorRecipientModalVisible(true);
                        }}
                        t={t}
                        config={selectedNode?.data?.overdueConfig?.escalationConfig}
                        title={t('workflowDesigner.overdue.configureEscalation')}
                        recipientsLabel={t('workflowDesigner.timeValidator.overdueEscalationRecipients')}
                        recipientsDescription={t('workflowDesigner.timeValidator.overdueEscalationRecipientsDescription')}
                        messageLabel={t('workflowDesigner.timeValidator.overdueEscalationMessage')}
                        messageDescription={t('workflowDesigner.timeValidator.overdueEscalationMessageDescription')}
                        messagePlaceholder={t('workflowDesigner.timeValidator.overdueEscalationMessagePlaceholder')}
                        messageTip={t('workflowDesigner.timeValidator.overdueEscalationMessageTip')}
                        expanded={overdueEscalationExpanded}
                        onToggleExpanded={setOverdueEscalationExpanded}
                        metaTemplates={metaTemplates}
                      />
                      
                      {/* ???????? */}
                      {selectedNode.data.overdueConfig?.escalationConfig && (
                        <div style={{ marginTop: 8, padding: 8, backgroundColor: '#fff7e6', borderRadius: 4, border: '1px solid #ffd666' }}>
                          <div style={{ fontSize: 12, color: '#d48806' }}>
                            ?? Recipients: {selectedNode.data.overdueConfig.escalationConfig.recipients || 'Not set'}
                          </div>
                          <div style={{ fontSize: 12, color: '#d48806', marginTop: 4 }}>
                            {selectedNode.data.overdueConfig.escalationConfig.useTemplate 
                              ? `?? Template: ${selectedNode.data.overdueConfig.escalationConfig.templateName}`
                              : `?? Message: ${selectedNode.data.overdueConfig.escalationConfig.message?.substring(0, isFullscreen ? 100 : 50)}...`
                            }
                          </div>
                        </div>
                      )}
                    </Form.Item>
                    
                    {/* Overdue ?? */}
                    <div style={{ 
                      padding: '8px 12px', 
                      backgroundColor: '#f0f8ff', 
                      border: '1px solid #1890ff',
                      borderRadius: '6px',
                      fontSize: '12px',
                      color: '#666',
                      marginTop: 8
                    }}>
                      <div style={{ fontWeight: 'bold', marginBottom: 4 }}>
                        ? {t('workflowDesigner.overdue.howItWorks')}
                      </div>
                      <ul style={{ margin: '4px 0', paddingLeft: '20px' }}>
                        <li>{t('workflowDesigner.overdue.description1')}</li>
                        <li>{t('workflowDesigner.overdue.description2')}</li>
                        <li>{t('workflowDesigner.overdue.description3')}</li>
                      </ul>
                    </div>
                  </>
                )}
              </Card>
                      </>
                    ),
                  },
                ]}
              />
            </Form>
          </div>
        )}
        </div>

        {/* ???????? */}
        <RecipientModal
          visible={isRecipientModalVisible}
          onCancel={() => setIsRecipientModalVisible(false)}
          onSelect={(value, detailedValue) => {
            console.log('?? NodePropertyDrawer - ?????:', value);
            console.log('?? NodePropertyDrawer - ?????:', detailedValue);
            // ?????????????
            if (selectedNode.data.type === 'sendWhatsApp' || selectedNode.data.type === 'sendWhatsAppTemplate' || selectedNode.data.type === 'sendEForm' || selectedNode.data.type === 'sendWhatsAppShoppingCart' || selectedNode.data.type === 'sendInstitutionOrderingCart' || selectedNode.data.type === 'generateHtmlReport' || selectedNode.data.type === 'generateDocument') {
              // ?????????? to ??
              handleNodeDataChange({ to: value });
              // ??????? recipientDetails ??
              if (detailedValue) {
                handleNodeDataChange({ recipientDetails: detailedValue });
              }
            } else if (selectedNode.data.type === 'waitReply' || selectedNode.data.type === 'waitForQRCode' || selectedNode.data.type === 'waitForLocation' || selectedNode.data.type === 'chatOrderingCart' || selectedNode.data.type === 'chatBot') {
              // ?????????? specifiedUsers ??
              handleNodeDataChange({ specifiedUsers: value });
              // ??????? recipientDetails ??
              if (detailedValue) {
                handleNodeDataChange({ recipientDetails: detailedValue });
              }
            }
          }}
          value={
            selectedNode.data.type === 'sendWhatsApp' || selectedNode.data.type === 'sendWhatsAppTemplate' || selectedNode.data.type === 'sendEForm' || selectedNode.data.type === 'sendWhatsAppShoppingCart' || selectedNode.data.type === 'sendInstitutionOrderingCart' || selectedNode.data.type === 'generateHtmlReport' || selectedNode.data.type === 'generateDocument'
              ? selectedNode.data.to 
              : (selectedNode.data.type === 'waitReply' || selectedNode.data.type === 'waitForQRCode' || selectedNode.data.type === 'waitForLocation' || selectedNode.data.type === 'chatOrderingCart')
              ? selectedNode.data.specifiedUsers
              : ''
          }
          recipientDetails={selectedNode.data.recipientDetails}
          allowMultiple={true}
          placeholder={t('workflowDesigner.selectRecipients')}
          workflowDefinitionId={workflowId}
        />

        {/* Webhook ??????????? */}
        <WebhookAccessControlModal
          visible={webhookAccessModalVisible}
          onCancel={() => setWebhookAccessModalVisible(false)}
          value={{
            contacts: selectedNode?.data?.webhookAllowedContacts || [],
            groups: selectedNode?.data?.webhookAllowedGroups || [],
            hashtags: selectedNode?.data?.webhookAllowedHashtags || [],
          }}
          onConfirm={(payload) => {
            handleNodeDataChange({
              webhookAllowedContacts: payload.contacts || [],
              webhookAllowedGroups: payload.groups || [],
              webhookAllowedHashtags: payload.hashtags || [],
            });
            setWebhookAccessModalVisible(false);
          }}
        />

        {/* DataSet ????????? */}
        <DataSetFieldMappingModal
          visible={dataSetFieldMappingModalVisible}
          onCancel={() => {
            setDataSetFieldMappingModalVisible(false);
            dataSetFieldMappingForm.resetFields();
          }}
          editingMappings={(() => {
            const currentNode = nodes.find(node => node.id === selectedNode?.id);
            if (currentNode?.data?.type === 'start' && currentNode?.data?.activationType === 'scheduled') {
              return currentNode?.data?.scheduledMappedFields || [];
            }
            return currentNode?.data?.mappedFields || [];
          })()}
          mappingForm={dataSetFieldMappingForm}
          dataSetColumns={dataSetColumns}
          processVariables={processVariables}
          onSave={handleSaveDataSetFieldMapping}
          t={t}
        />

        {/* ????????? */}
        <Modal
          title={operationDataModalMode === 'scheduledStart'
            ? t('workflowDesigner.scheduledPostSuccessSetWriteBack')
            : t('workflowDesigner.dataSet.setOperationData')}
          open={operationDataModalVisible}
          onCancel={handleCancelOperationData}
          width={800}
          footer={null}
          destroyOnClose
        >
          <Form
            layout="vertical"
            onFinish={handleSaveOperationData}
          >
            <Form.Item label={t('workflowDesigner.dataSet.operationData')}>
              <div style={{ maxHeight: '400px', overflowY: 'auto', border: '1px solid #d9d9d9', borderRadius: '6px', padding: '8px' }}>
                {editingOperationData.map((field, index) => {
                  const isJsonPv = getSelectedPvType(field.value) === 'json';
                  const isDynamic = field.targetColumnMode === 'dynamic';
                  const isDynamicJsonPv = isDynamic && getSelectedPvType(field.targetColumnRef) === 'json';
                  return (
                    <div key={index} style={{ 
                      marginBottom: '12px',
                      padding: '12px',
                      backgroundColor: '#f5f5f5',
                      borderRadius: '4px',
                      border: isDynamic ? '1px solid #722ed1' : (isJsonPv ? '1px solid #1890ff' : '1px solid #d9d9d9')
                    }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
                        <Radio.Group
                          size="small"
                          value={field.targetColumnMode || 'fixed'}
                          onChange={(e) => handleUpdateOperationDataField(index, 'targetColumnMode', e.target.value)}
                        >
                          <Radio value="fixed">{t('workflowDesigner.dataSet.fixedColumn')}</Radio>
                          <Radio value="dynamic">{t('workflowDesigner.dataSet.dynamicColumnName')}</Radio>
                        </Radio.Group>
                        <Button 
                          type="text" 
                          danger 
                          size="small"
                          icon={<MinusCircleOutlined />}
                          onClick={() => handleRemoveOperationDataField(index)}
                        />
                      </div>
                      <div style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: '8px', 
                        marginBottom: (isJsonPv || isDynamicJsonPv) ? '8px' : '0'
                      }}>
                        {isDynamic ? (
                          <Select
                            placeholder={t('workflowDesigner.dataSet.selectDynamicColumnSource')}
                            value={field.targetColumnRef || undefined}
                            onChange={(value) => handleUpdateOperationDataField(index, 'targetColumnRef', value)}
                            style={{ flex: 1 }}
                            showSearch
                            loading={loadingEformFields}
                            filterOption={(input, option) => {
                              const label = option?.label ?? option?.children;
                              return String(label || '').toLowerCase().includes(input.toLowerCase());
                            }}
                            optionLabelProp="label"
                          >
                            <Select.OptGroup label={t('workflowDesigner.dataSet.processVariables')}>
                              {processVariables && processVariables.length > 0 ? processVariables.map(pv => (
                                <Select.Option key={`dyn-pv-${pv.id || pv.variableName}`} value={`\${${pv.variableName || pv.name}}`} label={`${pv.variableName || pv.name} (${pv.dataType || 'Unknown'})`}>
                                  {pv.variableName || pv.name} ({pv.dataType || 'Unknown'})
                                </Select.Option>
                              )) : (
                                <Select.Option value="" disabled>{t('workflowDesigner.dataSet.noProcessVariables')}</Select.Option>
                              )}
                            </Select.OptGroup>
                            {nodes?.filter(n => n.data?.type === 'sendEForm' && n.data?.formId && eformFieldsMap[n.data.formId]?.length).map(node => (
                              <Select.OptGroup key={`dyn-${node.id}`} label={`${t('workflowDesigner.dataSet.eFormFields')}: ${node.data.formName || node.data.taskName || node.id}`}>
                                {eformFieldsMap[node.data.formId]?.map(f => (
                                  <Select.Option 
                                    key={`dyn-eform-${node.id}-${f.name}`} 
                                    value={`eform:${node.id}:${f.name}`} 
                                    label={`[${node.data.formName || node.id}] ${f.label || f.name}`}
                                  >
                                    {f.label || f.name} ({f.name})
                                  </Select.Option>
                                ))}
                              </Select.OptGroup>
                            ))}
                          </Select>
                        ) : (
                          <Select
                            placeholder={t('workflowDesigner.dataSet.selectDataSetField')}
                            value={field.name || undefined}
                            onChange={(value) => handleUpdateOperationDataField(index, 'name', value)}
                            style={{ flex: 1 }}
                            showSearch
                            filterOption={(input, option) =>
                              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                            }
                            options={dataSetColumns.map(col => ({
                              value: col.columnName,
                              label: `${col.displayName || col.columnName} (${col.dataType})`
                            }))}
                          />
                        )}
                        <span style={{ color: '#666', fontSize: '14px' }}>?</span>
                        <Select
                          placeholder={t('workflowDesigner.dataSet.selectValueSource')}
                          value={field.value || undefined}
                          onChange={(value) => handleUpdateOperationDataField(index, 'value', value)}
                          style={{ flex: 1 }}
                          showSearch
                          loading={loadingEformFields}
                          filterOption={(input, option) => {
                            const label = option?.label ?? option?.children;
                            return String(label || '').toLowerCase().includes(input.toLowerCase());
                          }}
                          optionLabelProp="label"
                        >
                          <Select.OptGroup label={t('workflowDesigner.dataSet.processVariables')}>
                            {processVariables && processVariables.length > 0 ? processVariables.map(pv => (
                              <Select.Option key={`pv-${pv.id || pv.variableName}`} value={`\${${pv.variableName || pv.name}}`} label={`${pv.variableName || pv.name} (${pv.dataType || 'Unknown'})`}>
                                {pv.variableName || pv.name} ({pv.dataType || 'Unknown'})
                              </Select.Option>
                            )) : (
                              <Select.Option value="" disabled>{t('workflowDesigner.dataSet.noProcessVariables')}</Select.Option>
                            )}
                          </Select.OptGroup>
                          {nodes?.filter(n => n.data?.type === 'sendEForm' && n.data?.formId && eformFieldsMap[n.data.formId]?.length).map(node => (
                            <Select.OptGroup key={node.id} label={`${t('workflowDesigner.dataSet.eFormFields')}: ${node.data.formName || node.data.taskName || node.id}`}>
                              {eformFieldsMap[node.data.formId]?.map(f => (
                                <Select.Option 
                                  key={`eform-${node.id}-${f.name}`} 
                                  value={`eform:${node.id}:${f.name}`} 
                                  label={`[${node.data.formName || node.id}] ${f.label || f.name}`}
                                >
                                  {f.label || f.name} ({f.name})
                                </Select.Option>
                              ))}
                            </Select.OptGroup>
                          ))}
                        </Select>
                      </div>
                      {isDynamicJsonPv && (
                        <div style={{ 
                          marginTop: '8px', 
                          padding: '8px', 
                          backgroundColor: '#f9f0ff', 
                          borderRadius: '4px',
                          border: '1px dashed #d3adf7'
                        }}>
                          <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>
                            {t('workflowDesigner.dataSet.dynamicColumnJsonKey')}
                          </div>
                          <Input
                            placeholder={t('workflowDesigner.dataSet.dynamicColumnJsonKeyPlaceholder')}
                            value={field.targetColumnJsonKey || ''}
                            onChange={(e) => handleUpdateOperationDataField(index, 'targetColumnJsonKey', e.target.value)}
                            style={{ width: '100%' }}
                            prefix={<span style={{ color: '#999' }}>JSON Key:</span>}
                          />
                          <div style={{ fontSize: '11px', color: '#999', marginTop: '4px' }}>
                            {t('workflowDesigner.dataSet.dynamicColumnJsonKeyDescription')}
                          </div>
                        </div>
                      )}
                      {isJsonPv && (
                        <div style={{ 
                          marginTop: '8px', 
                          padding: '8px', 
                          backgroundColor: '#e6f7ff', 
                          borderRadius: '4px',
                          border: '1px dashed #91d5ff'
                        }}>
                          <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>
                            {t('workflowDesigner.dataSet.jsonPvMapping')}
                          </div>
                          <Input
                            placeholder={t('workflowDesigner.dataSet.jsonKeyPlaceholder')}
                            value={field.jsonKey || ''}
                            onChange={(e) => handleUpdateOperationDataField(index, 'jsonKey', e.target.value)}
                            style={{ width: '100%' }}
                            prefix={<span style={{ color: '#999' }}>JSON Key:</span>}
                          />
                          <div style={{ fontSize: '11px', color: '#999', marginTop: '4px' }}>
                            {t('workflowDesigner.dataSet.jsonKeyDescription')}
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
                
                {editingOperationData.length === 0 && (
                  <div style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
                    {t('workflowDesigner.dataSet.noOperationData')}
                  </div>
                )}
                
                <Button 
                  type="dashed" 
                  icon={<PlusOutlined />}
                  onClick={handleAddOperationDataField}
                  style={{ width: '100%' }}
                >
                  {t('workflowDesigner.dataSet.addFieldMapping')}
                </Button>
              </div>
            </Form.Item>
            
            <div style={{ fontSize: '12px', color: '#666', marginBottom: '16px' }}>
              {t('workflowDesigner.dataSet.operationDataDescription')}
            </div>
            
            <div style={{ textAlign: 'right' }}>
              <Space>
                <Button onClick={handleCancelOperationData}>
                  {t('common.cancel')}
                </Button>
                <Button type="primary" htmlType="submit">
                  {t('common.save')}
                </Button>
              </Space>
            </div>
          </Form>
        </Modal>

        {/* ?????????? */}
        <Modal
          title={
            <div>
              <div style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '8px' }}>
                {t('workflowDesigner.dataSet.queryResultPreview')}
              </div>
              {/* PV ?????? - ?????????? */}
              {(() => {
                const currentNode = nodes.find(node => node.id === selectedNode?.id);
                const conditionGroups = currentNode?.data?.queryConditionGroups || [];
                const usedVariables = extractProcessVariablesFromConditions(conditionGroups);
                
                if (usedVariables.length > 0) {
                  return (
                    <div style={{ 
                      backgroundColor: '#f8f9fa', 
                      padding: '12px', 
                      borderRadius: '6px', 
                      border: '1px solid #e9ecef',
                      marginTop: '8px'
                    }}>
                      <div style={{ fontSize: '14px', color: '#6c757d', marginBottom: '12px' }}>
                        {t('workflowDesigner.dataSet.pvSimulationDataDescription')}
                      </div>
                      
                      {usedVariables.map(variableName => (
                        <div key={variableName} style={{ marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <span style={{ width: '120px', fontSize: '14px', fontWeight: '500', color: '#495057' }}>
                            ${variableName}:
                          </span>
                          <Input 
                            placeholder={`?? ${variableName} ????`}
                            value={pvSimulationData[variableName] || ''}
                            onChange={(e) => {
                              setPvSimulationData(prev => ({
                                ...prev,
                                [variableName]: e.target.value
                              }));
                            }}
                            style={{ flex: 1 }}
                          />
                        </div>
                      ))}
                      
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '8px' }}>
                        <div style={{ fontSize: '12px', color: '#6c757d' }}>
                          {t('workflowDesigner.dataSet.pvSimulationDataHelp')}
                        </div>
                        <Button 
                          type="primary" 
                          size="small"
                          onClick={async () => {
                            try {
                              setTestingOperation(true);
                              const currentNode = nodes.find(node => node.id === selectedNode?.id);
                              
                              // ?????????????????
                              const conditionGroups = currentNode?.data?.queryConditionGroups || [];
                              const processedConditionGroups = conditionGroups.map(group => ({
                                ...group,
                                conditions: group.conditions.map(condition => ({
                                  ...condition,
                                  value: condition.value.replace(/\$\{([^}]+)\}/g, (match, variableName) => {
                                    return pvSimulationData[variableName] || match;
                                  })
                                }))
                              }));
                              
                              const whereClause = generateWhereClause(processedConditionGroups);
                              
                              // ?? API ??????
                              const response = await fetch('/api/datasets/preview', {
                                method: 'POST',
                                headers: {
                                  'Authorization': `Bearer ${localStorage.getItem('token')}`,
                                  'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({
                                  dataSetId: currentNode?.data?.dataSetId || selectedNode?.data?.dataSetId,
                                  whereClause,
                                  limit: 10,
                                  processVariableValues: pvSimulationData
                                })
                              });

                              if (!response.ok) {
                                const errorText = await response.text();
                                console.error('API ????:', errorText);
                                throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
                              }

                              const result = await response.json();
                              console.log('API ????:', result);

                              if (result.success && result.data) {
                                setQueryPreviewData(result.data);
                                const total = result.totalCount ?? result.data.length;
                                message.success(`??????? ${total} ????`);
                              } else {
                                throw new Error(result.message || '????????');
                              }
                            } catch (previewError) {
                              console.error('????????:', previewError);
                              message.error('????????: ' + previewError.message);
                            } finally {
                              setTestingOperation(false);
                            }
                          }}
                          loading={testingOperation}
                        >
                          {t('workflowDesigner.dataSet.testQuery')}
                        </Button>
                      </div>
                    </div>
                  );
                }

                return null;
              })()}
            </div>
          }
          open={queryPreviewModalVisible}
          onCancel={() => {
            setQueryPreviewModalVisible(false);
            setQueryPreviewData([]);
            setPvSimulationData({});
          }}
          footer={null}
          width={isFullscreen ? '85vw' : 960}
          style={{ top: 24 }}
          destroyOnClose
        >
          {queryPreviewData.length > 0 ? (
            <Table
              dataSource={queryPreviewData}
              columns={Object.keys(queryPreviewData[0]).map(key => ({
                title: key,
                dataIndex: key,
                key: key,
                width: 120,
                render: (text) => {
                  if (typeof text === 'number') {
                    return text.toLocaleString();
                  }
                  return text;
                }
              }))}
              pagination={false}
              size="small"
              scroll={{ x: 'max-content' }}
              style={{ fontSize: '12px' }}
              rowKey={(record, index) => `preview-row-${index}`}
            />
          ) : (
            <div style={{ textAlign: 'center', padding: '40px', color: '#999' }}>
              {t('workflowDesigner.dataSet.noQueryResultData')}
            </div>
          )}
          
          <div style={{ fontSize: '12px', color: '#666', marginTop: '12px', textAlign: 'right' }}>
            {t('workflowDesigner.dataSet.totalRecords', { count: queryPreviewData.length })}
          </div>
        </Modal>

        {/* Institution Ordering Cart??? Flow Template ???? */}
        <Modal
          title={t('workflowDesigner.institutionOrderingCartPreviewTitle')}
          open={flowTemplatePreviewModalVisible}
          onCancel={() => { setFlowTemplatePreviewModalVisible(false); setFlowTemplatePreview(null); }}
          footer={[
            <Button key="close" onClick={() => { setFlowTemplatePreviewModalVisible(false); setFlowTemplatePreview(null); }}>
              {t('workflowDesigner.close')}
            </Button>,
            <Button
              key="meta"
              type="primary"
              onClick={() => {
                window.open('/whatsapp-templates', '_blank');
              }}
            >
              {t('workflowDesigner.institutionOrderingCartOpenMetaPanel')}
            </Button>
          ]}
          width={520}
          destroyOnClose
        >
          {flowTemplatePreview && (
            <>
              <Card size="small" title={t('workflowDesigner.institutionOrderingCartTemplateInfo')} style={{ marginBottom: 16 }}>
                <p><strong>{t('workflowDesigner.templateName')}</strong> {flowTemplatePreview.flowTemplateName}</p>
                <p><strong>{t('workflowDesigner.institutionOrderingCartStatus')}</strong>
                  <Tag color={flowTemplatePreview.status === 'APPROVED' ? 'green' : flowTemplatePreview.status === 'REJECTED' ? 'red' : 'orange'}>
                    {flowTemplatePreview.status || 'PENDING'}
                  </Tag>
                </p>
                <p><strong>{t('workflowDesigner.institutionOrderingCartCategory')}</strong> <Tag>{flowTemplatePreview.category || 'UTILITY'}</Tag></p>
                <p><strong>{t('workflowDesigner.institutionOrderingCartLanguage')}</strong> <Tag>{flowTemplatePreview.language || 'zh_TW'}</Tag></p>
              </Card>
              <Card size="small" title={t('workflowDesigner.institutionOrderingCartMessagePreview')} style={{ marginBottom: 0 }}>
                <div style={{
                  background: 'linear-gradient(to bottom, #e5ddd5 0%, #e5ddd5 50%, #d4edda 50%, #d4edda 100%)',
                  padding: '24px 16px',
                  borderRadius: 8,
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'flex-start'
                }}>
                  <div style={{
                    maxWidth: '85%',
                    background: '#ffffff',
                    borderRadius: '8px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    overflow: 'hidden',
                    padding: '12px 14px'
                  }}>
                    <div style={{ fontSize: '13px', color: '#667781', marginBottom: 8 }}>{t('workflowDesigner.institutionOrderingCartFlowMessageBody')}</div>
                    <div style={{
                      marginTop: 8,
                      padding: '10px 14px',
                      background: '#0084ff',
                      color: '#fff',
                      borderRadius: 8,
                      textAlign: 'center',
                      fontSize: '14px',
                      cursor: 'default'
                    }}>
                      {t('workflowDesigner.institutionOrderingCartFlowButton')}
                    </div>
                  </div>
                </div>
              </Card>
            </>
          )}
        </Modal>

        {/* Time Validator Recipient Modal */}
        <RecipientModal
          visible={timeValidatorRecipientModalVisible}
          onCancel={() => setTimeValidatorRecipientModalVisible(false)}
          onSelect={(recipients, recipientDetails) => {
            // ????????????????
            if (templateModalSource === 'retryMessage') {
              const currentConfig = selectedNode?.data?.validation?.retryMessageConfig || {};
              const newValidation = {
                ...(selectedNode.data.validation || {}),
                retryMessageConfig: {
                  ...currentConfig,
                  recipients,
                  recipientDetails
                }
              };
              handleNodeDataChange({ validation: newValidation });
            } else if (templateModalSource === 'escalation') {
              const currentConfig = selectedNode?.data?.validation?.escalationConfig || {};
              const newValidation = {
                ...(selectedNode.data.validation || {}),
                escalationConfig: {
                  ...currentConfig,
                  recipients,
                  recipientDetails
                }
              };
              handleNodeDataChange({ validation: newValidation });
            } else if (templateModalSource === 'overdue') {
              const currentConfig = selectedNode?.data?.overdueConfig?.escalationConfig || {};
              const newOverdueConfig = {
                ...(selectedNode.data.overdueConfig || {}),
                escalationConfig: {
                  ...currentConfig,
                  recipients,
                  recipientDetails
                }
              };
              handleNodeDataChange({ overdueConfig: newOverdueConfig });
            }
            setTimeValidatorRecipientModalVisible(false);
          }}
          value={
            templateModalSource === 'retryMessage'
              ? (selectedNode?.data?.validation?.retryMessageConfig?.recipients || '')
              : templateModalSource === 'overdue'
              ? (selectedNode?.data?.overdueConfig?.escalationConfig?.recipients || '')
              : (selectedNode?.data?.validation?.escalationConfig?.recipients || '')
          }
          recipientDetails={
            templateModalSource === 'retryMessage'
              ? (selectedNode?.data?.validation?.retryMessageConfig?.recipientDetails || null)
              : templateModalSource === 'overdue'
              ? (selectedNode?.data?.overdueConfig?.escalationConfig?.recipientDetails || null)
              : (selectedNode?.data?.validation?.escalationConfig?.recipientDetails || null)
          }
          allowMultiple
          workflowDefinitionId={workflowId}
          t={t}
        />
      </Drawer>
    </>
  );
};

export default NodePropertyDrawer;
